/* eslint-disable */
'use strict';
import _, { isFunction } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { nanoid as nanoid }  from 'nanoid';
import { newId as uuid } from 'uuid-pure';
import CancelIcon from '@iconify-icons/material-symbols/cancel-outline'
import AddIcon from '@iconify-icons/material-symbols/add-circle-outline'
import { Icon } from '@iconify-icon/react'

import { RemoveBtn, AddBtn } from './IconButton'
import { LOCALES, POSTAL, OPTIONS } from '../../../constants/';
import { LocalStorage as ls } from './Cache';
import { Loading, TipButton } from './Control';
import { Box, Tip } from './Dialogs';
import { HAComponent } from './Generic';
import { AdvCriteriaDescriptor, AdvCriteriaBox } from './Grids';
import { MobileContext } from './Context'
import { I18n } from './I18n'
import { classnames } from './Utils';
import { VirtualListBasic } from './VirtualList'

class ReactInput extends HAComponent {
	static version = '1.0.5';
	static propTypes = {
		placeholder: PropTypes.string,
		validate: PropTypes.object,
		errorMsg: PropTypes.object,
		tip: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		disable: PropTypes.bool,
		readOnly: PropTypes.bool,
		onUpdate: PropTypes.func,
		onEditing: PropTypes.func,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func,
		onError: PropTypes.func,
		onMenuClose: PropTypes.func,
	};
	static defaultProps = {
		data: undefined,
		value: undefined,
		tip: false,
		disable: undefined,
		readOnly: undefined,
	};
	state = {
		enable: true,
		editable: true,
		hover: false,
		focus: false,
		value: undefined,
		fieldValue: '',
		error: false,
	};

	constructor(props) {
		super(props);
		this.focus = this.focus.bind(this);
		this.blur = this.blur.bind(this);

		const { value, validate } = this.props;
		if (!_.isNil(value)) this.state._value = this.state.value = value;
		if (!_.isNil(validate)) this.state._validate = validate;
	}

	static getDerivedStateFromProps(props, state) {
		const { disable, readOnly, focus, value, validate, error } = props;
		const { _disable, enable, _readOnly, editable, _focus, _value, _validate, _error } = state;
		let s = null;
		if (disable !== _disable) {
			if (!s) s = {};
			s._disable = disable;
			s.enable = !disable;
			s.error = false;
		}
		if (readOnly !== _readOnly) {
			if (!s) s = {};
			s._readOnly = readOnly;
			s.editable = !readOnly;
			s.error = false;
		}
		if (focus !== _focus) {
			if (!s) s = {};
			s._focus = focus;
			s.focus = focus;
			if (focus) s.error = false;
		}
		if (error !== _error) {
			if (!s) s = {};
			s._error = error;
			s.error = error;
		}

		if ((enable || !disable) && (editable || !readOnly) && !_.isNil(value) && !(value == _value || _.isEqual(value, _value))) {
			if (!s) s = {};
			s._preValue = value;
			s._value = value;
			s.fieldValue = value;
			s.value = _.isObject(value) ? _.cloneDeep(value) : value;
		}
		if (enable && editable && !_.isNil(validate) && !(validate == _validate || _.isEqual(validate, _validate))) {
			if (!s) s = {};
			s._validate = validate;
			s.error = false;
			s._reValid = true;
		}
		return s;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { _reValid: rv, value } = this.state;
		if (rv) {
			if (!_.isNil(value)) this.validate();
			this.state._reValid = false;
		}
	}

	reset(cb) {
		if (!this._mounted) return false;
		const { enable, editable } = this.state;
		if (!enable || !editable) return false;
		this.setState({ error: false }, cb);
		return this;
	}

	$getValidateRules() {
		return this.props.validate || {};
	}

	validate() {
		if (!this._mounted) return true;
		const { enable, editable, error } = this.state;
		if (!enable || !editable) {
			if (error) this.setState({ error: false });
			return true;
		}
		const rules = this.$getValidateRules();
		if (!rules) {
			if (error) this.setState({ error: false });
			return true;
		}
		// TODO: common validate ... ??
	}

	isEnable() { return this.state.enable; }

	enable(cb) {
		if (!this._mounted) return false;
		if (this.state.enable) return this;
		this.setState({ enable: true }, cb && this.validate() ? cb : null);
		return this;
	}

	disable(cb) {
		if (!this._mounted) return;
		if (!this.state.enable) return this;
		this.setState({ enable: false, hover: false, focus: false, error: false }, cb);
		return this;
	}

	isEditable() { return this.state.editable; }

	editable(cb) {
		if (!this._mounted) return false;
		if (this.state.editable) return this;
		this.setState({ editable: true }, cb);
		return this;
	}

	readOnly(cb) {
		if (!this._mounted) return false;
		if (!this.state.editable) return this;
		this.setState({ editable: false, hover: false, focus: false, error: false }, cb);
		return this;
	}

	isFocus() {return this.state.focus;}

	focus(cb) {
		if (!this._mounted) return false;
		const { enable, editable } = this.state;
		if (!enable || !editable) return;

		this.setState({ focus: true, error: false }, cb);
		const { onFocus } = this.props;
		_.isFunction(onFocus) ? onFocus(this) : null;
		return this;
	}

	blur(cb) {
		if (!this._mounted) return false;
		const { enable, editable } = this.state;
		if (!enable || !editable) return;

		this.setState({ focus: false }, cb);
		const { onBlur } = this.props;
		_.isFunction(onBlur) ? onBlur(this) : null;
		return this;
	}

	getValue() {
		const { enable, error, value } = this.state;
		return !enable || error ? undefined : value;
	}

	setValue(value, cb) {
		return this;
	}

	isError() {
		return this.state.error ? true : false;
	}

	setError(msg) {
		if (!this._mounted) return false;
		this.setState({ error: msg });
	}

	clearError() {
		if (!this._mounted) return false;
		this.setState({ error: false });
	}
}

class Text extends ReactInput {
	static version = '0.6.4';
	static propTypes = {
		...ReactInput.propTypes,
		line: PropTypes.number,
		indicator: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		onEnter: PropTypes.func,
		isPicker: PropTypes.bool,
	};
	static defaultProps = {
		...ReactInput.defaultProps,
		line: 1,
		isPicker: false,
		//indicator: '<%=count%> / <%=max%>', 	// false or String(variable:<%=count%>, <%=max%>)
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		max: OptionUtils.getLabel('components.Input', 'upToWords'),
		min: OptionUtils.getLabel('components.Input', 'minimumWords'),
		regexp: OptionUtils.getLabel('components.Input', 'theFormatDoesNotConform'),
		'pattern-email': OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectEmailFormat'),
		'pattern-date': OptionUtils.getLabel('components.Input', 'pleaseEnterDateFormatYYYYMMDD'),
		'pattern-time': OptionUtils.getLabel('components.Input', 'pleaseEnterTimeFormathhmm'),
		'pattern-year': OptionUtils.getLabel('components.Input', 'pleaseEnterADFormatYYYY'),
		'pattern-yearMonth': OptionUtils.getLabel('components.Input', 'pleaseEnterTheFormatOfAD'),
		'pattern-monthDay': OptionUtils.getLabel('components.Input', 'pleaseEnterTheFormatOfThe'),
		'pattern-datetime': OptionUtils.getLabel('components.Input', 'pleaseEnterTheDateTimeFormat'),
		'pattern-dateRange': OptionUtils.getLabel('components.Input', 'pleaseEnterTheDateRangeYYYYMMDD'),
		'pattern-cellphone': OptionUtils.getLabel('components.Input', 'pleaseEnterTheMobilePhoneNumber'),
		'pattern-tel': OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectPhoneNumber'),
		'pattern-tel-ext': OptionUtils.getLabel('components.Input', 'pleaseEnterTheExtensionFormatFor'),
		'pattern-telOrCellphone': OptionUtils.getLabel('components.Input', 'pleaseEnterAPhoneOrMobile'),
		'pattern-sno': OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectUniformNumbering'),
		'pattern-IPv4': OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectIPvFormat'),
		'pattern-IPv6': OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectIPv6Format'),
	};
	static PATTERN = {
		email: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/i,
		date: /^[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[1-2][0-9]|3[0-1])$/i,
		time: /^(2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$/i,
		year: /^[0-9]{4}$/i,
		yearMonth: /^[0-9]{4}\/([1-9]|0[1-9]|1[0-2])$/i,
		monthDay: /^(?:0?[13578]|1[02])\/(?:0?[1-9]|[12]\d|3[01])$|^(?:0?[469]|11)\/(?:0?[1-9]|[12]\d|30)$|^0?2\/(?:0?[1-9]|[12]\d)$/,
		datetime: /^[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$/i,
		dateRange: /^[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[1-2][0-9]|3[0-1])( |)(-|~|to|)( |)[0-9]{4}\/([1-9]|0[1-9]|1[0-2])\/([1-9]|0[1-9]|[1-2][0-9]|3[0-1])$/i,
		cellphone: /^09[0-9]{2}(-| |)[0-9]{6}$/i,
		tel: /^(0([2-8]|37|49|82|89|836)(-| |)|\(0([2-8]|37|49|82|89|836)\)( |))[0-9]{6,8}$/i,
		'tel-ext': /^[0-9]{2,6}$/i,
		number: /^[0-9]{0,}$/,
		sno: /^[0-9]{8}$/i,
		IPv4: /^(25([0-5])|(2[0-4]|1\d|[1-9])?(\d)|\*)(\.(25([0-5])|(2[0-4]|1\d|[1-9])?(\d)|\*)){3}$/,
		IPv6: /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/,
		password: /^[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|]+$/,
	};

	constructor(props) {
		super(props);

		const { value, initValue, onUpdate } = this.props;
		if (!_.isNil(initValue)) {
			const checked = this._chkSetValue(initValue);
			if (checked) {
				const { value, fieldValue } = checked;
				this._init = this.state.value = this.state._value = this.state._preValue = value;
				this.state.fieldValue = fieldValue;
			}
		}
		if (!_.isNil(value)) {
			const checked = this._chkSetValue(value);
			if (checked) {
				const { value, fieldValue } = checked;
				this.state.value = this.state._value = this.state._preValue = value;
				this.state.fieldValue = fieldValue;
			}
		}
		this._keyUp = this._keyUp.bind(this);
		this._keyDown = this._keyDown.bind(this);
		// 會形成閉包丟失props資料
		// if(onUpdate && _.isFunction(onUpdate)) this._onUpdate = onUpdate.bind(this);
		this._onUpdate = this._onUpdate.bind(this);
		this.$onMenuClose = this.$onMenuClose.bind(this);
		this.isOnComposition = false;
		this.isCancelEnter = false;
		this.isFirstAutoFill = true;
		this.isKeyDown = false;
	}

	_keyUp(evt) {
		const { line, onEnter, onEditing } = this.props;
		const key = evt.key;
		if (line === 1 && key === 'Enter' && this.isCancelEnter) {
			return this.isCancelEnter = false
		}
		if (line === 1 && key === 'Enter') {
			return this.blur(() => !this.state.error && _.isFunction(onEnter) ? onEnter() : null);
		}

		const v = this._dom.field.value;
		if (_.isFunction(onEditing)) onEditing(v);
	}

	_onUpdate(...params) {
		const { onUpdate } = this.props;
		if(onUpdate && _.isFunction(onUpdate)) onUpdate(...params);
	}

	_keyDown(evt) {
		this.isKeyDown = false;
		const { enable, editable } = this.state;
		if (evt.key === 'Enter' && this.isOnComposition) {
			this.isCancelEnter = true
		}
		if (!enable || !editable) return evt.preventDefault();
	}

	reset() {
		if (!super.reset()) return false;
		const { value, fieldValue } = this._chkSetValue(this._init) || { value: '', fieldValue: '' };
		this.setState({
			value,
			_preValue: value,
			fieldValue,
			focus: false,
		});

		return this;
	}

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();

		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		const msg = this.props.errorMsg || Text.ERROR;
		const { required, max, min, regexp, pattern } = rules;
		if (required && length === 0) return msg.required;

		if (!_.isNil(min) && min > length) return _.template(msg.min)({ min: min });
		if (!_.isNil(max) && max < length) return _.template(msg.max)({ max: max });
		const _regexp = new RegExp(regexp);
		if (length > 0 && regexp && !value.test(_regexp)) return _.template(msg.regexp)();
		if (length > 0 && pattern) {
			if (_.isString(pattern) && Text.PATTERN[pattern] && !value.test(Text.PATTERN[pattern]))
				return _.template(msg.pattern || Text.ERROR['pattern-' + pattern])();
			else if (_.isArray(pattern) && !_.some(pattern, p => value.test(Text.PATTERN[p])))
				return _.template(msg.pattern || Text.ERROR.regexp)();
		}
		return true;
	}

	validate() {
		if (super.validate()) return true;

		const success = this._validate();
		if (success !== true) {
			const { onError } = this.props;
			// 會加 _preValue: undefined 是因為 RDate 的 validate: { required: true } 時，直接編輯把內容清掉，再用小日曆選日期會無法選擇
			this.setState({ error: success, _preValue: undefined }, () => _.isFunction(onError) ? onError(success, this) : null);
			return false;
		} else {
			if (this.state.error) this.setState({ error: false });
			return true;
		}
	}

	focus(cb) {
		return super.focus(() => {
			this._dom.field.focus();
			_.isFunction(cb) ? cb() : null;
		});
	}

	/**
	 * 拉平 fieldValue, value
	 * 目的: 日期輸入 20200101 要能自動變成 2020/01/01 之類的。
	 * @return {{value: string | undefined, fieldValue: string}}
	 */
	alignValues() {
		const { line } = this.props;
		let fieldValue = this._dom.field.value;
		if (line <= 1) fieldValue = fieldValue.trim();
		return {
			value: !_.isEmpty(fieldValue) && fieldValue || '', // Text 類型應改回空字串，這樣才能讓 Forming 收集到
			                                                   // 其他 Type 應該也有相同問題，但以現在 api 層使用 validate 的方式...
			fieldValue,
		};
	}

	insertTag(tag) {
		this.focus(() => {
			// IE
			if (document.selection) {
				document.selection.createRange().text = tag;
				this.setValue(this._dom.field.value);
			}
			// other
			else {
				const field = document.activeElement || this._dom.field;
				const { selectionStart, selectionEnd } = field;
				if (field.setRangeText) {
					field.setRangeText(tag, selectionStart, selectionEnd, 'end');
					// this.setValue(field.value);
				} else {
					const newVal = selectionStart || selectionStart == '0'
						? `${field.value.slice(0, selectionStart)}${tag}${field.value.slice(selectionEnd)}`
						: field.value + tag;
					this.setValue(newVal);
				}
			}
		});
	}

	blur(cb) {
		const { enable, editable, value: _value, fieldValue: _fieldValue } = this.state;
		if (!enable || !editable) return;

		this._dom.field.blur();

		// 拉平後才 blur
		const { value, fieldValue } = this.alignValues() || { value: '', fieldValue: '' };

		const doBlur = () => {
			const validated = this.validate();
			if (!validated && this.state.focus) return this.setState({ focus: false }, cb);
			super.blur(() => {
				if (_.isFunction(cb)) cb();
				const _pre = this.state._preValue;
				if ((_.isNil(value) || value === '') && (_.isNil(_pre) || _pre === '')) return;
				if (value == _pre || _.isEqual(value, _pre)) return;

				if (_.isFunction(this._onUpdate)) this._onUpdate(value, _pre, this);
				this.setState({ _preValue: value });
			});
		};

		if (this.props.theme === 'password') {
			return doBlur();
		}
		if (value !== _value || fieldValue !== _fieldValue) {
			this.setState({ value, fieldValue }, doBlur);
		} else {
			doBlur();
		}
	}

	replacePassword(value) {
		if (this.props.theme === 'password') {
			const rule = /[a-z_A-Z0-9-\.!@#\$%\\\^&\*\)\(\+=\{\}\[\]\/",'<>~\·`\?:;|]/g
			const fieldValue = value.match(rule)?.join('') || ''
			this.setState({ fieldValue, value: fieldValue })
		}
	}

	getValue() {
		const { enable, error, focus, value } = this.state;
		if (!enable || error || focus) return undefined;
		return value;
	}

	_chkSetValue(value) {
		value = _.isNil(value) ? '' : (value + '').trim();
		if (this._validate(value) !== true) return false;
		return {
			value: !_.isEmpty(value) && value || '', // Text 類型應改回空字串，這樣才能讓 Forming 收集到
													 // 其他 Type 應該也有相同問題，但以現在 api 層使用 validate 的方式...
			fieldValue: value,
		};
	}

	setValue(v, cb) {
		const checked = this._chkSetValue(v);
		if (!checked) return false;
		const { value, fieldValue } = checked;
		const { value: currValue } = this.state;
		if (_.isEqual(value, currValue)) return false;
		this.setState({
			value,
			_preValue: value,
			fieldValue,
			error: false,
		});
		return this;
	}

	getText() {
		return this._dom.field.value;
	}

	$renderPickerBody() {}

	$onMenuClose(evt) {
		const { onMenuClose } = this.props;
		if (_.isFunction(onMenuClose)) onMenuClose(evt, this);
		else this.blur();
	}

	$isOpenMenu() {return true;}

	handleComposition(e) {
		if (e.type === "compositionstart") {
			this.isOnComposition = true;
		} else if (e.type === "compositionend") {
			this.isOnComposition = false;
			this.replacePassword(e.target.value)
		}
	}

	renderPrefix({ className, ico, text, width, theme, onClick }) {
		const { renderPrefix } = this.props;
		return _.isFunction(renderPrefix) ? renderPrefix() : <span {...{
			ref: ele => this._dom.prefix = ele,
			className: `-prefix ${theme ? theme : ''} ${className ? className : ''}`,
			...width ? { style: { width } } : null,
			...onClick ? { onClick } : null,
		}}>{ico && <i className={`fa fa-sm fa-${ico}`} />} {text}</span>;
	}

	renderSuffix({ className, ico, text, width, theme, onClick }) {
		const { renderSuffix } = this.props;
		return _.isFunction(renderSuffix) ? renderSuffix() : <span {...{
			ref: ele => this._dom.suffix = ele,
			className: `-suffix ${theme ? theme : ''} ${className ? className : ''}`,
			...width ? { style: { width: width } } : null,
			...onClick ? { onClick } : null,
		}}>{ico && <i className={`fa fa-sm fa-${ico}`} />} {text}</span>;
	}

	render() {
		const {
			className, style,
			placeholder, width, indicator, line,
			tip, theme, menuProps,
			prefix, suffix, isPicker, onClick, onMouseEnter, onMouseLeave, autoComplete
		} = this.props;
		const { focus, error, enable, editable, hover, fieldValue } = this.state;

		const _renderIndicator = () => {
			const rules = this.$getValidateRules();
			if (indicator === false || _.isEmpty(fieldValue) || !rules || !rules.max) return null;

			const length = fieldValue.length;
			if (length === 0) return null;

			const illegal = rules && ((rules.max && length > rules.max) /*|| (rules.min && length < rules.min)*/);
			return <span className={`-indicator ${illegal ? 'err' : ''}`}>{
				_.isString(indicator) ? _.template(indicator)({ count: length, max: (rules.max || '?') }) : length
			}</span>;
		};
		const Input = line === 1 ? 'input' : 'textarea';
		return <div {...{
			ref: ele => this._dom.root = ele,
			className: (() => {
				let css = `H2-Text`;
				css += theme ? ` ${theme}` : '';
				css += className ? ` ${className}` : '';
				css += focus ? ` focus` : '';
				css += error ? ` error` : '';
				css += enable ? '' : ' disable';
				css += editable ? '' : ' readOnly';
				return css;
			})(),
			style: {
				...style ? style : null,
				...width ? { width } : null,
				// ... maxWidth ? { maxWidth, width: 'auto' } : null,
				// ... minWidth ? { minWidth, width: 'auto' } : null,
			},
			...enable && editable ? (
				onClick ? { onClick } : {
					onClick: evt => {
						evt.stopPropagation();
						if (!this.state.focus)
							this.setState({ focus: true, error: false }, () => this._dom.field.focus());
					},
				}
			) : null,
			...tip || error ? {
				onMouseEnter: evt => {
					if (!enable || !editable) return;
					this.setState({ hover: true }, () => () => _.isFunction(onMouseEnter) ? onMouseEnter(evt) : null);
				},
				onMouseLeave: evt => {
					if (!enable || !editable) return;
					this.setState({ hover: false }, () => _.isFunction(onMouseLeave) ? onMouseLeave(evt) : null);
				},
			} : null,
		}}>
			{prefix ? this.renderPrefix(prefix) : null}
			<div className={'-inputWrapper'}>
				<Input {...{
					ref: ele => this._dom.field = ele,
					type: 'text',
					...!enable ? { disabled: true } : null,
					...!editable ? { readOnly: true } : null,
					// style: { imeMode: 'disabled' },
					className: '-field',
					placeholder: placeholder,
					...line > 1 ? { rows: line } : null,
					value: fieldValue,
					onFocus: evt => {
						if (!enable || !editable) return this._dom.field.blur();
						else this.focus(this.props.onFocus);
					},
					onBlur: evt => !isPicker && this.blur(),
					onKeyUp: this._keyUp,
					onKeyDown: this._keyDown,
					// onChange: evt => this.setState({ fieldValue: evt.target.value }),
					onCompositionStart: (e) => this.handleComposition(e),
          			onCompositionEnd: (e) => this.handleComposition(e),
					onChange: evt => {
						const value = evt.target.value;

						if (this.props.theme === 'password') {
							if (this.isOnComposition) {
								this.setState({ fieldValue: value, value })
							} else {
								const valid = Text.PATTERN['password'].test(value)
								if (value === '' || valid) {
									this.setState({ fieldValue: value, value })
								}
							}
						} else {
							this.setState({ fieldValue: value })
						}
						// firefox 密碼儲存初次載入
						const isFirefox = navigator.userAgent.toLowerCase().includes('firefox')
						if (isFirefox && this.isFirstAutoFill && !this.isKeyDown) {
							this.setState({ value });
							this.blur();
							this.isFirstAutoFill = false;
						}
					},
					autoComplete,
				}} />
				<span ref={ele => this._dom.infoContainer = ele} className={'-infoContainer'}>
					{error ? <i className={'-err color-red fa fa-sm fa-exclamation-circle'} /> : null}
					{enable && !editable ? <i className={'-lock color-gray fa fa-sm fa-lock-alt'} /> : null}
					{enable && editable ? _renderIndicator() : null}
				</span>
			</div>
			{
				error && hover ? <Tip {...{
						stick: this._dom.root,
						stickDirection: 'top',
						stickAlign: 1,
						pointerStyle: { right: 20, left: 'unset' },
						theme: 'validate',
					}}>{error}</Tip> :
					hover && tip && this._dom.field.value ? <Tip {...{
						stick: this._dom.root,
						stickDirection: 'top',
						stickAlign: -1,
					}}>{tip}</Tip> : null
			}
			{suffix ? this.renderSuffix(suffix) : null}
			{enable && editable && focus && isPicker && this.$isOpenMenu() ? <Box {...{
				ref: ele => this._dom.picker = ele,
				stick: this._dom.field,
				stickDirection: 'ver',
				stickAlign: -1,
				//stickOffset: {y: 10, x:-20},
				theme: 'pickerMenu',
				close: evt => this.$onMenuClose(evt),
				clickExcludes: this._dom.root,
				isRDate: true,
				...menuProps,
			}}>{this.$renderPickerBody()}</Box> : null}
		</div>;
	}
}

class TextRange extends ReactInput {
	static version = '0.7.0';
	static propTypes = {
		...ReactInput.propTypes,
		infinity: PropTypes.oneOf(['none', 'left', 'right', 'both']),
		placeholder: PropTypes.array,
		autoSwitch: PropTypes.bool,
		checkOrder: PropTypes.bool,
		isSuffix: PropTypes.bool,
	};
	static defaultProps = {
		...ReactInput.defaultProps,
		infinity: 'both',
		placeholder: [OptionUtils.getLabel('components.Input', 'rise'), OptionUtils.getLabel('components.Input', 'apocalypse')],
		autoSwitch: false, // 不要再把這個打開了，PM 沒這個需求，還會造成日曆元件類手動輸入直接送出的時間差問題
		checkOrder: false, // 是否檢查起始值不能大於結束值 (原本沒檢查這項，所以預設為 false)
		isSuffix: true,
		inputTheme: 'empty',
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		startRequired: OptionUtils.getLabel('components.Input', 'aStartingValueIsRequired'),
		endRequired: OptionUtils.getLabel('components.Input', 'anEndValueIsRequired'),
		startOutOfMin: OptionUtils.getLabel('components.Input', 'theStartingValueCannotBeLess'),
		startOutOfMax: OptionUtils.getLabel('components.Input', 'theStartingValueCannotBeGreater'),
		endOutOfMin: OptionUtils.getLabel('components.Input', 'theEndValueCannotBeLess'),
		endOutOfMax: OptionUtils.getLabel('components.Input', 'theEndValueCannotBeGreater'),
		startAfterEnd: OptionUtils.getLabel('components.Input', 'theStartValueCannotBeGreater'),
	};
	state = {
		...this.state,
		value: [undefined, undefined],
		_preValue: [undefined, undefined],
	};
	_init = [undefined, undefined];
	_onBlur = i => setTimeout(() => {
		if (this._dom[`field${i === 0 ? 1 : 0}`].isFocus() || !this.validate()) return;
		const { value: v, _preValue: pre } = this.state;
		if (!_.isEqual(v, pre)) {
			const { onUpdate } = this.props;
			if (_.isFunction(onUpdate)) onUpdate(v, pre, this);
			this.state._preValue = _.cloneDeep(v);
		}
		this.setState({ focus: false });
	}, 0);

	constructor(props) {
		super(props);
		this.$init();
	}

	$init() {
		const { value, initValue, onUpdate } = this.props;
		if (_.isArray(initValue) && initValue.length > 1 && this._validate(initValue[0], initValue[1]) === true) {
			this._init = _.cloneDeep(initValue);
			this.state.value = _.cloneDeep(initValue);
			this.state._preValue = _.cloneDeep(initValue);
		}

		if (_.isArray(value) && value.length > 1 && this._validate(value[0], value[1]) === true) {
			this.state.value = _.cloneDeep(value);
			this.state._preValue = _.cloneDeep(value);
		}

		// if (onUpdate && _.isFunction(onUpdate)) this._onUpdate = onUpdate;
	}

	_onUpdate(...params) {
		if (_.isFunction(this.props.onUpdate)){
			this.props.onUpdate(...params);
		}
	}

	reset() {
		if (!super.reset()) return false;
		const { field0: f0, field1: f1 } = this._dom;
		if (f0) f0.reset();
		if (f1) f1.reset();
		this.state._preValue = _.clone(this._init);
		this.state.value = _.clone(this._init);
		this.state.error = false;
		this.state.focus = false;
		this.forceUpdate();
		return this;
	}

	$getValidateRules() {
		return {
			required: false,
			infinity: this.props.infinity || 'both',
			...this.props.validate,
		};
	}

	$transferMaxMin(str) { return str; }

	_validate(v0 = this.state.value[0], v1 = this.state.value[1]) {
		const msg = {
			...Text.ERROR,
			...TextRange.ERROR,
			...this.props.errorMsg,
		};
		const { required, max, min, infinity, regexp, pattern } = this.$getValidateRules();
		const { root, field0: f0, field1: f1 } = this._dom;

		const noLeft = _.isEmpty(v0);
		const noRight = _.isEmpty(v1);
		if (!required && noLeft && noRight)
			// 非必填，而且左右都沒填的話，不用檢查任何東西
			return true;
		else {
			if (required && noLeft && noRight) {
				// 必填，而且全都沒填的話，顯示必填提示
				if (root) this.state.errorTarget = root;
				return msg.required;
			}
			if (noLeft && (infinity === 'right' || infinity === 'none')) {
				// 左邊該填卻沒填，顯示左邊必填提示
				if (f0) this.state.errorTarget = f0._dom.root;
				return msg.startRequired;
			}
			if (noRight && (infinity === 'left' || infinity === 'none')) {
				// 右邊該填卻沒填，顯示右邊必填提示
				if (f1) this.state.errorTarget = f1._dom.root;
				return msg.endRequired;
			}
		}

		if (!noLeft) {
			if (f0) this.state.errorTarget = f0._dom.root;
			if (!_.isNil(min) && v0 < min) return _.template(msg.startOutOfMin)({ min: this.$transferMaxMin(min) });
			if (!_.isNil(max) && v0 > max) return _.template(msg.startOutOfMax)({ max: this.$transferMaxMin(max) });
		}
		if (!noRight) {
			if (f1) this.state.errorTarget = f1._dom.root;
			if (!_.isNil(min) && v1 < min) return _.template(msg.endOutOfMin)({ min: this.$transferMaxMin(min) });
			if (!_.isNil(max) && v1 > max) return _.template(msg.endOutOfMax)({ max: this.$transferMaxMin(max) });
		}
		if (!noLeft) {
			if (f0) this.state.errorTarget = f0._dom.root;
			if (regexp && !v0.test(regexp)) return _.template(msg.regexp)();
			if (_.isString(pattern) && Text.PATTERN[pattern] && !v0.test(Text.PATTERN[pattern]))
				return _.template(msg.pattern || Text.ERROR['pattern-' + pattern])();
		}
		if (!noRight) {
			if (f1) this.state.errorTarget = f1._dom.root;
			if (regexp && !v1.test(regexp)) return _.template(msg.regexp)();
			if (_.isString(pattern) && Text.PATTERN[pattern] && !v1.test(Text.PATTERN[pattern]))
				return _.template(msg.pattern || Text.ERROR['pattern-' + pattern])();
		}

		if (!_.isEmpty(v0) && !_.isEmpty(v1) && v0 > v1) {
			if (this.props.autoSwitch) this.state.value = [v1, v0];
			else if (this.props.checkOrder) return msg.startAfterEnd;
		}

		return true;
	}

	validate() {
		if (!this._mounted) return true;
		const { enable, editable, error } = this.state;
		if (!enable || !editable) {
			if (error) this.setState({ error: false });
			return true;
		}
		const rules = this.$getValidateRules();
		if (!rules) {
			if (error) this.setState({ error: false });
			return true;
		}

		const validated = this._validate();
		const domValidate = this._dom.field0.validate() && this._dom.field1.validate();

		if (validated !== true || domValidate !== true) {
			const msg = validated === false ? 'error' : validated;
			const { onError } = this.props;
			this.setState({ error: msg }, () => _.isFunction(onError) ? onError(msg, this) : null);
			return false;
		} else {
			if (this.state.error) this.setState({ error: false });
			return true;
		}
	}

	getValue(type) {
		const { enable, error } = this.state;
		if (!enable || error) return this._init;

		return this.state.value;
	}

	setValue(value, cb) {
		const { enable, editable } = this.state;
		if (!enable || !editable) return false;

		if (this._validate(value[0], value[1]) === true) {
			// const {field0:f0, field1:f1} = this._dom;
			// if(f0) f0.setValue(value[0]);
			// if(f1) f1.setValue(value[1]);
			this.setState({ value: _.cloneDeep(value) });
		}
		return this;
	}

	getText() {
		const { field0: f0, field1: f1 } = this._dom;
		return [f0 ? f0.getText() : undefined, f1 ? f1.getText() : undefined];
	}

	$renderInput(i = 0) {
		const { _init } = this;
		const { inputClassName, inputTheme, placeholder, disable, readOnly, className } = this.props;
		const { value } = this.state;

		return <Text {...{
			key: `${value[0]}:${value[1]}:${i}`,
			ref: ele => this._dom[`field${i}`] = ele,
			disable, readOnly,
			className: inputClassName + (_.includes(className, 'sm') ? ' sm' : '') + (_.includes(className, 'lg') ? ' lg' : ''),
			theme: inputTheme,
			placeholder: placeholder && placeholder[i],
			tip: false,
			..._init[i] ? { initValue: _init[i] } : null,
			value: value[i] || '',
			onClick: evt => {
			}, // DO nothing!
			onUpdate: v => {
				const newValue = [...value];
				newValue[i] = v;
				this.setState({ value: newValue }, () => {
					const { field0: f0, field1: f1 } = this._dom;
					if (this.state.hover) {
						if (i === 0) {
							f1.focus();
						} else {
							f0.focus();
						}
					}
				});
			},
			onBlur: this._onBlur.bind(this, i),
		}} />;
	}

	$renderSuffix() {
		return null;
	}

	render() {
		const { className, style, width, tip, isSuffix } = this.props;
		const { focus, error, errorTarget, enable, editable, hover, value } = this.state;

		return <div {...{
			ref: ele => this._dom.root = ele,
			className: (() => {
				let css = `H2-TextRange`;
				css += focus ? ' focus' : '';
				css += error ? ' error' : '';
				css += enable ? '' : ' disable';
				css += editable ? '' : ' readOnly';
				css += className ? ` ${className}` : '';
				return css;
			})(),
			style: {
				...style ? style : null,
				...width ? { width } : null,
			},
			// ... tip || error ? {
			onMouseEnter: evt => {
				if (!enable || !editable || hover) return;
				this.setState({ hover: true }, () => {
					if (this.props.onMouseEnter) this.props.onMouseEnter();
				});
			},
			onMouseLeave: evt => {
				if (!enable || !editable || !hover) return;
				this.setState({ hover: false }, () => {
					if (this.props.onMouseLeave) this.props.onMouseLeave();
				});
			},
			// } : null,
			// ...enable && editable ? {
			// 	onClick: evt => {
			// 		this.setState({ focus: true, error: false }, () => {
			// 			const { field0: f0, field1: f1 } = this._dom;
			// 			if (f0 && !f0.isFocus() && f1 && !f1.isFocus()) f0.focus();
			// 		});
			// 	},
			// } : null,
		}}>
			{this.$renderInput(0)}
			<i className={'fal fa-minus'} />
			{this.$renderInput(1)}
			{/* {isSuffix && this.$renderSuffix()} */}
			{_.isString(error) && hover ? <Tip {...{
				key: error,
				stick: errorTarget || this._dom.root,
				stickDirection: 'top',
				stickAlign: 0,
				theme: 'validate',
			}}>{error}</Tip> : null}
			<MobileContext.Consumer>
				{isMobile => (isMobile || hover) && value && !(_.isNil(value[0]) && _.isNil(value[1])) && <i {...{
					className: '-remover btn btn-sm square btn-danger fa fa-trash-alt',
					onClick: evt => {
						if (!enable || !editable) return;
						evt.stopPropagation();
						this.state._preValue = [undefined, undefined];
						this.state.value = [undefined, undefined];
						this.state.errorTarget = undefined;
						this.state.error = undefined;
						const { field0: f0, field1: f1 } = this._dom;
						if (f0) f0.reset();
						if (f1) f1.reset();
						this.forceUpdate(() => {
							if (this._onUpdate)
								this._onUpdate(this.state.value, this.state._preValue, this);
						});
					},
				}} />}
			</MobileContext.Consumer>
		</div>;
	}
}

const alphaVal = ['BNZ', 'AMW', 'KLY', 'JVX', 'HU', 'GT', 'FS', 'ER', 'DOQ', 'CIP'].reduce((prev, curr, i) => {
	[...curr].forEach(c => prev[c] = i);
	return prev;
}, {});

class TWIDText extends Text {
	static version = '0.0.2';
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		format: OptionUtils.getLabel('components.Input', 'pleaseEnterTheCorrectIDNumber'),
	};

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();

		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		const msg = this.props.errorMsg || TWIDText.ERROR;
		const { required } = rules;
		if (!required && length === 0) return true;
		if (required && length === 0) return msg.required;

		if (!Utils.Format.checkIdcNo(value)) return msg.format;

		const result = [...value].reduce((prev, curr, i) => {
			return prev += i ? (Math.max(9 - i, 1) * curr) : alphaVal[curr];
		}, 0);
		if (result % 10 || !+value.charAt(1)) return msg.format;

		// 這邊做 setState 的話，在一開始就使用 props 給 value 或 initValue 時，會引發 React 的 warning
		// `Can't call setState on a component that is not yet mounted.`
		// (觸發點是 Text 的 constructor)
		//this.setState({value: value});
		return true;
	}
}

class AlienIDText extends Text {
	static version = '0.0.2';
	static ERROR = {
		required: '必填欄位',
		format: '請輸入正確的外籍統一證號',
	};

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();

		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		const msg = this.props.errorMsg || AlienIDText.ERROR;
		const { required } = rules;
		if (!required && length === 0) return true;
		if (required && length === 0) return msg.required;

		if (!Utils.Format.checkAlienIdc(value)) return msg.format;
		//2020/08 chloe : 未來規則會改, 先判斷基本的
		// const sexVal = {A: 0, B: 1, C: 2, D: 3};
		// const result = [... value].reduce((prev, curr, i) => {
		// 	return prev += (i > 1 ? (Math.max(9 - i, 1) * curr) : sexVal[curr] * 8) + alphaVal[curr];
		// }, 0);
		// if(result % 10 || !(sexVal[value.charAt(1)] % 2 + 1)) return msg.format;

		return true;
	}
}

class I18nText extends ReactInput {
	static version = '0.0.2';
	static propTypes = {
		readOnly: PropTypes.bool,
	};
	static defaultProps = {
		locales: ['zh_TW', 'en_US', 'zh_CN']
	}
	inputs = {};

	reset() {
		_.every(this.inputs, input => input.reset());
		return this;
	}

	validate() {
		let v = true;
		_.forEach(this.inputs, input => {
			v = input.validate() && v;
		});
		return v;
	}

	enable() {
		_.forEach(this.inputs, (input, code) => input.enable());
		return this;
	}

	disable() {
		_.forEach(this.inputs, (input, code) => input.disable());
		return this;
	}

	editable() {
		this.setState({ editable: true }, () => _.forEach(this.inputs, (input, code) => input.editable()));
		return this;
	}

	readOnly() {
		_.forEach(this.inputs, (input, code) => input.readOnly());
		this.setState({ editable: false });
		return this;
	}

	getValue() {
		return _.transform(this.inputs, (result, value, key) => result[key] = value.getValue());
	}

	setValue(v, fireEvent = true) {
		_.forEach(v, (value, code) => {
			if (this.inputs.hasOwnProperty(code))
				this.inputs[code].setValue(value, fireEvent);
		});
		return this;
	}

	render() {
		const locales = Object.keys(LOCALES).filter(key => this.props.locales.includes(key))
		const { placeholder } = this.props;
		return <>
			{
				locales.map((code, idx) => {
					let options = {
						key: code,
						ref: ele => {if (ele) this.inputs[code] = ele;},
						...this.props,
						style: { marginBottom: 3 },
						suffix: true,
						renderSuffix: () => <span {...{
							className: '-suffix light',
							style: { minWidth: 85 },
						}}>{LOCALES[code]}</span>,
						placeholder: typeof placeholder === 'object' ? placeholder[code] : placeholder
					};
					if (options.validate) {
						options.validate = _.clone(options.validate);
						if (options.validate.required !== false)
							options.validate.required = idx === 0;
					} else options.validate = { required: idx === 0 };
					return <Text key={idx} {...options} />;
				})
			}
		</>;
	}
}

class RNumber extends Text {
	static version = '1.0.2';
	static propTypes = {
		...Text.PropTypes,
		sign: PropTypes.bool,
		float: PropTypes.bool,
		precision: PropTypes.number,
		separator: PropTypes.bool, // 千分位
	};
	static defaultProps = {
		...Text.defaultProps,
		line: 1,
		indicator: false,
		sign: false,
		float: false,
		separator: false,
		precision: 2,
		roundType: 1, // 1: 四捨五入, 2: 無條件捨去, 3: 無條件進位
		theme: 'number',
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		format: OptionUtils.getLabel('components.Input', 'pleaseEnterANumericType'),
		max: OptionUtils.getLabel('components.Input', 'mustBeLessThan'),
		min: OptionUtils.getLabel('components.Input', 'mustBeGreaterThan'),
		unit: OptionUtils.getLabel('components.Input', 'mustBeAMultiple'),
	};

	constructor(props) {
		super(props);

		const f = this._onUpdate;
		if (_.isFunction(f))
			this._onUpdate = (v, pv) => f(_.isNil(v) || v === '' ? undefined : +v, _.isNil(pv) || v === '' ? undefined : +pv);
	}

	_keyDown(evt) {
		const { sign, float } = this.props;
		const { enable, editable } = this.state;
		const { key, ctrlKey, metaKey } = evt;
		if (!enable || !editable || evt.keyCode === 229) return evt.preventDefault();
		if ((ctrlKey || metaKey) && _.includes(['a', 'c', 'v', 'x'], key)) return;
		if ((key === '-' && !sign) || (key === '.' && !float)) return evt.preventDefault();
		if (!_.includes(['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '.',
			'Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Home', 'End'], key))
			return evt.preventDefault();
	}

	$getValidateRules() {
		return {
			...this.props.validate,
			line: 1,
			indicator: false,
		};
	}

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();
		const { required, max, min, unit } = rules;
		const msg = this.props.errorMsg || RNumber.ERROR;
		if (_.isString(value)) value = value.trim();
		if (required && (_.isNil(value) || value === '')) return msg.required;
		if (_.isNil(value) || value === '') return true;

		value = +value;
		if (!_.isNumber(value) || _.isNaN(value)) return msg.format;
		if (min > value) return _.template(msg.min)({ min: min });
		if (max < value) return _.template(msg.max)({ max: max });

		if (_.isNumber(unit) && unit !== 0 && !_.isNaN(unit) && !_.isInteger(value / unit)) return _.template(msg.unit)({ unit: unit });
		return true;
	}

	validate() {
		const success = super.validate();
		if (!success) return false;

		return true;
	}

	alignValues() {
		const fieldValue = this._dom.field.value.trim();
		if (_.isEmpty(fieldValue)) return { value: undefined, fieldValue: '' };

		const { float, precision, sign, roundType } = this.props;
		let num = +fieldValue;
		if (_.isNaN(num))
			return { value: undefined, fieldValue };
		const pr = Math.abs(precision) || 0;
		if (float && pr > 0) {
			if (roundType === 1) num = (num * (10).pow(pr)).round() / (10).pow(pr);
			if (roundType === 2) num = (num * (10).pow(pr)).floor() / (10).pow(pr);
			if (roundType === 3) num = (num * (10).pow(pr)).ceil() / (10).pow(pr);
		} else {
			if (roundType === 1) num = num.round();
			if (roundType === 2) num = num.floor();
			if (roundType === 3) num = num.ceil();
		}
		if (!sign) num = num.abs();
		return {
			value: num + '',
			fieldValue: num + '',
		};
	}

	getValue() {
		const v = super.getValue();
		return _.isNil(v) || _.isNaN(v) || (_.isString(v) && _.isEmpty(v)) ? undefined : +v;
	}

	render() {
		const { withBtn, onUpdate } = this.props

		if (withBtn) {
			return (
				<div className='H2-NumberWrapper btn-group flex-row'>
					<span
						className='btn square fal fa-minus'
						onClick={() => {
							const _v = this.getValue() || 0
							const newV = _v - 1;
							if (newV < 0) return;
							this.setValue(newV);
							if (this._validate(newV) === true && onUpdate) onUpdate(newV);
						}}
					/>
					{super.render()}
					<span
						className='btn square fal fa-plus'
						onClick={() => {
							const _v = this.getValue() || 0
							const newV = _v + 1;
							this.setValue(newV);
							if (this._validate(newV) === true && onUpdate) onUpdate(newV);
						}}
					/>
				</div>
			)
		}

		return super.render();
	}
}

class NumberRange extends TextRange {
	static version = '0.9.0';
	static propTypes = {
		...TextRange.PropTypes,
		sign: PropTypes.bool,
		float: PropTypes.bool,
		precision: PropTypes.number,
	};
	static defaultProps = {
		...TextRange.defaultProps,
		sign: false,
		float: false,
		precision: 2,
		autoSwitch: true, // PM 其實沒這個需求，還會造成日曆元件類手動輸入直接送出的時間差問題
	};
	static ERROR = {
		required: '必填欄位',
		startRequired: '需要最小值',
		endRequired: '需要最大值',
		startOutOfMin: '最小值不能小於 <%=min%>',
		startOutOfMax: '最小值不能大於 <%=max%>',
		endOutOfMin: '最大值不能小於 <%=min%>',
		endOutOfMax: '最大值不能大於 <%=max%>',
	};

	_validate(v0 = this.state.value[0], v1 = this.state.value[1]) {
		// if (v0 === '') v0 = Number.NaN;
		// if (v1 === '') v1 = Number.NaN;
		const msg = this.props.errorMsg || NumberRange.ERROR;
		const { required, max, min, infinity } = this.$getValidateRules();
		const { root, field0: f0, field1: f1 } = this._dom;
		if ((required || infinity === 'none') && _.isNaN(v0) && _.isNaN(v1)) {
			if (root) this.state.errorTarget = root;
			return msg.required;
		}
		if ((infinity === 'right' || infinity === 'none') && _.isNaN(v0)) {
			if (f0) this.state.errorTarget = f0._dom.root;
			return msg.startRequired;
		}
		if ((infinity === 'left' || infinity === 'none') && _.isNaN(v1)) {
			if (f1) this.state.errorTarget = f1._dom.root;
			return msg.endRequired;
		}
		if (_.isNumber(v0)) {
			if (f0) this.state.errorTarget = f0._dom.root;
			if (!_.isNil(min) && v0 < min) return _.template(msg.startOutOfMin)({ min });
			if (!_.isNil(max) && v0 > max) return _.template(msg.startOutOfMax)({ max });
		}
		if (_.isNumber(v1)) {
			if (f1) this.state.errorTarget = f1._dom.root;
			if (!_.isNil(min) && v1 < min) return _.template(msg.endOutOfMin)({ min });
			if (!_.isNil(max) && v1 > max) return _.template(msg.endOutOfMax)({ max });
		}
		if (_.isNumber(v0) && _.isNumber(v1) && v0 > v1) {
			this.state.value = [v1, v0];
			this._dom.field0?.setValue(v1);
			this._dom.field1?.setValue(v0);
		}
		return true;
	}

	$renderInput(i = 0) {
		const { _init } = this;
		const { placeholder, disable, readOnly, sign, float, precision } = this.props;
		const { value } = this.state;

		return <RNumber {...{
			ref: ele => this._dom[`field${i}`] = ele,
			disable, readOnly, sign, float, precision,
			theme: 'empty',
			placeholder: placeholder && placeholder[i],
			tip: false,
			...(_init[i] === undefined || _init[i] === null) ? null : { initValue: _init[i] },
			value: (value[i] === undefined || value[i] === null) ? '' : value[i],
			onClick: evt => {}, // DO nothing!
			onUpdate: v => this.state.value[i] = v,
			onBlur: this._onBlur.bind(this, i),
		}} />;
	}
}

class Password extends Text {
	static version = '0.0.1';
	static defaultProps = {
		...Text.defaultProps,
		theme: 'password',
		indicator: false,
		suffix: true,
		eye: true,
	};
	static ERROR = {
		required: '請輸入密碼',
		max: '密碼長度最多為 <%=max%>',
		min: '密碼長度至少為 <%=min%>',
		alphabet: '至少需要 <%=a%> 個字母',
		numeric: '至少需要 <%=n%> 個數字',
		special: '至少需要 <%=count%> 個特殊字元(<%=char%>)',
		denySpecial: '不可包含特殊字元',
	};
	state = {
		...this.state,
		see: false,
	};

	componentDidMount() {
		super.componentDidMount();
		const { see } = this.state;
		this._dom.field.setProperty('type', see ? 'text' : 'password');
	}

	componentDidUpdate() {
		const { see } = this.state;
		this._dom.field.setProperty('type', see ? 'text' : 'password');
	}

	$getValidateRules() {
		return {
			max: undefined,
			min: 3,
			alphabet: 0,
			numeric: 0,
			special: undefined,
			// special: {
			// 	char: '!@#$%^&/*+-=\\',
			// 	count: 3
			// },
			...this.props.validate,
		};
	}

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();
		const { required, max, min, alphabet, numeric, special } = rules;
		const msg = this.props.errorMsg || Password.ERROR;

		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		if (required && length === 0) return msg.required;
		if (!_.isNil(min) && min > length) return _.template(msg.min)({ min: min });
		if (!_.isNil(max) && max < length) return _.template(msg.max)({ max: max });

		if (_.isNumber(alphabet) && alphabet > 0)
			if (!value.test(new RegExp(`[a-zA-Z]{${alphabet},}`))) return _.template(msg.alphabet)({ a: alphabet });
		if (_.isNumber(numeric) && numeric > 0)
			if (!value.test(new RegExp(`[0-9]{${numeric},}`))) return _.template(msg.numeric)({ n: numeric });

		if (special) {
			let regexp = '[';
			_.forEach(_.toArray(special.char), c => regexp += '\\' + c);
			regexp += (`]{${special.count},}`);
			if (!value.test(new RegExp(regexp)))
				return _.template(msg.special)({ count: special.count, char: special.char });
		} else if (special === false && value.test(new RegExp(/\W/))) return msg.denySpecial;

		return true;
	}

	renderSuffix({ className, ico, text, width, theme, onClick }) {
		const { enable, editable } = this.state;
		return this.props.eye ? <span {...{
			ref: ele => this._dom.suffix = ele,
			className: `-suffix link light`,
			...enable ? {
				onClick: evt => {
					evt.stopPropagation();
					this.setState({ see: !this.state.see });
				},
			} : null,
		}}><i className={`fa fa-eye${this.state.see ? '' : '-slash'}`} /></span> : null;
	}
}

class TextPassword extends Text {
	static version = '0.0.1';
	static defaultProps = {
		...Text.defaultProps,
		indicator: false,
		suffix: true,
		eye: true,
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'pleaseEnterAPassword'),
		max: OptionUtils.getLabel('components.Input', 'thePasswordLengthIsUpTo'),
		min: OptionUtils.getLabel('components.Input', 'passwordLengthIsAtLeast'),
		otp: OptionUtils.getLabel('components.Input', 'theFormatDoesNotConform'),
	};
	state = {
		...this.state,
		see: false,
	};

	componentDidMount() {
		super.componentDidMount();
		const { see } = this.state;
		this._dom.field.setProperty('type', see ? 'text' : 'password');
	}

	componentDidUpdate() {
		const { see } = this.state;
		this._dom.field.setProperty('type', see ? 'text' : 'password');
	}

	$getValidateRules() {
		return {
			max: undefined,
			min: 3,
			...this.props.validate,
		};
	}

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();
		const { required, max, min, otp } = rules;
		const msg = this.props.errorMsg || TextPassword.ERROR;

		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		if (required && length === 0) return msg.required;
		if (!_.isNil(min) && min > length) return _.template(msg.min)({ min: min });
		if (!_.isNil(max) && max < length) return _.template(msg.max)({ max: max });
		if (otp && !/^\d{6}$/.test(value)) return msg.otp;
		return true;
	}

	renderSuffix({ className, ico, text, width, theme, onClick }) {
		const { enable, editable } = this.state;
		return this.props.eye ? <span {...{
			ref: ele => this._dom.suffix = ele,
			className: `-suffix link light`,
			...enable ? {
				onClick: evt => {
					evt.stopPropagation();
					this.setState({ see: !this.state.see });
				},
			} : null,
		}}><i className={`fa fa-eye${this.state.see ? '' : '-slash'}`} /></span> : null;
	}
}

class _Calendar extends HAComponent {
	static version = '0.0.2';
	static propTypes = {
		mode: PropTypes.oneOf(['default', 'range']),
		infinity: PropTypes.oneOf(['both', 'left', 'right', 'none']),
		stage: PropTypes.oneOf(['day', 'month', 'year']),
		value: PropTypes.oneOfType([
			PropTypes.instanceOf(window.Date), PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment), PropTypes.array,
		]),
		//min: PropTypes.oneOfType([PropTypes.instanceOf(window.Date), PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment)]),
		//max: PropTypes.oneOfType([PropTypes.instanceOf(window.Date), PropTypes.string, PropTypes.number, PropTypes.instanceOf(moment)]),
		rangeMax: PropTypes.string,		// ex: '1d', '2w', '3y', ...
		rangeMin: PropTypes.string,
		onYearSelect: PropTypes.func,
		onMonthSelect: PropTypes.func,
		onDaySelect: PropTypes.func,
		onMonthSlide: PropTypes.func,
		onStageChange: PropTypes.func,
	};
	static defaultProps = {
		mode: 'default', // 'default', 'range'
		infinity: 'none',
		stage: 'day', // 'year', 'month', 'day'
		noYear: false,
	};
	static MIN = moment('1900/1/1 00:00', 'YYYY/MM/DD HH:mm');
	static MAX = moment('2999/12/31 23:59', 'YYYY/MM/DD HH:mm');
	static MONTHS = [
		['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
		['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
		['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	];
	static DAYS = [
		['日', '一', '二', '三', '四', '五', '六'],
		['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		['日', '一', '二', '三', '四', '五', '六'],
	];
	state = {
		value: null,
		date: null,
		stage: this.props.stage || 'day',
		from: '',
		hoverDayCell: null,
	};

	constructor(props) {
		super(props);
		const i18nIdx = LocaleUtils.i18nIdx();
		this._MONTHS = _Calendar.MONTHS[i18nIdx];
		this._DAYS = _Calendar.DAYS[i18nIdx];

		const { mode, infinity, value, date, min, max } = this.props;
		this._min = _Calendar.MIN;
		this._max = _Calendar.MAX;
		if (min) {
			const m = moment.isMoment(min) ? min.clone() :
				_.isNumber(min) || _.isDate(min) ? moment(min) :
					_.isString(min) ? moment(min, 'YYYY/MM/DD') : null;
			if (m) m.startOf('day');
			if (m && m.isAfter(this._min)) this._min = m;
		}
		if (max) {
			const m = moment.isMoment(max) ? max.clone() :
				_.isNumber(max) || _.isDate(max) ? moment(max) :
					_.isString(max) ? moment(max, 'YYYY/MM/DD') : null;
			if (m) m.endOf('day');
			if (m && m.isBefore(this._max)) this._max = m;
		}
		if (mode === 'default') {
			let v = null, d = null;
			if (value) v = moment.isMoment(value) ? value.clone() : _.isNumber(value) || _.isDate(value) ? moment(value) : _.isString(value) ? moment(value, 'YYYY/MM/DD') : null;
			if (date) d = moment.isMoment(date) ? date.clone() : _.isNumber(date) || _.isDate(date) ? moment(date) : _.isString(date) ? moment(date, 'YYYY/MM/DD') : null;
			if (v && !v.isBetween(this._min, this._max, 'date', '[]')) v = null;
			if (d && !d.isBetween(this._min, this._max, 'date', '[]')) d = null;
			if (v) {
				this.state.value = v;
				this.state.date = v.clone();
			} else if (d) {
				this.state.value = null;
				this.state.date = d;
			} else {
				this.state.value = null;
				d = moment().startOf('date');
				if (!d.isBetween(this._min, this._max, null, '[]')) d = null;
				this.state.date = d ? d : this._min.clone();
			}
		} else if (mode === 'range') {
			// DateRange 沒有 mode 可以用，只好再弄一個 _toMoment...
			// (stage 不是 mode)
			const _toMoment = v => moment.isMoment(v)
				? v.clone()
				: _.isDate(v)
					? moment(v)
					: _.isNumber(v)
						? this._min.year() <= v && v <= this._max.year()
							? moment(String(v), 'YYYY')
							: moment(v)
						: _.isString(v) && v.trim().length > 0
							? moment(v, 'YYYY/MM/DD')
							: null;
			if (
				(!_.isArray(value) || value.length < 2) ||
				(infinity === 'both' && !value[0] && !value[1]) ||
				(infinity === 'left' && !value[1]) ||
				(infinity === 'right' && !value[0]) ||
				(infinity === 'none' && (!value[0] || !value[1]))
			) {
				let d = moment().startOf('date');
				if (date)
					d = _toMoment(date) || moment().startOf('date');
				this.state.date = d.isBetween(this._min, this._max, null, '[]') ? d : this._min.clone();
				return;
			}
			let v = _.map(value, _toMoment);
			if (!v[0]) {
				this.state.value = v;
				this.state.date = v[1].clone();
			} else if (!v[1]) {
				this.state.value = v;
				this.state.date = v[0].clone();
			} else {
				this.state.value = _.sortBy(v);
				this.state.date = this.state.value[0].clone();
			}
		}
	}

	render() {
		const { _min, _max } = this;
		const {
			mode, minStage, infinity, theme, rangeMax, rangeMin,
			onYearSelect, onMonthSelect, onDaySelect, onRangeSelect, onMonthSlide, onStageChange,
		} = this.props;
		const { value, date, stage, from, hoverDayCell } = this.state;
		const year = date.get('year');
		const month = date.get('month');

		const yearBtn = <span {...{
			className: '-y',
			_belong: 1,
			onClick: evt => this.setState({ stage: 'year', from: 'lower' }, () => _.isFunction(onStageChange) ? onStageChange('year') : null),
		}}>{year}</span>;
		const monthBtn = <span {...{
			className: '-m',
			_belong: 1,
			onClick: evt => this.setState({ stage: 'month', from: 'lower' }, () => _.isFunction(onStageChange) ? onStageChange('month') : null),
		}}>{this._MONTHS[month]}</span>;
		const _prevBtn = isPrev => <i {...{
			className: `-prev fal fa-lg fa-angle-left${isPrev ? '' : ' na'}`,
			...isPrev ? { onClick: evt => isPrev('Left') } : null,
		}} />;
		const _nextBtn = isNext => <i {...{
			className: `-next fal fa-lg fa-angle-right${isNext ? '' : ' na'}`,
			...isNext ? { onClick: evt => isNext('Right') } : null,
		}} />;
		const _inRange = now => {
			return value && value.length === 2 && (
				(infinity === 'none' && value[0] && value[1] && now.isBetween(value[0], value[1], '()')) || (
					(!value[0] && value[1] && now.isBefore(value[1])) ||
					(value[0] && !value[1] && now.isAfter(value[0])) ||
					(value[0] && value[1] && now.isBetween(value[0], value[1], '()'))
				)
			) ? ' inRange' : '';
		};
		const _isShadow = now => {
			return value && hoverDayCell && value.length == 1 && value[0] && (
				(hoverDayCell === -1 && now.isBefore(value[0])) ||
				(hoverDayCell === 1 && now.isAfter(value[0])) ||
				(moment.isMoment(hoverDayCell) && now.isBetween(
					value[0].isBefore(hoverDayCell) ? value[0] : hoverDayCell,
					hoverDayCell.isAfter(value[0]) ? hoverDayCell : value[0], '()',
				))
			) ? ' shadow' : '';
		};
		const _outOfRange = (t0, t1, level = 'day') => {
			const max = rangeMax;
			const min = rangeMin;
			if (!(max || min) || !(t0 && t1)) return false;
			if (max) {
				const u = _.last(max).toUpperCase();
				const unit = u === 'Y' ? 'y' : u === 'M' ? 'M' : 'd';
				const length = +max.substring(0, max.length - 1);
				if (Math.abs(t0.diff(t1, unit, true)) > length
					&& !(level === 'month' && t0.year() === t1.year() && t0.month() === t1.month())
					&& !(level === 'year' && t0.year() === t1.year())) return 1;
			}
			if (min) {
				const u = _.last(min).toUpperCase();
				const unit = u === 'Y' ? 'y' : u === 'M' ? 'M' : 'd';
				const length = +min.substring(0, min.length - 1);
				if (Math.abs(t0.diff(t1, unit, true)) < length) return -1;
			}
			return false;
		};

		const isInfinityLeft = mode === 'range' && (infinity === 'both' || infinity === 'left') && value && value.length == 1 && _min.isSame(_Calendar.MIN);
		const isInfinityRight = mode === 'range' && (infinity === 'both' || infinity === 'right') && value && value.length == 1 && _max.isSame(_Calendar.MAX);
		const _renderInfinityLeft = () => <span {...{
			className: '-cell infinity left',
			onClick: evt => this.setState({ value: [null, value[0]] }, () => _.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null),
			onMouseEnter: evt => this.setState({ hoverDayCell: -1 }),
			onMouseLeave: evt => this.setState({ hoverDayCell: null }),
		}}>- <i className={'fa fa-infinity'} /></span>;
		const _renderInfinityRight = () => <span {...{
			className: '-cell infinity right',
			onClick: evt => this.setState({ value: [value[0], null] }, () => _.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null),
			onMouseEnter: evt => this.setState({ hoverDayCell: 1 }),
			onMouseLeave: evt => this.setState({ hoverDayCell: null }),
		}}>+ <i className={'fa fa-infinity'} /></span>;
		const _renderDayStage = () => {
			const start = date.clone().startOf('month').startOf('date');
			const end = date.clone().endOf('month').startOf('date');
			const isPrev = end.clone().subtract(1, 'days').isAfter(_min) ? from => {
				date.subtract(1, 'months');
				this.state.from = from;
				this.forceUpdate(() => {
					if (_.isFunction(onMonthSlide)) onMonthSlide();
				});
			} : false;
			const isNext = start.clone().add(1, 'months').isBefore(_max) ? from => {
				date.add(1, 'months');
				this.state.from = from;
				this.forceUpdate(() => {
					if (_.isFunction(onMonthSlide)) onMonthSlide();
				});
			} : false;
			// const isInfinityLeft = mode === 'range' && (infinity === 'both' || infinity === 'left') && value && value.length == 1;
			// const isInfinityRight = mode === 'range' && (infinity === 'both' || infinity === 'right') && value && value.length == 1;
			const _renderDefaultPrevCell = i => {
				const now = start.clone().subtract(start.day() - i, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				return <span {...{
					key: `pre_${i}`,
					className: `-cell day out${available ? '' : ' na'}`,
					...available ? {
						onClick: evt => this.setState({
							value: now,
							date: now.clone(),
							from: 'left',
						}, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null),
					} : null,
				}}>{now.get('date')}</span>;
			};
			const _renderRangePrevCell = i => {
				const now = start.clone().subtract(start.day() - i, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				const outOfRange = _outOfRange(now, value && value[0]);
				const isStart = _.isArray(value) && value[0] && value[0].isSame(now, 'date');
				const isEnd = _.isArray(value) && value[1] && value[1].isSame(now, 'date');
				return <span {...{
					key: `pre_${i}`,
					_belong: 1,
					className: `-cell day out${isStart || isEnd ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? `${_inRange(now)}${_isShadow(now)}` : ' na'}`,
					...available ? {
						onClick: evt => {
							if (_.isArray(value) && value.length == 1) {
								if (outOfRange) return;
								this.setState(
									{ value: _.sortBy([value[0], now]), date: now.clone() },
									() => _.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null,
								);
							} else this.setState({
								value: [now],
								date: now.clone(),
								from: 'left',
							}, () => _.isFunction(onDaySelect) ? onDaySelect(this.state.value) : null);
						},
					} : null,
					onMouseEnter: evt => this.setState({ hoverDayCell: now }),
					onMouseLeave: evt => this.setState({ hoverDayCell: null }),
				}}>{now.get('date')}</span>;
			};
			const _renderDefaultCell = i => {
				const day = i + 1;
				const now = moment(`${year}-${month + 1}-${day}`, 'YYYY-M-D');
				const available = now.isBetween(_min, _max, null, '[]');
				const selected = value && value.isSame(now, 'date');
				const today = moment().isSame(now, 'day');

				return <span {...{
					key: `d_${i}`,
					className: `-cell ${today ? '-today ': ''} day${selected ? ' selected' : ''}${available ? '' : ' na'}`,
					...available ? {
						onClick: evt => {
							date.date(day);
							this.setState({ value: date.clone() }, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null);
						},
					} : null,
				}}>
					{day}
				</span>;
			};
			const _renderRangeCell = i => {
				const day = i + 1;
				const now = moment(`${year}-${month + 1}-${day}`, 'YYYY-M-D');
				const available = now.isBetween(_min, _max, null, '[]');
				const outOfRange = _outOfRange(now, value && value[0]);
				const selected = value && value[0] && value[0].isSame(now, 'date');
				const isStart = value && value[0] && value[0].isSame(now, 'day') && (
					(value.length === 1 && (!hoverDayCell || moment.isMoment(hoverDayCell) && hoverDayCell.isAfter(value[0]) || hoverDayCell === 1)) || value.length === 2
				);
				const isEnd = value && (
					(value.length === 1 && (
						(moment.isMoment(hoverDayCell) && hoverDayCell.isBefore(value[0])) || hoverDayCell === -1
					) && value[0].isSame(now, 'day')) ||
					(value.length === 2 && value[1] && value[1].isSame(now, 'day'))
				);
				return <span {...{
					key: `d_${i}`,
					_belong: 1,
					className: `-cell day${selected || isStart || isEnd ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? `${_inRange(now)}${_isShadow(now)}` : ' na'}`,
					...available ? {
						onClick: evt => {
							if (_.isArray(value) && value.length == 1) {
								if (outOfRange) return;
								this.setState(
									{ value: _.sortBy([value[0], now]) },
									() => _.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null,
								);
							} else this.setState({ value: [now] }, () => _.isFunction(onDaySelect) ? onDaySelect(this.state.value) : null);
						},
					} : null,
					onMouseEnter: evt => this.setState({ hoverDayCell: now }),
					onMouseLeave: evt => this.setState({ hoverDayCell: null }),
				}}>{day}</span>;
			};
			const _renderDefaultNextCell = i => {
				const now = end.clone().add(i + 1, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				return <span {...{
					key: `next_${i}`,
					className: `-cell day out${available ? '' : ' na'}`,
					...available ? {
						onClick: evt => this.setState({
							value: now,
							date: now.clone(),
							from: 'right',
						}, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null),
					} : null,
				}}>{now.get('date')}</span>;
			};
			const _renderRangeNextCell = i => {
				const now = end.clone().add(i + 1, 'days');
				const available = now.isBetween(_min, _max, null, '[]');
				const outOfRange = _outOfRange(now, value && value[0]);
				const isStart = value && value[0] && value[0].isSame(now);
				const isEnd = value && value[1] && value[1].isSame(now);
				return <span {...{
					key: `pre_${i}`,
					_belong: 1,
					className: `-cell day out${isStart || isEnd ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? `${_inRange(now)}${_isShadow(now)}` : ' na'}`,
					...available ? {
						onClick: evt => {
							if (_.isArray(value) && value.length == 1) {
								if (outOfRange) return;
								this.setState(
									{ value: _.sortBy([value[0], now]), date: now.clone() },
									() => _.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null,
								);
							} else this.setState({
								value: [now],
								date: now.clone(),
								from: 'right',
							}, () => _.isFunction(onDaySelect) ? onDaySelect(this.state.value) : null);
						},
					} : null,
					onMouseEnter: evt => this.setState({ hoverDayCell: now }),
					onMouseLeave: evt => this.setState({ hoverDayCell: null }),
				}}>{now.get('date')}</span>;
			};
			const _renderPeriod = () => {
				if (mode != 'range') return null;
				const d = !value || !value[0] || (!hoverDayCell && !value[1]) ? 0 :
					(hoverDayCell === 1 || hoverDayCell === -1) ? 'infinity' : Math.abs((value[1] || hoverDayCell).diff(value[0], 'days')) + 1;
					return <div className={'-period'}>
						<I18n key1='components.Input' key2='total' options={{'temp1': _.isNumber(d) ? d : <i className={'fa fa-infinity'} />}} />
					</div>;
			};
			return <>
				<div className={'-chead'}>{!this.props.noYear ? yearBtn : null} {monthBtn}</div>
				<div className={'-cbody'} onWheel={evt => evt.deltaY < 0 ? (isPrev ? isPrev('Top') : null) : (isNext ? isNext('Bottom') : null)}>
					<div key={`m_${month}`} className={`-calendar${isInfinityLeft ? ' iLeft' : ''}${isInfinityRight ? ' iRight' : ''}`}>
						<div className={'-week'}>
							{_.times(7, i => <span key={`w_${i}`}>{this._DAYS[i]}</span>)}
						</div>
						<div className={`-days an-${from === 'upper' ? 'zoomInEnlarge' : `slideIn${from}-500`} an-250ms`}>
							{_.times(start.day(), i => mode === 'range' ? _renderRangePrevCell(i) : _renderDefaultPrevCell(i))}
							{_.times(end.date(), i => mode === 'range' ? _renderRangeCell(i) : _renderDefaultCell(i))}
							{_.times(6 - end.day(), i => mode === 'range' ? _renderRangeNextCell(i) : _renderDefaultNextCell(i))}
						</div>
						{isInfinityLeft ? _renderInfinityLeft() : null}
						{isInfinityRight ? _renderInfinityRight() : null}
					</div>
					{_renderPeriod()}
					{_prevBtn(isPrev)} {_nextBtn(isNext)}
				</div>
			</>;
		};
		const _renderMonthStage = () => {
			const isPrev = _min.isBefore(date, 'year') ? from => {
				date.subtract(1, 'years');
				this.state.from = from;
				this.forceUpdate();
			} : false;
			const isNext = _max.isAfter(date, 'year') ? from => {
				date.add(1, 'years');
				this.state.from = from;
				this.forceUpdate();
			} : false;
			const fxCss = `an-${from === 'upper' ? 'zoomInEnlarge' : from === 'lower' ? 'zoomInShrink' : `slideIn${from}-500`}`;
			const _renderDefaultCell = i => {
				const now = moment({ year, month: i, date: 1 });
				const available = now.isBetween(_min, _max, 'month', '[]');
				const outOfRange = _outOfRange(now, value && value[0], 'month');
				const selected = (mode === 'default' && value && value.isSame(now, 'month')) ||
					(mode === 'range' && value && ((value[0] && value[0].isSame(now, 'month')) || (value[1] && value[1].isSame(now, 'month'))));
				const inRange = mode === 'range' && !selected && available && _inRange(now);
				const isShadow = mode === 'range' && !selected && available && _isShadow(now);
				const isStart = mode === 'range' && value && value.length === 2 && value[0] && value[0].isSame(now, 'month');
				const isEnd = mode === 'range' && value && value.length === 2 && value[1] && value[1].isSame(now, 'month');
				return <span {...{
					key: `m_${i}`,
					className: `-cell${selected ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? '' : ' na'}${inRange ? ' inRange' : ''}${isShadow ? ' shadow' : ''}`,
					...minStage !== 'month' && { _belong: 1 },
					...available ? {
						onClick: evt => {
							if (minStage === 'month') {
								this.setState({
									value: now,
									date: now.clone(),
									from: 'left',
								}, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null);
							} else {
								date.month(i);
								this.setState({
									stage: 'day',
									from: 'upper',
								}, () => _.isFunction(onStageChange) ? onStageChange('day') : null);
							}
						},
					} : null,
					...mode === 'range' ? { onMouseEnter: evt => this.setState({ hoverDayCell: now }) } : null,
					...mode === 'range' ? { onMouseLeave: evt => this.setState({ hoverDayCell: null }) } : null,
				}}>{this._MONTHS[i]}</span>;
			};
			const _renderRangeCell = i => {
				const now = moment({ year, month: i, date: 1 });
				const available = now.isBetween(_min, _max, null, '[]');
				const outOfRange = _outOfRange(now, value && value[0], 'month');
				const isStart = value && value[0] && value[0].isSame(now, 'month') && (
					(value.length === 1 && (!hoverDayCell || moment.isMoment(hoverDayCell) && hoverDayCell.isAfter(value[0]) || hoverDayCell === 1)) || value.length === 2
				);
				const isEnd = value && (
					(value.length === 1 && (
						(moment.isMoment(hoverDayCell) && hoverDayCell.isBefore(value[0])) || hoverDayCell === -1
					) && value[0].isSame(now, 'month')) ||
					(value.length === 2 && value[1] && value[1].isSame(now, 'month'))
				);
				return <span {...{
					key: `m_${i}`,
					_belong: 1,
					className: `-cell ${isStart || isEnd ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? `${_inRange(now)}${_isShadow(now)}` : ' na'}`,
					...available ? {
						onClick: evt => {
							if (_.isArray(value) && value.length == 1)
								this.setState({ value: _.sortBy([value[0], now]) }, () =>
									_.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null);
							else this.setState({ value: [now] }, () => _.isFunction(onDaySelect) ? onDaySelect(this.state.value) : null);
						},
					} : null,
					onMouseEnter: evt => this.setState({ hoverDayCell: now }),
					onMouseLeave: evt => this.setState({ hoverDayCell: null }),
				}}>{this._MONTHS[i]}</span>;
			};
			return <>
				{!this.props.noYear ? <div className={'-chead'}>{yearBtn}</div> : null}
				<div className={'-cbody'} onWheel={evt => evt.deltaY < 0 ? (isPrev ? isPrev('Top') : null) : (isNext ? isNext('Bottom') : null)}>
					{isInfinityLeft ? _renderInfinityLeft() : null}
					<div key={`y_${year}`} className={`-months ${fxCss} an-250ms`}>
						{_.times(12, i => mode === 'range' && minStage === 'month' ? _renderRangeCell(i) : _renderDefaultCell(i))}
					</div>
					{isInfinityRight ? _renderInfinityRight() : null}
					{!this.props.noYear ? _prevBtn(isPrev) : null}
					{!this.props.noYear ? _nextBtn(isNext) : null}
				</div>
			</>;
		};
		const _renderYearStage = () => {
			const base = Math.floor(year / 25) * 25;
			const isPrev = _min.year() < base ? from => {
				date.subtract(25, 'years');
				this.state.from = from;
				this.forceUpdate();
			} : false;
			const isNext = _max.year() >= (base + 25) ? from => {
				date.add(25, 'years');
				this.state.from = from;
				this.forceUpdate();
			} : false;
			const fxCss = `an-${from === 'upper' ? 'zoomInEnlarge' : from === 'lower' ? 'zoomInShrink' : `slideIn${from}-500`}`;
			const _renderDefaultCell = i => {
				const now = moment({ year: base + i, month: 0, date: 1 });
				const available = now.isBetween(_min, _max, 'year', '[]');
				const outOfRange = _outOfRange(now, value && value[0], 'year');
				const selected = (mode === 'default' && value && value.isSame(now, 'year')) ||
					(mode === 'range' && value && ((value[0] && value[0].isSame(now, 'year')) || (value[1] && value[1].isSame(now, 'year'))));
				const inRange = mode === 'range' && !selected && available && _inRange(now);
				const isShadow = mode === 'range' && !selected && available && _isShadow(now);
				const isStart = mode === 'range' && value && value.length === 2 && value[0] && value[0].isSame(now, 'year');
				const isEnd = mode === 'range' && value && value.length === 2 && value[1] && value[1].isSame(now, 'year');
				return <span {...{
					key: `y_${i}`,
					className: `-cell${selected ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? '' : ' na'}${inRange ? ' inRange' : ''}${isShadow ? ' shadow' : ''}`,
					...minStage !== 'year' && { _belong: 1 },
					...available ? {
						onClick: evt => {
							if (minStage === 'year') {
								this.setState({
									value: now,
									date: now.clone(),
								}, () => _.isFunction(onDaySelect) ? onDaySelect(now.clone()) : null);
							} else {
								date.year(now.year());
								this.setState({
									stage: 'month',
									from: 'upper',
								}, () => _.isFunction(onStageChange) ? onStageChange('month') : null);
							}
						},
					} : null,
				}}>{now.year()}</span>;
			};
			const _renderRangeCell = i => {
				const now = moment({ year: base + i, month: 0, date: 1 });
				const available = now.isBetween(_min, _max, null, '[]');
				const outOfRange = _outOfRange(now, value && value[0], 'year');
				const isStart = value && value[0] && value[0].isSame(now, 'year') && (
					(value.length === 1 && (!hoverDayCell || moment.isMoment(hoverDayCell) && hoverDayCell.isAfter(value[0]) || hoverDayCell === 1)) || value.length === 2
				);
				const isEnd = value && (
					(value.length === 1 && (
						(moment.isMoment(hoverDayCell) && hoverDayCell.isBefore(value[0])) || hoverDayCell === -1
					) && value[0].isSame(now, 'year')) ||
					(value.length === 2 && value[1] && value[1].isSame(now, 'year'))
				);
				return <span {...{
					key: `y_${i}`,
					_belong: 1,
					className: `-cell ${isStart || isEnd ? ' selected' : ''}${isStart ? ' s' : ''}${isEnd ? ' e' : ''}${available && outOfRange < 1 ? `${_inRange(now)}${_isShadow(now)}` : ' na'}`,
					...available ? {
						onClick: evt => {
							if (_.isArray(value) && value.length == 1)
								this.setState({ value: _.sortBy([value[0], now]) }, () =>
									_.isFunction(onRangeSelect) ? onRangeSelect(this.state.value) : null);
							else this.setState({ value: [now] }, () => _.isFunction(onDaySelect) ? onDaySelect(this.state.value) : null);
						},
					} : null,
					onMouseEnter: evt => this.setState({ hoverDayCell: now }),
					onMouseLeave: evt => this.setState({ hoverDayCell: null }),
				}}>{now.year()}</span>;
			};
			return <>
				<div className={'-cbody'} onWheel={evt => evt.deltaY < 0 ? (isPrev ? isPrev('Top') : null) : (isNext ? isNext('Bottom') : null)}>
					{isInfinityLeft ? _renderInfinityLeft() : null}
					<div key={`ys_${base}`} className={`-years ${fxCss} an-250ms`}>
						{_.times(25, i => mode === 'range' && minStage === 'year' ? _renderRangeCell(i) : _renderDefaultCell(i))}
					</div>
					{isInfinityRight ? _renderInfinityRight() : null}
					{_prevBtn(isPrev)} {_nextBtn(isNext)}
				</div>
			</>;
		};
		return <div className={`H2-EZCalendarPicker ${stage} ${theme ? theme : ''}`}>
			{
				stage === 'day' ? _renderDayStage() :
					stage === 'month' ? _renderMonthStage() :
						stage === 'year' ? _renderYearStage() : null
			}
		</div>;
	}
}

class _Clock extends HAComponent {
	static version = '0.1.0';
	static propTypes = {
		value: PropTypes.string,
		max: PropTypes.string,
		min: PropTypes.string,
		onHourPick: PropTypes.func,
		onMinutePick: PropTypes.func,
		onComplete: PropTypes.func,
	};
	static defaultProps = {};
	static HOUR = ['時', 'Hour', '时'];
	static MINUTE = ['分', 'Minute', '分'];
	static MAX = '23:59';
	static MIN = '00:00';
	state = {
		value: null,
		more: false,
		hrHover: null,
		minHover: null,
		hrs: null,
		mins: null,
	};

	constructor(props) {
		super(props);
		const i18nIdx = LocaleUtils.i18nIdx();
		this._HOUR = _Clock.HOUR[i18nIdx];
		this._MINUTE = _Clock.MINUTE[i18nIdx];

		const { value, min, max } = this.props;
		this._min = _Clock.MIN;
		this._max = _Clock.MAX;
		const regexp = /^(2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$/i;
		if (min && min.test(regexp) && min > this._min) this._min = min;
		if (max && max.test(regexp) && max < this._max) this._max = max;
		if (!value) return;
		if (value.test(regexp) && value >= this._min && value <= this._max) {
			this.state.hrs = value.substring(0, 2);
			this.state.mins = value.substring(3, 5);
		} else if (value.test(/^(2[0-3]|1[0-9]|[0-9]|[01][0-9]):$/i)) {
			this.state.hrs = value.substring(0, 2);
		} else if (value.test(/^:([0-9]|[0-5][0-9])$/i)) {
			this.state.mins = value.substring(1);
		}
		if (this.state.mins && this.state.mins % 5 !== 0)
			this.state.more = true;
	}

	render() {
		const { _max, _min } = this;
		const { theme, onHourPick, onMinutePick, onComplete, onlyHour } = this.props;
		const { more, hrHover, minHover, hrs, mins } = this.state;

		const _renderHourTick = (i) => {
			const v = (i < 10 ? '0' : '') + i;
			const available = (v + ':59') >= _min && (v + ':00') <= _max;
			const isOutOfRange = mins && `${v}:${mins}` < _min || `${v}:${mins}` > _max;
			return <span {...{
				//key: 'h_' + i,
				className: `-cell${v === hrs ? ' selected' : ''}${available ? '' : ' na'}`,
				...available && hrs != v ? { onMouseEnter: evt => this.setState({ hrHover: v }) } : null,
				...available && hrs != v ? { onMouseLeave: evt => this.setState({ hrHover: null }) } : null,
				...available ? {
					onClick: evt => {
						if (onlyHour) {
							this.setState({ hrs: v }, () => {
								_.isFunction(onHourPick) ? onHourPick(`${v}:00`) : null;
								_.isFunction(onComplete) ? onComplete(`${v}:00`) : null;
							});
							return;
						}

						this.setState({
							hrs: v,
							hrHover: null,
							...isOutOfRange ? { mins: null } : null,
						}, () => {
							_.isFunction(onHourPick) ? onHourPick(`${v}:${mins && !isOutOfRange ? mins : ''}`) : null;
							v && mins && !isOutOfRange && _.isFunction(onComplete) ? onComplete(`${v}:${mins}`) : null;
						})
					},
				} : null,
			}}>{v}</span>;
		};
		return <div className={`H2-EZClockPicker ${theme ? theme : ''}`}>
			<div className={'-block hours'}>
				{
					hrHover ? <h4 className={'color-blue opacity-25'}>{hrHover}</h4> :
						hrs ? <h4 className={'color-blue pure'}>{hrs}</h4> :
							<h4 className={'color-lightGray'}>{this._HOUR}</h4>
				}
				{
					_.times(12, i => <React.Fragment key={i}>
						{_renderHourTick(i)}
						{_renderHourTick(i + 12)}
					</React.Fragment>)
				}
			</div>
			{
				onlyHour ? null : (
					<>
						<div className={'-colon'}>:</div>
						<div className={`-block minutes${more ? ' more' : ''}`}>
							{minHover && <h4 className={'color-blue opacity-25'}>{minHover}</h4>}
							{!minHover && mins && <h4 className={'color-blue pure'}>{mins}</h4>}
							{!minHover && !mins && <h4 className={'color-lightGray'}>{this._MINUTE}</h4>}
							<i className={`btn btn-white btn-xs square fa fa-angle-${more ? 'left' : 'right'}`} onClick={evt => this.setState({ more: !more })} />
							{
								_.times(more ? 60 : 12, i => {
									let v = more ? i : (i * 5);
									v = (v < 10 ? '0' : '') + v;
									const available = !hrs || (((hrs + ':' + v) >= _min && (hrs + ':' + v) <= _max));
									const isOutOfRange = hrs && (`${hrs}:${v}` < _min || `${hrs}:${v}` > _max);
									return <span {...{
										key: 'm_' + i,
										className: `-cell${v === mins ? ' selected' : ''}${available ? '' : ' na'}`,
										...available && mins != v ? { onMouseEnter: evt => this.setState({ minHover: v }) } : null,
										...available && mins != v ? { onMouseLeave: evt => this.setState({ minHover: null }) } : null,
										...available ? {
											onClick: evt => this.setState({
												...isOutOfRange ? { hrs: null } : null,
												mins: v,
												minHover: null,
											}, () => {
												_.isFunction(onMinutePick) ? onMinutePick(`${hrs && !isOutOfRange ? hrs : ''}:${v}`) : null;
												hrs && v && !isOutOfRange && _.isFunction(onComplete) ? onComplete(`${hrs}:${v}`) : null;
											}),
										} : null,
									}}>{v}</span>;
								})
							}
						</div>
					</>
				)
			}
		</div>;
	}
}

/**
 * 把傳入值轉成 moment<br />
 * (如果 v 不是 moment, 非空字串, Date, number 之一的話，回傳 null)<br />
 * (如果 v 為非空字串且 isStrict=true, 回傳的 moment 可能會是 invalid)
 * @param v
 * @param mode
 * @param fmt
 * @param isStrict
 * @returns {moment.Moment|null}
 * @private
 */
const _toMoment = (v, mode, fmt = '', isStrict = false) => {
	if (moment.isMoment(v)) return v.clone();
	if (_.isString(v) && !_.isEmpty(v)) return moment(v, fmt, isStrict);
	if (_.isDate(v)) return moment(v);
	if (!_.isNumber(v)) return null;

	if (mode === 'month') return moment(v);
	if (mode === 'monthDate') return moment(v);
	// 不可能把 moment(2021) 跟 moment('2021') 都識別成 2021/01/01！
	// moment(2021) 是 1970-01-01 00:00:02:021Z
	if (1895 < v && v < 3000 && mode === 'year') return moment(v, 'YYYY'); // 1895/04/17 馬關條約
	return moment(v);
};
const _pruneMoment = (mode, m) => {
	if (!moment.isMoment(m)) return;
	if (mode === 'date') m.startOf('date');
	else if (mode === 'time' || mode === 'datetime') m.startOf('minute');
	else if (mode === 'year') m.startOf('year');
	else if (mode === 'yearMonth') m.startOf('month');
	else if (mode === 'month') m.startOf('month');
	else if (mode === 'monthDate') m.startOf('date');
	// return m;
};
const STAGES = { day: 1, month: 2, year: 3 };

// TODO __defineFieldFormat 跟 __defineValueFormat 應該可以統一
const __defineFieldFormat = (mode, s) => {
	if (mode === 'date') return `YYYY${s}MM${s}DD`;
	if (mode === 'time') return `HH:mm`;
	if (mode === 'hour') return `HH:mm`;
	if (mode === 'datetime') return `YYYY${s}MM${s}DD HH:mm`;
	if (mode === 'year') return `YYYY`;
	if (mode === 'yearMonth') return `YYYY${s}MM`;
	if (mode === 'month') return `MM`
	if (mode === 'monthDate') return `MM${s}DD`
	return null;
};
const __defineValueFormat = (mode, s) => {
	if (mode === 'time') return `HH:mm`;
	if (mode === 'hour') return `HH:mm`;
	if (mode === 'datetime') return `YYYY${s}MM${s}DD HH:mm`;
	if (mode === 'year') return `YYYY`;
	if (mode === 'yearMonth') return `YYYY${s}MM`;
	// if (mode === 'month') return `MM`
	// if (mode === 'monthDate') return `MM${s}DD`
	// if (mode === 'date')
	return `YYYY${s}MM${s}DD`;
};
class RDate extends Text {
	static version = '0.1.1';
	static propTypes = {
		...Text.PropTypes,
		mode: PropTypes.oneOf(['date', 'time', 'hour', 'datetime', 'year', 'yearMonth', 'monthDate', 'month']),
		valueType: PropTypes.oneOf(['date', 'timestamp', 'string']),
		isFreeKeyin: PropTypes.bool,
		separator: PropTypes.oneOf(['/', '-', '']),
		isPicker: PropTypes.bool,
		stage: PropTypes.oneOf(['day', 'month', 'year']),
	};
	static defaultProps = {
		...Text.defaultProps,
		mode: 'date',
		suffix: true,
		indicator: false,
		placeholder: 'YYYY/MM/DD',
		valueType: 'timestamp', 			// 'date', 'timestamp', or 'string'
		isFreeKeyin: true,
		separator: '/',
		isPicker: true,
		valueFixed: false, // 是否已修正 onUpdate 回傳值型別跟 valueType 不符的問題
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		date: OptionUtils.getLabel('components.Input', 'pleaseEnterTheDateFormat'),
		year: OptionUtils.getLabel('components.Input', 'pleaseEnterTheADFormat'),
		yearMonth: OptionUtils.getLabel('components.Input', 'pleaseEnterTheYearAndMonth'),
		month: OptionUtils.getLabel('components.Input', 'pleaseEnterTheMonthFormat'),
		monthDate: OptionUtils.getLabel('components.Input', 'pleaseEnterMonthAndDayFormat'),
		time: OptionUtils.getLabel('components.Input', 'pleaseEnterTheTimeFormat'),
		hour: OptionUtils.getLabel('components.Input', 'pleaseEnterTheHourFormat'),
		datetime: OptionUtils.getLabel('components.Input', 'pleaseEnterTheDatetimeFormat'),
		max: OptionUtils.getLabel('components.Input', 'mustBeLessThan'),
		min: OptionUtils.getLabel('components.Input', 'mustBeGreaterThan'),
	};
	static MIN = moment('1900/01/01 00:00', 'YYYY/MM/DD HH:mm');
	static MAX = moment('2999/12/31 23:59', 'YYYY/MM/DD HH:mm');

	constructor(props) {
		super(props);

		const { mode, separator: s, value, initValue, onUpdate } = this.props;
		this.state.fieldFormat = this._defineFieldFormat(mode, s);
		this.state.valueFormat = this._defineValueFormat(mode, s);

		if (!_.isNil(initValue)) {
			const checked = this._chkSetValue(initValue);
			if (checked) {
				const { value, fieldValue } = checked;
				this._init = this.state._preValue = this.state._value = this.state.value = value;
				this.state.fieldValue = fieldValue;
			}
		}
		if (!_.isNil(value)) {
			const checked = this._chkSetValue(value);
			if (checked) {
				const { value, fieldValue } = checked;
				this.state._preValue = this.state._value = this.state.value = value;
				this.state.fieldValue = fieldValue;
			}
		}

		// 這段會導致閉包
		// if (onUpdate && _.isFunction(onUpdate))
		// 	this._onUpdate = (_value, _preValue, _this, ...args) => {
		// 		// TODO 原本的元件，getValue 拿到的型別是 valueType, 結果 onUpdate 都給 string...
		// 		if (this.props.valueFixed) {
		// 			_value = this._getValue(_value);
		// 			_preValue = this._getValue(_preValue);
		// 		}
		// 		onUpdate(_value, _preValue, _this, ...args);
		// 	};
	}

	static getDerivedStateFromProps(props, state) {
		const s = Text.getDerivedStateFromProps(props, state);
		if (!s) return null;

		if (s.value) {
			const { mode, value } = props;
			const { valueFormat } = state;
			const m = _toMoment(s.value, mode, valueFormat);
			if (m && m.isValid()) {
				_pruneMoment(mode, m);
				s._value = value;
				s.value = s._preValue = m.format(valueFormat);
				s.fieldValue = m.format(state.fieldFormat);
			} else {
				s._value = value;
				s.value = s._preValue = undefined;
				s.fieldValue = '';
			}
		}

		return s;
	}

	_onUpdate = (_value, _preValue, _this, ...args) => {
		const { onUpdate } = this.props;
		if (onUpdate && _.isFunction(onUpdate)) {
			// TODO 原本的元件，getValue 拿到的型別是 valueType, 結果 onUpdate 都給 string...
			if (this.props.valueFixed) {
				_value = this._getValue(_value);
				_preValue = this._getValue(_preValue);
			}
			onUpdate(_value, _preValue, _this, ...args);
		}
	}

	_defineFieldFormat(mode, s) {
		return __defineFieldFormat(mode, s);
	}

	_defineValueFormat(mode, s) {
		return __defineValueFormat(mode, s);
	}

	alignValues() {
		const { mode, separator: s } = this.props;
		const { valueFormat, fieldFormat } = this.state;

		const f = this._dom.field;
		let fieldValue = (f.value + '').trim();

		if (mode === 'date' && fieldValue.length > 7) {
			let v = fieldValue.substring(0, 8);
			if (v.test(/^[0-9]{8}$/i)) {
				v = v.substring(0, 4) + s + v.substring(4, 6) + s + v.substring(6, 8);
				const m = _toMoment(v, mode, `YYYY${s}MM${s}DD`);
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		} else if ((mode === 'time' || mode === 'hour') && fieldValue.length > 3) {
			let v = fieldValue.substring(0, 4);
			if (v.test(/^[0-9]{4}$/i)) {
				v = v.substring(0, 2) + ':' + v.substring(2, 4);
				const m = _toMoment(v, mode, 'HH:mm');
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		} else if (mode === 'datetime' && fieldValue.length > 12) {
			let v = fieldValue.substring(0, 13);
			if (v.test(/^[0-9]{8} [0-9]{4}$/i)) {
				v = v.substring(0, 4) + s + v.substring(4, 6) + s + v.substring(6, 8) + ' ' + v.substring(9, 11) + ':' + v.substring(11, 13);
				const m = _toMoment(v, mode, `YYYY${s}MM${s}DD HH:mm`);
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		} else if (mode === 'year' && fieldValue.length >= 4) {
			let v = fieldValue.substring(0, 4);
			if (v.test(/^\d{4}$/)) {
				const m = _toMoment(v, mode, 'YYYY');
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		} else if (mode === 'yearMonth' && fieldValue.length >= 6) {
			let v = fieldValue.substring(0, 6);
			if (v.test(/^\d{6}$/)) {
				v = v.substring(0, 4) + s + v.substring(4, 6);
				const m = _toMoment(v, mode, `YYYY${s}MM`);
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		} else if (mode === 'monthDate') {
			return {
				value: `1911${s}${fieldValue}`,
				fieldValue,
			};
		} else if (mode === 'month') {

			return {
				value: `1911${s}${fieldValue}${s}01`,
				fieldValue,
			};
		}

		const m = _toMoment(fieldValue, mode, fieldFormat, true);
		return {
			value: m && m.isValid() && m.format(valueFormat) || undefined,
			fieldValue,
		};
	}

	_keyDown(evt) {
		const { isFreeKeyin, mode, separator: s } = this.props;
		if (!isFreeKeyin) return evt.preventDefault();

		const { enable, editable } = this.state;
		const { key, ctrlKey, metaKey } = evt;

		if (!enable || !editable || evt.keyCode == 229) return evt.preventDefault();
		if ((ctrlKey || metaKey) && _.includes(['a', 'c', 'v', 'x'], key)) return;
		const numKeys = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
		const ctrlKeys = ['Enter', 'Tab', 'ArrowLeft', 'ArrowRight', 'Backspace', 'Delete', 'Home', 'End'];
		if (key === 'Tab') {
			this.blur();
		}
		if (!_.includes(
			(mode === 'date' || mode === 'yearMonth' || mode === 'month' || mode === 'monthDate') ? numKeys.concat(ctrlKeys).concat([s]) :
				mode === 'year' ? numKeys.concat(ctrlKeys) :
					(mode === 'time' || mode === 'hour') ? numKeys.concat(ctrlKeys).concat([':']) :
						mode === 'datetime' ? numKeys.concat(ctrlKeys).concat([s, ' ', ':']) : [], key))
			return evt.preventDefault();
	}

	$getValidateRules() {
		const { mode, separator: s, validate } = this.props;
		const _transfer = m => {
			return mode === 'year' ? moment(m, 'YYYY') :
				moment.isMoment(m) ? m.clone() :
					_.isNumber(m) || _.isDate(m) ? moment(m) :
						_.isString(m) ? moment(m, this.state.fieldFormat || 'YYYY/MM/DD') : null;
		};
		const min = _transfer(validate && validate.min);
		const max = _transfer(validate && validate.max);

		const regexpMap = {
			date: new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1])$`),
			datetime: new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$`),
			year: new RegExp(`^\\d{4}$`),
			yearMonth: new RegExp(`^\\d{4}\\${s}(?:0?[1-9]|1[0-2])$`),
			month: new RegExp(`^[1-9]|0[1-9]|1[0-2]$`),
			monthDate: new RegExp(`^([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1])$`),
		}

		return {
			...this.props.validate || {},
			regexp: regexpMap[mode],
			min: min && min.isAfter(RDate.MIN) ? min : RDate.MIN,
			max: max && max.isBefore(RDate.MAX) ? max : RDate.MAX,
		};
	}

	_validate(value = this.state.fieldValue) {
		const rules = this.$getValidateRules();

		const { mode, onlyHour } = this.props;
		value = _.isNil(value) ? '' : (value + '').trim();
		const length = value.length;
		const msg = this.props.errorMsg || RDate.ERROR;
		const { required, max, min } = rules;
		if (length === 0) return required ? msg.required : true;

		let FORMAT = this.state.fieldFormat || 'YYYY/MM/DD';
		if (onlyHour) {
			FORMAT = 'HH:00';
		}
		const m = _toMoment(value, mode, FORMAT, true);
		if (!m || !m.isValid()) return msg[mode];
		if (mode === 'time' || mode === 'hour') {
			if (max < value) return _.template(msg.max)({ max: max });
			if (min > value) return _.template(msg.min)({ min: min });
		} else {
			if (max && max.isBefore(m)) return _.template(msg.max)({ max: max.format(FORMAT) });
			if (min && min.isAfter(m)) return _.template(msg.min)({ min: min.format(FORMAT) });
		}
		return true;
	}

	_getValue(value) {
		if (_.isEmpty(value) || value === 0) return undefined;
		const { mode, valueType } = this.props;
		const { valueFormat, fieldFormat } = this.state;
		const m = _toMoment(value, mode, valueFormat);
		return (!valueType || valueType === 'date') ? m.toDate()
			: valueType === 'timestamp' ? m.valueOf()
				: valueType === 'string' ? m.format(fieldFormat) : undefined;
	}

	getValue() {
		const { enable, error, focus, value } = this.state;
		if (!enable || error) return undefined;

		if (focus) {
			if (!this.validate()) return undefined;
			this.blur();
			// 這邊是想拿到當下 fieldValue 填的東西。
			// value 因為還沒跑完 state 更新所以會是舊的。
			return this._getValue(this.state.fieldValue);
		}

		return this._getValue(value);
	}

	toMoment() {
		const value = super.getValue();
		if (_.isEmpty(value) || value === 0) return undefined;
		const { mode } = this.props;
		const { valueFormat, fieldFormat } = this.state;
		return _toMoment(value, mode, valueFormat);
	}

	_chkSetValue(value) {

		const { mode } = this.props;
		const { valueFormat } = this.state;

		if (!valueFormat || value === '0000-00-00') return false;
		const m = _toMoment(value, mode, valueFormat);

		// 允許空值
		// if (_.isEmpty(value)) return { value: undefined, fieldValue: '' };

		if (!m || !m.isValid()) return false;

		_pruneMoment(mode, m);
		value = m.format(valueFormat);
		const fieldValue = m.format(this.state.fieldFormat);
		if (this._validate(fieldValue) !== true) return false;

		return { value, fieldValue };
	}

	setValue(v, cb) {
		const checked = this._chkSetValue(v);
		if (!checked) return false;
		const { value, fieldValue } = checked;
		const { value: currValue } = this.state;
		if (_.isEqual(value, currValue)) return false;

		this.setState({
			value,
			_preValue: value,
			fieldValue,
			error: false,
		});
		return this;
	}

	renderSuffix({ className, ico, text, width, theme, onClick }) {
		const { mode } = this.props;
		return <span {...{
			ref: ele => this._dom.suffix = ele,
			className: `-suffix light`,
			style: { width: 24 },
		}}>
			{mode === 'date' || mode === 'yearMonth' || mode === 'year' || mode === 'month' || mode === 'monthDate' ?
				<i className={'fal fa-calendar-alt'} /> : null}
			{mode === 'time' ? <i className={'fal fa-clock'} /> : null}
			{mode === 'datetime' ? <>
				<i className="fal fa-calendar-alt" />
				<i className="fa fa-sm fa-clock zoom-p80" style={{ position: 'absolute', bottom: 4, right: 2 }} />
			</> : null}
		</span>;
	}

	$renderPickerBody() {
		const rules = this.$getValidateRules();
		const { mode, date } = this.props;
		const { value } = this.state;

		const minStage = {
			date: 'day',
			yearMonth: 'month',
			year: 'year',
			month: 'month',
			monthDate: 'day'
		}[mode];
		let stage;
		if (!value && this.props.stage) {
			if (STAGES[this.props.stage] < STAGES[minStage]) stage = minStage;
			else stage = this.props.stage;
		} else stage = minStage;

		return <_Calendar {...{
			max: rules.max,
			min: rules.min,
			value, date,
			stage,
			minStage,
			noYear: mode === 'month' || mode === 'monthDate',
			onDaySelect: m => {
				const v = m.format(this.state.valueFormat);

				if (_.isEqual(v, this.state._preValue)) {
					this.setState({ focus: false });
				} else {
					this.setState({
						value: v, // TODO need this? validate 已經改看 fieldValue 了...
						fieldValue: m.format(this.state.fieldFormat),
						focus: false,
					});
				}
			},
			onMonthSlide: () => this._dom.picker.position(),
			onStageChange: () => this._dom.picker.position(),
		}} />;
	}
}

class DateRange extends ReactInput {
	static version = '0.1.4';
	static propTypes = {
		...ReactInput.propTypes,
		infinity: PropTypes.oneOf(['none', 'left', 'right', 'both']),
		placeholder: PropTypes.array,
		valueType: PropTypes.oneOf(['date', 'timestamp', 'string']),
		onEnter: PropTypes.func,
		isPicker: PropTypes.bool,
		rangeMax: PropTypes.string, // 可選取的區間最大範圍(單位: y, m, d) Ex: 2m
		rangeMin: PropTypes.string, // 可選取的區間最小範圍(單位: y, m, d) ex: 3d
	};
	static defaultProps = {
		...ReactInput.defaultProps,
		infinity: 'none',
		isPicker: true,
		placeholder: [OptionUtils.getLabel('components.Input', 'startDate'), OptionUtils.getLabel('components.Input', 'endDate')],
		valueType: 'timestamp',
		autoReverse: true,
		valueFixed: false, // 是否已修正 onUpdate 回傳值型別跟 valueType 不符的問題
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'aStartOrEndDateIs'),
		startRequired: OptionUtils.getLabel('components.Input', 'aStartDateIsRequired'),
		endRequired: OptionUtils.getLabel('components.Input', 'anEndDateIsRequired'),
		wrongOrder: OptionUtils.getLabel('components.Input', 'theStartDateMustBeEarlier'),
		rangeMax: OptionUtils.getLabel('components.Input', 'theTimeRangeMustBeLess'),
		rangeMin: OptionUtils.getLabel('components.Input', 'theTimeRangeMustBeGreater'),
	};
	state = {
		...this.state,
		value: [],
	};

	constructor(props) {
		super(props);

		const { value, initValue, isPicker, onUpdate, onFocus, onBlur, mode } = this.props;
		const _valid = (src) => {
			if (!_.isArray(src) || src.length !== 2) return false;
			src = _.map(src, ele => _.isNil(ele) || ele === '0000-00-00' ? undefined : ele);
			return (src[0] || src[1]) ? true : false;
		};
		let checkedValue;
		if (_valid(value) && (checkedValue = this._chkSetValue(value))) {
			const { value: _value } = checkedValue;
			this.state.value = _value;
			this.state._preValue = _.cloneDeep(_value);
		}
		let checkedInitValue;
		if (_valid(initValue) && (checkedInitValue = this._chkSetValue(initValue))) {
			const { value: _value } = checkedInitValue;
			this._init = _value;
			if (!this.state._preValue) {
				this.state.value = _.cloneDeep(_value);
				this.state._preValue = _.cloneDeep(_value);
			}
		}

		if (onUpdate && _.isFunction(onUpdate)) this._onUpdate = onUpdate;
		this._FORMAT = mode === 'year' ? 'YYYY' : mode === 'yearMonth' ? 'YYYY/MM' : 'YYYY/MM/DD';
	}

	reset() {
		if (!super.reset()) return false;
		const isInit = !_.isNil(this._init);
		const { field0, field1 } = this._dom;
		if (this._init && this._init[0]) field0.setValue(this._init[0]);
		else field0.reset();
		if (this._init && this._init[1]) field1.setValue(this._init[1]);
		else field1.reset();
		this.state._preValue = isInit ? this._init : null;
		this.state.value = isInit ? _.cloneDeep(this._init) : [];
		this.forceUpdate();
		return this;
	}

	$getValidateRules() {
		const { mode, separator: s, validate } = this.props;
		const _transfer = m => {
			return mode === 'year' ? moment(m, 'YYYY') :
				moment.isMoment(m) ? m.clone() :
					_.isNumber(m) || _.isDate(m) ? moment(m) :
						_.isString(m) ? moment(m, this._FORMAT || 'YYYY/MM/DD') : null;
		};
		const min = _transfer(validate && validate.min);
		const max = _transfer(validate && validate.max);
		return {
			required: false,
			infinity: 'none',
			...this.props.validate,
			min: min && min.isAfter(RDate.MIN) ? min : RDate.MIN,
			max: max && max.isBefore(RDate.MAX) ? max : RDate.MAX,
		};
	}

	_validate(start, end) {
		const valid0 = start.validate();
		const valid1 = end.validate();
		if (!valid0 || !valid1) return false;

		const rules = this.$getValidateRules();
		const v0 = start.getValue();
		const v1 = end.getValue();
		const msg = this.props.errorMsg || DateRange.ERROR;
		const { required, infinity, rangeMax, rangeMin } = rules;
		if (required && infinity === 'both' && !v0 && !v1) return msg.required;
		const { mode } = this.props;

		if (v0 && v1) {
			const _FORMAT = mode === 'year' ? 'YYYY' : mode === 'yearMonth' ? 'YYYY/MM' : 'YYYY/MM/DD';
			if (v0 > v1) {
				// 自動修正日期值
				if (this.props.autoReverse) {
					start.setValue(v1);
					end.setValue(v0);
					this.setState({ value: [moment(v1).format(_FORMAT), moment(v0).format(_FORMAT)] });
				} else {
					return msg.wrongOrder;
				}
			}

			const UNIT = { y: OptionUtils.getLabel('components.Input', 'unitYear'), M: OptionUtils.getLabel('components.Input', 'unitMonth'), d: OptionUtils.getLabel('components.Input', 'unitDay') };
			const m0 = moment(v0);
			const m1 = moment(v1);
			if (rangeMax) {
				const u = _.last(rangeMax).toUpperCase();
				const unit = u === 'Y' ? 'y' : u === 'M' ? 'M' : 'd';
				const length = +rangeMax.substring(0, rangeMax.length - 1);
				if (Math.abs(m0.diff(m1, unit, true)) > length)
					return LocaleUtils.i18nIdx() === 1 && length > 1 ? _.template(msg.rangeMax)({ rangeMax: `${length} ${UNIT[unit]}s`}) : _.template(msg.rangeMax)({ rangeMax: `${length} ${UNIT[unit]}`});
			}
			if (rangeMin) {
				const u = _.last(rangeMin).toUpperCase();
				const unit = u === 'Y' ? 'y' : u === 'M' ? 'M' : 'd';
				const length = +rangeMin.substring(0, rangeMin.length - 1);
				if (Math.abs(m0.diff(m1, unit, true)) < length)
					return LocaleUtils.i18nIdx() === 1 && length > 1 ? _.template(msg.rangeMin)({ rangeMin: `${length} ${UNIT[unit]}`}) : _.template(msg.rangeMin)({ rangeMin: `${length} ${UNIT[unit]}`});
			}
		}
		return true;
	}

	validate() {
		if (super.validate()) return true;

		const { field0: f0, field1: f1 } = this._dom;
		const success = this._validate(f0, f1);
		if (success !== true) {
			const msg = success === false ? ' ' : success;
			const { onError } = this.props;
			this.setState({ error: msg }, () => _.isFunction(onError) ? onError(msg, this) : null);
			return false;
		} else {
			if (this.state.error) this.setState({ error: false });
			return true;
		}
	}

	focus(cb) {
		const { enable } = this.state;
		if (!enable) return this.blur();

		return super.focus(cb);
	}

	blur(cb) {
		const { onBlur } = this.props;
		if (_.isFunction(onBlur)) onBlur();

		this.setState({ focus: false }, () => {
			const validated = this.validate();
			if (!validated) return;

			const value = this.state.value;
			if (_.isEqual(value, this.state._preValue)) return;
			if (_.isFunction(this._onUpdate)) this._onUpdate(this._transfer(value), this._transfer(this.state._preValue), this);
			this.state._preValue = _.cloneDeep(value);
		});
		return this;
	}

	_transfer(src, type) {
		if (!src) return null;
		const t = type || this.props.valueType;
		const _toMoment = m => {
			return moment.isMoment(m) ? m.clone() :
				_.isNumber(m) || _.isDate(m) ? moment(m) :
					_.isString(m) ? moment(m, this._FORMAT || 'YYYY/MM/DD') : null;
		};
		const s0 = _toMoment(src[0]), s1 = _toMoment(src[1]);
		if (t === 'date') {
			const _t = m => {
				if (!m) return null;
				const d = m.toDate();
				return Date.isValid(d) ? d : undefined;
			};
			return [_t(s0), _t(s1)];
		} else if (t === 'timestamp') {
			const _t = m => {
				if (!m) return null;
				const d = m.valueOf();
				return Number.isNaN(d) ? undefined : d;
			};
			return [_t(s0), _t(s1)];
		} else if (t === 'string') {
			const _t = m => {
				if (!m) return null;
				const d = m.format(this._FORMAT);
				return d === 'Invalid date' ? undefined : d;
			};
			return [_t(s0), _t(s1)];
		} else return undefined;
	}

	getValue(type) {
		const { enable, error } = this.state;
		if (!enable || error) return undefined;

		const { field0: start, field1: end } = this._dom;
		if (this._validate(start, end) === true) {
			const v0 = start.getValue();
			const v1 = end.getValue();
			return _.isNil(v0) && _.isNil(v1) ? undefined : [v0, v1];
		} else return undefined;
	}

	_chkSetValue(value) {
		if (_.isNil(value)) value = [null, null];
		else if (!_.isArray(value) || value.length !== 2) return false;
		const _toTS = src => {
			if (src instanceof Date) return src.getTime();
			else if (moment.isMoment(src)) return src.valueOf();
			else if (_.isNumber(src)) return src;
			else if (src && typeof src == 'string') return moment(src, 'YYYY/MM/DD').valueOf();
			else return null;
		};
		value = value.map(v => _toTS(v));
		if (value[0] && value[1]) value = _.sortBy(value);
		//const {max, min} = this.$getValidateRules();
		// TODO: validate min & max ....
		return { value };
	}

	setValue(value, cb) {
		const { enable, editable } = this.state;
		if (!enable || !editable) return false;
		const checked = this._chkSetValue(value);
		if (!checked) return false;
		const { value: _value } = checked;
		// 透過 state 更新 f0, f1
		this.setState({
			value: _value,
			_preValue: _.cloneDeep(_value),
		});
		return this;
	}

	getText() {
		const { field0: f0, field1: f1 } = this._dom;
		return [f0 ? f0.getText() : undefined, f1 ? f1.getText() : undefined];
	}

	renderPrefix() {
		const { renderPrefix } = this.props;
		return _.isFunction(renderPrefix) ? renderPrefix() : null;
	}

	$renderPickerBody() {
		const { date, mode } = this.props;
		const rules = this.$getValidateRules();
		const calendarMode = mode === 'year' ? 'year' : mode === 'yearMonth' ? 'month' : 'day'
		const noYear = mode === 'monthDate'

		return <_Calendar {...{
			mode: 'range',
			infinity: rules.infinity,
			max: rules.max,
			min: rules.min,
			rangeMax: rules.rangeMax,
			rangeMin: rules.rangeMin,
			value: this.state.value ? this.state.value : [],
			date,
			minStage: calendarMode,
			stage: calendarMode,
			onRangeSelect: d => {
				this.setState({
					value: [d[0] ? d[0].format(this._FORMAT) : null, d[1] ? d[1].format(this._FORMAT) : null],
				}, () => this.blur());
			},
			onDaySelect: () => this._dom.picker.position(),
			onMonthSlide: () => this._dom.picker.position(),
			onStageChange: () => this._dom.picker.position(),
			noYear,
		}} />;
	}

	render() {
		const { className, style, tip, isPicker, width, placeholder, disable: propDisable, readOnly: propReadOnly, valueType, menuProps, mode, valueFixed } = this.props;
		const { focus, error, enable, editable, hover, value } = this.state;
		const { required, min, max, infinity } = this.$getValidateRules();
		const disable = propDisable || !enable;
		const readOnly = propReadOnly || !editable;
		//const isRemover = (!tip || (tip && hover)) && (infinity === 'both' && !required && (value[0] || value[1]));
		return <>
			<div {...{
				ref: ele => this._dom.root = ele,
				className: `H2-TextRange form-control${focus ? ' focus' : ''}${error ? ' error' : ''}${enable ? '' : ' disable'}${editable ? '' : ' readOnly'}${className ? ` ${className}` : ''}`,
				onClick: enable && editable ? evt => this.focus() : null,
				style: {
					...style ? style : null,
					...width ? { width } : null,
					// ... maxWidth ? { maxWidth, width: 'auto' } : null,
					// ... minWidth ? { minWidth, width: 'auto' } : null,
				},
				// ... tip || error ? {
				onMouseEnter: evt => {
					if (!enable || !editable || hover) return;
					this.setState({ hover: true }, () => {
						if (this.props.onMouseEnter) this.props.onMouseEnter();
					});
				},
				onMouseLeave: evt => {
					if (!enable || !editable || !hover) return;
					this.setState({ hover: false }, () => {
						if (this.props.onMouseLeave) this.props.onMouseLeave();
					});
				},
				// } : null,
			}}>
				{this.renderPrefix()}
				<RDate {...{
					ref: ele => this._dom.field0 = ele,
					disable, readOnly,
					valueFixed,
					isPicker: false,
					theme: 'empty',
					width: 'calc(50% - 21px)',
					suffix: false,
					placeholder: (placeholder && placeholder[0]) || 'YYYY/MM/DD',
					value: value?.[0] || '',
					valueType, mode,
					validate: {
						required: !focus && (
							(required && (infinity === 'none' || infinity === 'right')) ||
							(!required && value[1] && (infinity === 'none' || infinity === 'right'))
						),
						...max ? { max } : null,
						...min ? { min } : null,
					},
					onClick: evt => this.setState({ focus: true }),
					onUpdate: v => {
						this.state.value[0] = v;
						const ok = this.validate();
						if (!ok || this.state.focus) return;
						const value = this.state.value;
						if (_.isEqual(value, this.state._preValue)) return;
						if (_.isFunction(this._onUpdate)) this._onUpdate(this._transfer(value), this._transfer(this.state._preValue), this);
						this.state._preValue = _.cloneDeep(value);
					},
					tip: false,
				}} />
				<i className={'fal fa-minus'} />
				<RDate {...{
					ref: ele => this._dom.field1 = ele,
					disable, readOnly,
					valueFixed,
					isPicker: false,
					theme: 'empty',
					width: 'calc(50% - 21px)',
					suffix: false,
					placeholder: (placeholder && placeholder[1]) || 'YYYY/MM/DD',
					value: value?.[1] || '',
					valueType, mode,
					validate: {
						required: !focus && (
							(required && (infinity === 'none' || infinity === 'left')) ||
							(!required && value[0] && (infinity === 'none' || infinity === 'right'))
						),
						...max ? { max } : null,
						...min ? { min } : null,
					},
					onClick: evt => this.setState({ focus: true }),
					onUpdate: v => {
						this.state.value[1] = v;
						const ok = this.validate();
						if (!ok || this.state.focus) return;
						const value = this.state.value;
						if (_.isEqual(value, this.state._preValue)) return;
						if (_.isFunction(this._onUpdate)) this._onUpdate(this._transfer(value), this._transfer(this.state._preValue), this);
						this.state._preValue = _.cloneDeep(value);
					},
					tip: false,
				}} />
				{
					(error && error !== ' ' && hover) ? <Tip {...{
							stick: this._dom.root,
							stickDirection: 'top',
							stickAlign: 1,
							theme: 'validate',
						}}>{error}</Tip> :
						(hover && tip && (value[0] || value[1])) ? <Tip {...{
							stick: this._dom.root,
							stickDirection: 'top',
							stickAlign: -1,
						}}>{tip}</Tip> : null
				}
				<span {...{
					ref: ele => this._dom.suffix = ele,
					className: `-suffix light`,
					style: { width: 24 },
				}}><i className={'fal fa-calendar-week'} /></span>
				{<MobileContext.Consumer>
					{isMobile => !required && (isMobile || hover) && value && _.filter(value, v => !_.isNil(v)).length > 0 && <i {...{
						className: '-remover btn btn-sm square btn-danger fa fa-trash-alt',
						onClick: evt => {
							if (!enable || !editable) return;
							evt.stopPropagation();
							this.state._preValue = [null, null];
							this.state.value = [null, null];
							this.state.focus = false;
							this.forceUpdate(() => this._onUpdate ? this._onUpdate() : null);
						},
					}} />}
				</MobileContext.Consumer>}
			</div>
			{enable && editable && focus && isPicker ? <Box {...{
				ref: ele => this._dom.picker = ele,
				stick: this._dom.root,
				stickDirection: 'ver',
				stickAlign: -1,
				//stickOffset: {y: 10, x:-20},
				theme: 'pickerMenu',
				close: this.blur,
				clickExcludes: this._dom.root,
				...menuProps,
			}}>{this.$renderPickerBody()}</Box> : null}
		</>;
	}
}

class YearMonth extends RDate {
	static version = '0.0.1';
	static defaultProps = {
		...RDate.defaultProps,
		mode: 'yearMonth',
		placeholder: 'YYYY/MM',
	};

	// RDate 跟它的 SubClass 耦合太深了...
}

class Time extends RDate {
	static version = '0.1.2';
	static defaultProps = {
		...RDate.defaultProps,
		mode: 'time',
		placeholder: 'hh:mm',
		valueType: 'string',
	};

	$getValidateRules() {
		const { min, max } = this.props.validate || {};
		let _min = '00:00', _max = '23:59';
		if (min && min > _min) _min = min;
		if (max && max < _max) _max = max;
		return {
			...this.props.validate || {},
			regexp: /^(2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$/i,
			min: _min,
			max: _max,
		};
	}

	$renderPickerBody() {
		const rules = this.$getValidateRules();
		return <_Clock {...{
			max: rules.max,
			min: rules.min,
			value: this.state.value,
			onHourPick: hm => this.setState({ fieldValue: hm }),
			onMinutePick: hm => this.setState({ fieldValue: hm }),
			onComplete: hm => {
				if (_.isEqual(hm, this.state._preValue)) {
					this.setState({ focus: false });
				} else {
					const m = _toMoment(hm, 'time', this.state.valueFormat);
					this.setState({
						focus: false,
						fieldValue: m.format(this.state.fieldFormat),
					});
				}
			},
			onlyHour: this.props.onlyHour,
		}} />;
	}
}

class TimeRange extends TextRange {
	static version = '0.9.2';
	static propTypes = {
		...TextRange.PropTypes,
	};
	static defaultProps = {
		...TextRange.defaultProps,
		autoSwitch: false, // PM 其實沒這個需求，還會造成日曆元件類手動輸入直接送出的時間差問題
		onlyHour: false, // 只有小時選項
	};

	$renderInput(i = 0) {
		const { _init, _dom } = this;
		const { placeholder, disable, readOnly, onUpdate, valueFixed, renderPrefix, onlyHour } = this.props;
		const { _preValue, focus, value } = this.state;

		const rule = this.$getValidateRules();
		const max = rule.max || '23:59';
		const min = rule.min || '00:00';
		const { field0: f0, field1: f1 } = this._dom;
		const v0 = f0 && f0._validate() === true ? f0.state.value : null;
		const v1 = f1 && f1._validate() === true ? f1.state.value : null;
		return <>
			{renderPrefix ? renderPrefix(this.getValue(), i) : null}
			<Time {...{
				ref: ele => _dom[`field${i}`] = ele,
				disable, readOnly,
				valueFixed,
				validate: !renderPrefix && (i === 0 ? {
					min, max: v1 || max
				} : {
					min: v0 || min, max
				}),
				theme: 'empty',
				placeholder: placeholder && placeholder[i],
				tip: false,
				suffix: false,
				menuProps: {
					clickExcludes: this._dom.root,
				},
				..._init[i] ? { initValue: _init[i] } : null,
				value: value[i] || '',
				onClick: evt => {
					evt.stopPropagation();
					if (focus) {
						const alt = this._dom[`field${i === 0 ? 1 : 0}`];
						alt.setState({ focus: false });
					} else this.setState({ focus: true });
				},
				onUpdate: v => {
					this.state.value[i] = v;
					this.forceUpdate();
					if (v && !this.state.value[i === 0 ? 1 : 0])
						this._dom[`field${i === 0 ? 1 : 0}`].setState({ focus: true });
				},
				onError: (err, _this) => {
					_this.setState({ error: false });
					this.setState({ error: err });
				},
				onEditing: v => {
					const valueFormat = 'HH:mm'
					const { value  } = this.state;
					const m = _toMoment(v, 'datetime', valueFormat, true);
					if (m && m.isValid()) {
						const vs = value ? [...value] : undefined;
						if (vs?.length > 0) vs[i] = this.props.valueFixed ? m.format(valueFormat) : v;
						this.setState({ value: vs });
					}
				},
				onBlur: this._onBlur.bind(this, i),
				onlyHour,
				...onlyHour ? {
					menuProps: {
						wrapperStyle: { minWidth: 80 },
					},
					mode: 'hour',
				} : {}
				// onMenuClose: (evt, _this) => {
				// 	if(!evt || (evt && evt.type === 'keyup')) return _this.blur();
				// 	const alt = this._dom[`field${i === 0 ? 1 : 0}`];
				// 	if(rule.required && _this.state.value && !alt.state.value){
				// 		alt.focus();
				// 		_this.setState({focus: false});
				// 	}
				// 	else _this.blur();
				// },
				// onUpdate: () => this.forceUpdate(),
			}} />
		</>;
	}

	$renderSuffix() {
		return <span {...{
			className: `-suffix light`,
			style: { width: 24 },
		}}><i className={'fal fa-clock'} /></span>;
	}
}

class DateTime extends RDate {
	static version = '0.1.2';
	static defaultProps = {
		...RDate.defaultProps,
		mode: 'datetime',
		stage: 'day',
		placeholder: 'YYYY/MM/DD hh:mm',
	};
	state = {
		...this.state,
		stage: this.props.stage,
	};

	reset() {
		if (!super.reset()) return false;
		this.setState({ datePart: undefined });
		return this;
	}

	$renderPickerBody() {
		const { field } = this._dom;
		const { separator: s } = this.props;
		const { datePart, timePart, value, stage } = this.state;
		const rules = this.$getValidateRules();
		// 完整
		const regexp0 = new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$`);
		// 分未填
		const regexp1 = new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|1[0-9]|[0-9]|[01][0-9]):$`);
		// 時未填
		const regexp2 = new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1]) :([0-9]|[0-5][0-9])$`);
		// 日期未填
		const regexp3 = new RegExp(`^\s?(2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$`);
		// 時間未填
		const regexp4 = new RegExp(`^[0-9]{4}\\${s}([1-9]|0[1-9]|1[0-2])\\${s}([1-9]|0[1-9]|[1-2][0-9]|3[0-1])`);
		// 僅填時
		const regexp5 = new RegExp(`^\s?(2[0-3]|1[0-9]|[0-9]|[01][0-9]):$`);
		// 僅填分
		const regexp6 = new RegExp(`^\s?:([0-9]|[0-5][0-9])$`);
		const calendar = <_Calendar {...{
			max: rules.max,
			min: rules.min,
			stage: stage,
			value: _toMoment(value, 'datetime', `YYYY${s}MM${s}DD`)?.startOf('day'),
			onDaySelect: d => {
				let fieldValue = field.value;
				const complete = fieldValue && (fieldValue.test(regexp0) || fieldValue.test(regexp3));
				if (fieldValue && fieldValue.trim().length > 0) {
					if (fieldValue.test(regexp0)) fieldValue = d.format(`YYYY${s}MM${s}DD`) + fieldValue.substring(10);
					else if (fieldValue.test(regexp1) || fieldValue.test(regexp2)) fieldValue = d.format(`YYYY${s}MM${s}DD`) + fieldValue.substring(10);
					else if (fieldValue.test(regexp3) || fieldValue.test(regexp5) || fieldValue.test(regexp6)) fieldValue = d.format(`YYYY${s}MM${s}DD`) + (fieldValue.charAt(0) == ' ' ? '' : ' ') + fieldValue;
					else if (fieldValue.test(regexp4)) fieldValue = d.format(`YYYY${s}MM${s}DD`);
				} else fieldValue = d.format(`YYYY${s}MM${s}DD`);
				this.setState({
					fieldValue,
					focus: !complete,
					datePart: d.format('YYYY/MM/DD'),
				});
			},
			onMonthSlide: () => this._dom.picker.position(),
			onStageChange: stage => {
				this._dom.picker.position();
				this.setState({ stage: stage });
			},
		}} />;
		const _onPick = time => {
			let fieldValue = field.value;
			if (fieldValue && fieldValue.trim().length > 0) {
				if (fieldValue.test(regexp0) || fieldValue.test(regexp1) || fieldValue.test(regexp2)) fieldValue = fieldValue.substring(0, 11) + time;
				else if (fieldValue.test(regexp3)) fieldValue = time;
				else if (fieldValue.test(regexp4)) fieldValue = fieldValue + ' ' + time;
				else if (fieldValue.test(regexp5) || fieldValue.test(regexp6)) fieldValue = time;
			} else fieldValue = time;
			this.setState({ fieldValue });
		};
		const clock = <_Clock {...{
			key: datePart || '_clock',
			...datePart && datePart == rules.min.format('YYYY/MM/DD') ? { min: rules.min.format('HH:mm') } : null,
			...datePart && datePart == rules.max.format('YYYY/MM/DD') ? { max: rules.max.format('HH:mm') } : null,
			value: value && value.length > 11 ? value.substring(11) : null,
			onHourPick: _onPick,
			onMinutePick: _onPick,
			onComplete: time => {
				let fieldValue = field.value;
				let complete = false;
				if (fieldValue && fieldValue.trim().length > 0) {
					if (fieldValue.test(regexp0) || fieldValue.test(regexp1) || fieldValue.test(regexp2)) fieldValue = fieldValue.substring(0, 11) + time;
					else if (fieldValue.test(regexp3)) fieldValue = time;
					else if (fieldValue.test(regexp4)) fieldValue = fieldValue + ' ' + time;
					else if (fieldValue.test(regexp5) || fieldValue.test(regexp6)) fieldValue = time;
					complete = fieldValue.test(regexp0);
				} else fieldValue = time;
				this.setState({
					fieldValue,
					focus: !complete,
				});
			},
		}} />;
		return <table>
			<tbody>
			<tr>
				<td style={{ paddingRight: 5, verticalAlign: 'top' }}>{calendar}</td>
				{stage == 'day' ? <td style={{
					borderLeft: '1px solid #CCC',
					paddingLeft: 5,
				}}>{clock}</td> : null}
			</tr>
			</tbody>
		</table>;
	}
}

class DateTimeRange extends TextRange {
	static version = '0.9.2';
	static propTypes = {
		...TextRange.PropTypes,
	};
	static defaultProps = {
		...TextRange.defaultProps,
		valueType: 'timestamp', 			// 'date', 'timestamp', or 'string'
		valueFixed: false, // 是否已修正 onUpdate 回傳值型別跟 valueType 不符的問題
		autoSwitch: false, // 不要再把這個打開了，PM 沒這個需求，還會造成日曆元件類手動輸入直接送出的時間差問題
	};
	static ERROR = {
		...TextRange.ERROR,
		datetime: OptionUtils.getLabel('components.Input', 'pleaseEnterTheDatetimeFormat'),
	};

	constructor(props) {
		super(props);

		this.state.fieldFormat = __defineFieldFormat('datetime', '/');
		this.state.valueFormat = __defineValueFormat('datetime', '/');

		delete this.state.fieldValue; // Range 類用不到
	}

	$init() {
		const { value, initValue, onUpdate } = this.props;
		if (initValue) {
			// 因為會有人拿 YYYY/MM/DD HH:mm:ss 字串來 setValue，所以只好讓 isStrict 可以是 false...
			const checked = this.__validate(initValue, false);
			const { target, msg, value: _value } = checked;
			this._init = _.cloneDeep(_value);
			this.state.value = _.cloneDeep(_value);
			this.state._preValue = _.cloneDeep(_value);
			this.state.errorTarget = target;
			this.state.error = target ? msg || 'error' : undefined;
		}
		if (value) {
			// 因為會有人拿 YYYY/MM/DD HH:mm:ss 字串來 setValue，所以只好讓 isStrict 可以是 false...
			const checked = this.__validate(value, false);
			const { target, msg, value: _value } = checked;
			this.state.value = _.cloneDeep(_value);
			this.state._preValue = _.cloneDeep(_value);
			this.state.errorTarget = target;
			this.state.error = target ? msg || 'error' : undefined;
		}

		// 唉...
		if (onUpdate && _.isFunction(onUpdate)) this._onUpdate = onUpdate;
	}

	$getValidateRules() {
		const rules = super.$getValidateRules();
		const { max, min } = rules;
		if (max) rules.max = _toMoment(max, 'datetime', this.state.fieldFormat, true);
		if (min) rules.min = _toMoment(min, 'datetime', this.state.fieldFormat, true);
		return rules;
	}

	/**
	 * 因為會有人拿 YYYY/MM/DD HH:mm:ss 字串來 setValue，所以只好讓 isStrict 可以是 false...
	 * @param {*} value
	 * @param {boolean} [isStrict] 如果 value 是字串時，是否嚴格比對 fieldFormat
	 * @returns {{value:[string|undefined, string|undefined], target?:*, msg?:string}}
	 * @private
	 */
	__validate(value, isStrict = true) {
		const msg = this.props.errorMsg || DateTimeRange.ERROR;
		const { fieldFormat, valueFormat } = this.state;
		const { required, max, min, infinity } = this.$getValidateRules();
		// max, min 已是 moment 或 null

		const [v0, v1] = value || [];
		const moment0 = _toMoment(v0, 'datetime', fieldFormat, isStrict);
		const moment1 = _toMoment(v1, 'datetime', fieldFormat, isStrict);

		// 不管使用者用哪種格式設定值，元件內部運作都用字串紀錄。方便 debug 或再做進一步轉換。
		const _v0 = moment0 && moment0.isValid() && moment0.format(valueFormat) || undefined;
		const _v1 = moment1 && moment1.isValid() && moment1.format(valueFormat) || undefined;

		// 格式不對
		if (moment0 && !moment0.isValid())
			return { target: 'f0', msg: msg.datetime, value: [_v0, _v1] };
		if (moment1 && !moment1.isValid())
			return { target: 'f1', msg: msg.datetime, value: [_v0, _v1] };

		const noLeft = _.isNil(moment0);
		const noRight = _.isNil(moment1);
		if (!required && noLeft && noRight)
			// 非必填，而且左右都沒填的話，不用檢查任何東西
			return { value: [undefined, undefined] };
		else {
			// 必填，而且全都沒填的話，顯示必填提示
			if (required && noLeft && noRight)
				return { target: 'root', msg: msg.required, value: [undefined, undefined] };
			// 左邊該填卻沒填，顯示左邊必填提示
			if (noLeft && (infinity === 'right' || infinity === 'none'))
				return { target: 'f0', msg: msg.startRequired, value: [undefined, _v1] };
			// 右邊該填卻沒填，顯示右邊必填提示
			if (noRight && (infinity === 'left' || infinity === 'none'))
				return { target: 'f1', msg: msg.endRequired, value: [_v0, undefined] };
		}

		// 超出區間
		if (moment0?.isValid()) {
			if (min && moment0.isBefore(min))
				return {
					target: 'f0', msg: _.template(msg.startOutOfMin)({ min: min.format(fieldFormat) }),
					value: [_v0, _v1],
				};
			if (max && moment0.isAfter(max))
				return {
					target: 'f0', msg: _.template(msg.startOutOfMax)({ max: max.format(fieldFormat) }),
					value: [_v0, _v1],
				};
		}
		if (moment1?.isValid()) {
			if (min && moment1.isBefore(min))
				return {
					target: 'f1', msg: _.template(msg.endOutOfMin)({ min: min.format(fieldFormat) }),
					value: [_v0, _v1],
				};
			if (max && moment1.isAfter(max))
				return {
					target: 'f1', msg: _.template(msg.endOutOfMax)({ max: max.format(fieldFormat) }),
					value: [_v0, _v1],
				};
		}
		if (moment0?.isValid() && moment1?.isValid() && moment0?.isAfter(moment1))
			return {
				target: 'root',
				msg: msg.startAfterEnd,
				value: [_v0, _v1],
			};
		return { value: [_v0, _v1] };
	}

	getValue() {
		const { enable, error } = this.state;
		if (!enable || error) return this._init; // TextRange 的行為...

		const { field0, field1 } = this._dom;
		// TODO validate?
		const v0 = field0.getValue();
		const v1 = field1.getValue();
		// TextRange 系列如果前後都無值，不是回傳 undefined，而是 [undefined, undefined] 的 array...
		return [v0, v1];
	}

	setValue(value, cb) {
		const { enable, editable } = this.state;
		if (!enable || !editable) return false;

		// 因為會有人拿 YYYY/MM/DD HH:mm:ss 字串來 setValue，所以只好讓 isStrict 可以是 false...
		const checked = this.__validate(value, false);
		const { target, msg, value: _value } = checked;

		if (target) {
			let errorTarget;
			if (target === 'root') errorTarget = this._dom.root;
			else if (target === 'f0') errorTarget = this._dom.field0._dom.root;
			else if (target === 'f1') errorTarget = this._dom.field1._dom.root;
			this.setState({
				errorTarget, error: msg || 'error',
				value: _.cloneDeep(_value),
			});
			return this;
		}
		this.setState({
			errorTarget: undefined,
			error: undefined,
			value: _.cloneDeep(_value),
			_preValue: _.cloneDeep(_value),
		});

		return this;
	}

	_validate(v0, v1) {
		v0 = v0 || this._dom.field0?.state.fieldValue || undefined;
		v1 = v1 || this._dom.field1?.state.fieldValue || undefined;
		const checked = this.__validate(v0 || v1 ? [v0, v1] : undefined);
		const { target: errorTarget, msg, value: _value } = checked;
		if (!errorTarget) return true;
		return msg || false;
	}

	$renderInput(i = 0) {
		const { _init, _dom } = this;
		const { placeholder, disable, readOnly, onUpdate, valueType, valueFixed } = this.props;
		const { _preValue, focus, value } = this.state;

		const rule = this.$getValidateRules();
		const max = rule.max;
		const min = rule.min;
		const { field0: f0, field1: f1 } = this._dom;
		const v0 = f0 && f0._validate() === true ? f0.state.value : null;
		const v1 = f1 && f1._validate() === true ? f1.state.value : null;
		return <DateTime {...{
			ref: ele => _dom[`field${i}`] = ele,
			disable, readOnly,
			validate: i === 0 ? { min, max: v1 || max } : { min: v0 || min, max },
			theme: 'empty',
			placeholder: placeholder && placeholder[i],
			tip: false,
			suffix: false,
			menuProps: {
				clickExcludes: this._dom.root,
			},
			valueFixed,
			valueType,
			..._init[i] ? { initValue: _init[i] } : null,
			value: value[i] || '',
			onClick: evt => {
				evt.stopPropagation();
				if (focus) {
					const alt = this._dom[`field${i === 0 ? 1 : 0}`];
					alt.setState({ focus: false });
				} else this.setState({ focus: true });
			},
			onUpdate: v => {
				if (this.props.valueFixed) {
					// 修正後，會回傳 valueType 格式，需再轉成 valueFormat
					const { valueFormat } = this.state;
					const m = _toMoment(v, 'datetime', valueFormat, true);
					this.state.value[i] = m && m.isValid() && m.format(valueFormat) || undefined;
				} else {
					// 未修正前，onUpdate 都回傳 string
					this.state.value[i] = v;
				}

				this.forceUpdate();
				if (rule.required && v && !this.state.value[i === 0 ? 1 : 0])
					this._dom[`field${i === 0 ? 1 : 0}`].setState({ focus: true });
			},
			onEditing: v => {
				const { value, valueFormat } = this.state;
				const m = _toMoment(v, 'datetime', valueFormat, true);
				// 手動編輯日期欄位時，只在符合日期格式時才觸發 DateTime 的 setState()
				// 不符合日期格式的就交給外層的 DateTimeRange 處理
				if (m && m.isValid()) {
					const vs = value ? [...value] : undefined;
					if (vs?.length > 0) vs[i] = this.props.valueFixed ? m.format(valueFormat) : v;
					this.setState({ value: vs });
				}
			},
			onError: (err, _this) => {
				_this.setState({ error: false });
				// this.setState({ error: err });
				this.setState(state => state.error ? {} : { error: err });
			},
			onBlur: this._onBlur.bind(this, i),
		}} />;
	}

	$renderSuffix() {
		return <span {...{
			className: `-suffix light`,
			style: { width: 24 },
		}}><i className={'fal fa-calendar-minus'} /></span>;
	}
}

const _TDAY = {
	'1900/01/01': OptionUtils.getLabel('components.Input', 'theDayBeforeYesterday'),
	'1900/01/02': OptionUtils.getLabel('components.Input', 'day'),
	'1900/01/03': OptionUtils.getLabel('components.Input', 'next'),
};

class ComboTime extends RDate {
	static version = '0.1.2';
	static propTypes = {
		...RDate.PropTypes,
		mode: PropTypes.oneOf(['time']),
		valueType: PropTypes.oneOf(['string']),
	};
	static defaultProps = {
		...RDate.defaultProps,
		prefix: true,
		mode: 'time',
		placeholder: 'hh:mm',
		valueType: 'string',
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		time: OptionUtils.getLabel('components.Input', 'pleaseEnterTheTimeFormat'),
		max: OptionUtils.getLabel('components.Input', 'mustBeLessThan'),
		min: OptionUtils.getLabel('components.Input', 'mustBeGreaterThan'),
	};

	constructor(props) {
		super(props);

		const rules = this.$getValidateRules();
		const keys = _.keys(_.pickBy(_TDAY, (value, prop) => rules.min.substring(0, 10) <= prop && prop <= rules.max.substring(0, 10)));
		if (keys.length === 3) this._initPrefix = this.state.prefix = keys[1];
		else if (keys.length === 2) this._initPrefix = this.state.prefix = '1900/01/02';
		else this._initPrefix = this.state.prefix = keys[0];

		const { initValue, value } = props;
		if (!_.isNil(initValue)) {
			const checked = this._chkSetValue(initValue);
			if (checked) {
				const { value, fieldValue } = checked;
				this._initPrefix = this.state.prefix = value.substring(0, 10);
				this._init = this.state._preValue = this.state._value = this.state.value = value;
				this.state.fieldValue = fieldValue;
			}
		}
		if (!_.isNil(value)) {
			const checked = this._chkSetValue(value);
			if (checked) {
				const { value, fieldValue } = checked;
				this.state.prefix = value.substring(0, 10);
				this.state._preValue = this.state._value = this.state.value = value;
				this.state.fieldValue = fieldValue;
			}
		}
	}

	static getDerivedStateFromProps(props, state) {
		const s = RDate.getDerivedStateFromProps(props, state);
		if (!s) return null;

		if (s.value) {
			s.prefix = s.value.substring(0, 10);
		}
		if (s._reValid) {
			const rules = ComboTime.genRules(props.validate);
			const data = _.pickBy(_TDAY, (value, prop) => rules.min.substring(0, 10) <= prop && prop <= rules.max.substring(0, 10));
			if (!data[state.prefix]) {
				// data 一定是 1~3 筆資料，3 的話不可能進來這裡
				if (_.size(data) === 1) s.prefix = _.keys(data)[0];
				else s.prefix = '1900/01/02';
			}
		}

		return s;
	}

	_defineValueFormat(mode, s) {
		return `YYYY${s}MM${s}DD HH:mm`;
	}

	$isOpenMenu() {
		return !this.state.isPrefixMenuOpen;
	}

	blur(cb) {
		if (!this._dom.field) return; // 當 ComboTimeRange 直接切換兩個的 prefix 時，field 會先 null
		super.blur(cb);
	}

	reset(cb) {
		if (!this._mounted) return false;
		const { enable, editable } = this.state;
		if (!enable || !editable) return false;
		const isInit = !_.isNil(this._init);

		if (!isInit) {
			this.setState({
				prefix: this._initPrefix,
				value: undefined,
				_preValue: undefined,
				fieldValue: '',
				focus: false,
				error: false,
			}, cb);
			return;
		}
		const { value, fieldValue } = this._chkSetValue(this._init);
		this.setState({
			prefix: value.substring(0, 10),
			value,
			_preValue: value,
			fieldValue,
			focus: false,
			error: false,
		}, cb);
		return this;
	}

	renderPrefix({ className, ico, text, width, theme, onClick }) {
		const { prefix } = this.state;
		const rules = this.$getValidateRules();
		const data = _.pickBy(_TDAY, (value, prop) => rules.min.substring(0, 10) <= prop && prop <= rules.max.substring(0, 10));
		return _.size(data) > 1 ? <span {...{
			className: `-prefix empty`,
			style: { width: 53, marginRight: -6 },
		}}>
			<Select {...{
				ref: ele => this._dom.prefix = ele,
				className: 'sm empty',
				data,
				// initValue: prefix,
				value: prefix,
				menuProps: {
					className: 'level2',
					stickDirection: 'top',
					stickOffset: { x: -5, y: -5 },
					pointer: 'bottom',
					pointerClassName: 'sm',
				},
				onMenuClose: (evt, _this) => {
					const validated = this._validate(this._dom.field.value);
					if (validated !== true) return;

					const _isContains = regions => _.some(evt.composedPath(), t => _.some(regions, e => e === t));
					if (!evt || (evt && (evt.type === 'keyup' || !_isContains([this._dom.root])))) return _this.blur(this.blur);
					else _this.blur();
				},
				onFocus: () => this.setState({ isPrefixMenuOpen: true, focus: true }),
				onBlur: () => this.setState({ isPrefixMenuOpen: false }),
				onUpdate: v => {
					const { onPrefixUpdate } = this.props;
					const validated = this._validate(this._dom.field.value, v);
					if (validated === true) {
						this.setState({
							prefix: v,
							focus: false,
							error: false,
							isPrefixMenuOpen: false,
						}, () => onPrefixUpdate ? onPrefixUpdate(v) : null);
					} else setTimeout(() => this.setState({ // TODO 為什麼要設 timeout??
						prefix: v,
						fieldValue: '',
						error: false,
						focus: true,
						isPrefixMenuOpen: false,
					}, () => this._dom.field.focus()), 0);
				},
			}} />
		</span> : <small style={{ paddingLeft: 10, marginRight: -6, lineHeight: '28px', whiteSpace: 'nowrap' }}>
			{_.values(data)[0]}<i className={'fal fa-fw fa-angle-right'} />
		</small>;
	}

	alignValues() {
		const { valueFormat } = this.state;
		const f = this._dom.field;
		const fieldValue = f.value + '';
		if (fieldValue.length > 3) {
			let v = fieldValue.substring(0, 4);
			if (v.test(/^[0-9]{4}$/i)) {
				v = v.substring(0, 2) + ':' + v.substring(2, 4);
				const m = _toMoment(this.state.prefix + ' ' + v, 'time', 'YYYY/MM/DD HH:mm');
				return {
					value: m && m.isValid() && m.format(valueFormat) || undefined,
					fieldValue: v,
				};
			}
		}
		const m = _toMoment(this.state.prefix + ' ' + fieldValue, 'time', 'YYYY/MM/DD HH:mm', true);
		return {
			value: m && m.isValid() && m.format(valueFormat) || undefined,
			fieldValue,
		};
	}

	_getValue(value) {
		if (_.isEmpty(value) || value === 0) return undefined;
		const { valueFormat } = this.state;
		const m = _toMoment(value, 'time', valueFormat);
		if (!m || !m.isValid()) return undefined;
		return m.format(valueFormat);
	}

	_chkSetValue(value) {
		const { valueFormat } = this.state;
		if (!valueFormat) return false;

		const m = _toMoment(value, 'time', valueFormat);
		if (!m || !m.isValid()) return false;

		value = m.format(valueFormat);
		const time = m.format('HH:mm');
		const day = m.format('YYYY/MM/DD');
		if (this._validate(time, day) !== true) return false;

		return {
			value,
			fieldValue: time,
		};
	}

	setValue(v) {
		const checked = this._chkSetValue(v);
		if (!checked) return;
		const { value, fieldValue } = checked;
		const { value: currValue } = this.state;
		if (_.isEqual(value, currValue)) return false;
		const prefix = value.substring(0, 10);
		if (this._dom.prefix) this._dom.prefix.setValue(prefix);
		this.setState({
			prefix,
			value,
			_preValue: value,
			fieldValue,
			error: false,
		});
		return this;
	}

	getText() {
		const { prefix } = this._dom;
		const rules = this.$getValidateRules();
		const data = _.pickBy(_TDAY, (value, prop) => rules.min.substring(0, 10) <= prop && prop <= rules.max.substring(0, 10));
		return (prefix ? prefix.getText() : _.values(data)[0]) + ' ' + super.getText();
	}

	static genRules = (validate = {}) => {
		const { min, max } = validate;
		let _min = '1900/01/01 00:00', _max = '1900/01/03 23:59';
		if (min && min > _min) _min = min;
		if (max && max < _max) _max = max;
		return {
			...validate,
			regexp: /^(2[0-3]|1[0-9]|[0-9]|[01][0-9]):([0-9]|[0-5][0-9])$/i,
			min: _min,
			max: _max,
		};
	};
	$getValidateRules() {
		return ComboTime.genRules(this.props.validate);
	}

	$renderPickerBody() {
		const { prefix } = this.state;
		const rules = this.$getValidateRules();
		return <_Clock {...{
			key: prefix,
			...rules.max.substring(0, 10) === prefix ? { max: rules.max.substring(11, 16) } : null,
			...rules.min.substring(0, 10) === prefix ? { min: rules.min.substring(11, 16) } : null,
			value: this.state.fieldValue,
			onHourPick: hm => this.setState({ fieldValue: hm }),
			onMinutePick: hm => this.setState({ fieldValue: hm }),
			onComplete: hm => {
				const value = prefix + ' ' + hm;
				if (_.isEqual(value, this.state._preValue)) {
					this.setState({ focus: false });
				} else {
					this.setState({
						focus: false,
						fieldValue: hm,
					});
				}
			},
		}} />;
	}

	_validate(time = this.state.fieldValue, day = this.state.prefix) {
		const rules = this.$getValidateRules();
		const msg = this.props.errorMsg || ComboTime.ERROR;
		const { required, regexp, max, min } = rules;
		if ((time || '').length === 0) return required ? msg.required : true;
		if (regexp && !time.test(regexp)) return msg['time'];

		const v = moment(day + ' ' + time, 'YYYY/MM/DD HH:mm:00');
		if (max) {
			const m = moment(max, 'YYYY/MM/DD HH:mm:00');
			if (m.isBefore(v)) return _.template(msg.max)({ max: _TDAY[max.substring(0, 10)] + ' ' + max.substring(11, 16) });
		}
		if (min) {
			const m = moment(min, 'YYYY/MM/DD HH:mm:00');
			if (m.isAfter(v)) return _.template(msg.min)({ min: _TDAY[min.substring(0, 10)] + ' ' + min.substring(11, 16) });
		}
		return true;
	}
}

class ComboTimeRange extends TextRange {
	static version = '0.1.0';
	static defaultProps = {
		...TimeRange.defaultProps,
		infinity: 'none',
		autoSwitch: false, // 不要再把這個打開了，PM 沒這個需求，還會造成日曆元件類手動輸入直接送出的時間差問題
		placeholder: [OptionUtils.getLabel('global.normal', 'startTime'), OptionUtils.getLabel('global.normal', 'endTime')],
		className: 'alignLeft',
	};

	componentDidMount() {
		super.componentDidMount();
		if (this.props.initValue || this.props.value) this.forceUpdate();
	}

	$renderInput(i = 0) {
		const { _init, _dom } = this;
		const { placeholder, disable, readOnly, valueFixed } = this.props;
		const { focus, value } = this.state;

		const rule = this.$getValidateRules();
		const max = rule.max || '1900/01/03 23:59';
		const min = rule.min || '1900/01/01 00:00';
		const { field0: f0, field1: f1 } = this._dom;
		const v0 = f0 && f0._validate() === true ? f0._getValue(f0.state.value) : null;
		const v1 = f1 && f1._validate() === true ? f1._getValue(f1.state.value) : null;
		return <ComboTime {...{
			ref: ele => _dom[`field${i}`] = ele,
			disable, readOnly,
			valueFixed,
			validate: i === 0 ? { min, max: v1 || max } : { min: v0 || min, max },
			theme: 'empty',
			placeholder: placeholder && placeholder[i],
			tip: false,
			suffix: false,
			menuProps: {
				clickExcludes: this._dom.root,
			},
			..._init[i] ? { initValue: _init[i] } : null,
			value: value[i] || '',
			onClick: evt => {
				evt.stopPropagation();
				if (focus) {
					const alt = this._dom[`field${i === 0 ? 1 : 0}`];
					// EHRMS-9639 補這段讓切換時同步資料
					alt.blur();
					alt.setState({ focus: false });
				} else this.setState({ focus: true });
			},
			onUpdate: v => {
				this.state.value[i] = v;
				this.forceUpdate();
				if (rule.required && v && !this.state.value[i === 0 ? 1 : 0])
					this._dom[`field${i === 0 ? 1 : 0}`].setState({ focus: true });
			},
			onError: (err, _this) => {
				_this.setState({ error: false });
				this.setState({ error: err });
			},
			onBlur: () => {
				const onBlur = this._onBlur.bind(this, i)
				return onBlur();
			},
		}} />;
	}

	$transferMaxMin(str) {
		return _TDAY[str.substring(0, 10)] + ' ' + str.substring(11, 16);
	}
}

const _casting = (v, valueType = 'number') => {
	if(valueType === 'number') return _.isNaN(+v) ? v : +v;
	else if(valueType === 'string') return (v + '').trim();
	else return v;
};
class ReactInputWithData extends ReactInput {
	static propTypes = {
		... ReactInput.propTypes,
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	};
	static defaultProps = {
		... ReactInput.defaultProps,
		data: undefined,
	};
	static _transformData = (data, valueType = 'number') => {
	 	if(_.isArray(data))
	 		return _.transform(data, (result, item, idx) => {
				if(_.isObject(item)) result.push(_.cloneDeep(item));
				else result.push({id: _casting(item, valueType), name: item});
			}, []);
		else if(_.isPlainObject(data))
			return _.transform(data, (result, value, key) => {
				result.push({id: _casting(key, valueType), name: value});
			}, []);
	};

	state = {
		... this.state,
		data: undefined,
		_preData: undefined,
	};

	static getDerivedStateFromProps(props, state) {
		let s = ReactInput.getDerivedStateFromProps(props, state);

		let value = props.value;
		const {_preData} = state;
		if (!_.isEqual(props.data, _preData)) {
			const data = ReactInputWithData._transformData(props.data);
			if(_.isNil(data) || _.isEmpty(data)) return s;

			if (!s) s = {};
			s.data = _.map(data, d => {
				const old = _.find(state.data, sd => sd.id === d.id);
				d._selected = old ? old._selected : false;
				return d;
			});
			s._preData = props.data;
		}
		if(_.isNil(value) || _.isEmpty(value)) return s;

		return s;
	}

	reset(){
		return !super.reset() || !this.state.data ? false : this;
	}
}

class PickerWrapper extends HAComponent {
	static version = '0.1.2';

	reset(){
		const picker = this._picker;
		if(picker) picker.reset();
		return this;
	}
	validate() {
		const picker = this._picker;
		return picker ? picker.validate() : true;
	}

	isEnable() {
		const picker = this._picker;
		return picker ? picker.isEnable() : true;
	}
	enable(cb) {
		const picker = this._picker;
		if(picker) picker.enable(cb);
		return this;
	}
	disable(cb) {
		const picker = this._picker;
		if(picker) picker.disable(cb);
		return this;
	}

	isEditable() {
		const picker = this._picker;
		return picker ? picker.isEditable() : true;
	}
	editable(cb) {
		const picker = this._picker;
		if(picker) picker.editable(cb);
		return this;
	}
	readOnly(cb) {
		const picker = this._picker;
		if(picker) picker.readOnly(cb);
		return this;
	}

	focus(cb){
		const picker = this._picker;
		if(picker) picker.focus(cb);
		return this;
	}
	blur(cb){
		const picker = this._picker;
		if(picker) picker.blur(cb);
		return this;
	}

	getValue() {
		const picker = this._picker;
		return picker ? picker.getValue() : undefined;
	}
	setValue(value, cb) {
		const picker = this._picker;
		if(!picker || !picker.state.data) return this._tempValue = value;	// 解決時間差問題
		if(picker.state.data) picker.setValue(value, cb);
		return this;
	}
	getText(){
		const picker = this._picker;
		return picker ? picker.getText() : undefined;
	}

	isError(){
		const picker = this._picker;
		return picker ? picker.isError() : true;
	}
	setError(msg){
		const picker = this._picker;
		if(picker) picker.setError(msg);
		return this;
	}
	clearError(){
		const picker = this._picker;
		if(picker) picker.clearError();
		return this;
	}
}
class DataLoader extends PickerWrapper{
	static version = '1.0.1';
	static propTypes = {
		bid: PropTypes.number,
		component: PropTypes.oneOf(['Picker', 'Select', 'Radio', 'ToggleButton', 'TreePicker']),
		api: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
		method: PropTypes.string,
		filter: PropTypes.func,
		isCache: PropTypes.bool,
		dataExcludes: PropTypes.array,
		// 保證當前選中的資料不會被 filter 掉
		includeSelf: PropTypes.bool,
	};
	static defaultProps = {
		isCache: true,
		component: 'Picker',
		// renderTag: d => <>{d.code && <><span className={'extra'}>{d.code}</span> </>}{d.name}</>,
		renderItem: d => <>{d.code && <><span className={'extra'}>{d.code}</span> </>}{d.name}</>,
		renderItemTextLabel: d => <>{d.name}</>,
		includeSelf: true,
		inactiveIsReadOnly: false,
	};
	static MULTI_COMPANY_PICKERS = ['OSCompanyPicker', 'ACAccountPicker'];
	state = {
		loading: false,
		data: null,
		updateKey: 0,
	};
	static lskey(_class, bid) {
		const CLAZZ = _class || eval(this).name;
		return [
			`DL:${CLAZZ.substring(0, 2)}:${CLAZZ.substring(2, CLAZZ.length - 6)}`,
			_.includes(DataLoader.MULTI_COMPANY_PICKERS, CLAZZ) ? '' : `:${bid || user.bid}`
		].join('');
	};

	constructor(props) {
		super(props);
		const {isCache, bid} = this.props;
		this.CACHE_KEY = DataLoader.lskey(this.constructor.name, bid);
		if(isCache && this.CACHE_KEY)
			this.state.data = this.onFetch(ls.get(this.CACHE_KEY, false));

		this.onUpdate = this.onUpdate.bind(this);
	}

	onFetch(data) { return this.props.onFetch ? this.props.onFetch(data) : data; }

	componentDidMount(){
		super.componentDidMount();
		const {bid} = this.props;

		if(!this.state.data)
			this._ajax.first = DataLoader.fetch.call(this.constructor, this.props, bid, {
				onRequest: () => this.setState({loading: true, data: null}),
				onSuccess: (data, xhr) => {
					this.setState({
						loading: false,
						data: this.onFetch(data),
					});
				},
			});
	}

	static label(value, defaultLabel, bid, render, _class, mate, textLabel ){
		const optionData = eval(this).data(bid, 0, _class);
		if(!optionData) return undefined;
		if (!render) render = textLabel ? eval(this).defaultProps.renderItemTextLabel : eval(this).defaultProps.renderItem ;

		value = _.isArray(value) ? value : [value];
		const _label = (v) => {
			if (v === -403) return '******';
			const opt = mate ? mate(optionData, v) : _.find(optionData, {id: v});
			if(!opt) return null;
			const label = _.isFunction(render) ? render(opt) : opt.name;
			return <>
				{label} {opt.hasOwnProperty('active') && !opt.active ?
					<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/> {OptionUtils.getLabel('global.normal', 'disable')}</small> : ''}
			</>;
		};
		const labels = _.compact(_.map(value, v => _label(+v)));
		return labels.length === 0 ? defaultLabel : _.map(labels, (label, idx) => <React.Fragment key={idx}>
			{label}{idx < labels.length - 1 && textLabel === 'comma' ? '、' : idx < labels.length - 1 ? ', ' : ''}
		</React.Fragment>);
	}
	static text(value, bid, _class, field = 'name') {
		const optionData = eval(this).data(bid, 0, _class);
		if(!optionData) return undefined;

		return _.isArray(value)
			? _.compact(_.map(value, v => v === -403 ? '******' : _.get(_.find(optionData, { id: v }), field)))
			: (value === -403
				? '******' : _.get(_.find(optionData, { id: value }), field, ''));
	}
	static data(bid, activeOnly = true, _class = ''){
		const CLAZZ = _class || eval(this).name;
		let raw = ls.get(DataLoader.lskey(CLAZZ, bid), false);
		if(activeOnly && raw && raw.length > 0) raw = _.filter(raw, d => !d.hasOwnProperty('active') || d.active);
		return raw;
	}
	static fetch(props, bid, options) {
		const {isCache = true, api, method, sendData} = props;
		const {onRequest, onSuccess, onError} = (options || {});

		return new _Ajax({
			url: _.isFunction(api) ? api(bid || user.bid) : api,
			method: method || 'get', data: sendData,
			onRequest,
			onSuccess: (data, xhr) => {
				const n = eval(this).name;
				if (isCache) ls.set(DataLoader.lskey(n, bid), data, false);
				_.isFunction(onSuccess) ? onSuccess(data) : null;
			},
			onError,
		}).send();
	}

	onUpdate(value, preValue) {
		const {onUpdate} = this.props;
		const fn = this._onUpdate || (_.isFunction(onUpdate) ? onUpdate : null);
		fn ? fn(this.getValue(), preValue, this) : null;
	}

	isInData(value) {
		const {data} = this.state;

		if (Array.isArray(value)) {
			return value.every(v => data.findIndex(d => d.id === v) !== -1);
		} else {
			return data.findIndex(d => d.id === value) !== -1
		}
	}

	setValue(value, cb) {
		const { includeSelf } = this.props;
		const picker = this._picker;
		if(!picker || !picker.state.data) return this._tempValue = value;	// 解決時間差問題
		if (includeSelf) {
			this.setState(preState => ({ updateKey: preState.updateKey + 1, _value: value }), () => {
				this._picker.setValue(value, cb);
			});
			return this;
		}
		if(picker.state.data) picker.setValue(value, cb);
		return this;
	}

	// 保證初始可選項之後可選
	getDataExcludes(init){
		const {dataExcludes, value, includeSelf} = this.props;
		if (!includeSelf) return dataExcludes;
		const {_value} = this.state;
		const excludes = [...dataExcludes || []];
		if(init) {
			if(Array.isArray(init)) excludes.push(...init);
			else excludes.push(init);
		}
		if (_value) {
			if (Array.isArray(_value)) excludes.push(..._value);
			else excludes.push(_value);
		};
		if (value) {
			if (Array.isArray(value)) excludes.push(...value);
			else excludes.push(value);
		}
		return excludes;
	}

	render(){
		const {component, initValue, filter, value} = this.props;
		const {_component, loading, _initValue, data, updateKey} = this.state;
		if(loading) return <Loading />;

		// 如果 value 不在 data 內，會造成元件無法再選新值
		// 遇到這個情況的 fixValueComponents 元件類型，value 就要給 undefined 的元件
		const fixValueComponents = {
			Picker: true,
			Select: true,
		};
		const componentType = _component || component || 'Picker';
		const Component = eval(componentType);
		const _init = _initValue || initValue || this._tempValue;
		if(_init) delete this._tempValue;

		return data ? <Component {... {
			... this.props,
			ref: ele => this._picker = ele,
			key: updateKey,
			data,
			dataFilter: filter,
			dataExcludes: this.getDataExcludes(_init),
			value: fixValueComponents[componentType] ? !this.isInData(value) ? undefined : value : value,
			... _init ? {initValue: _init} : null,
			renderTag: this.$renderTag || this.props.renderTag,
			onUpdate: this.onUpdate,
		}} /> : null;
	}
}
class SubDataLoader extends DataLoader{
	static version = '0.0.1';
	static propTypes = {
		... DataLoader.propTypes,
		composeValue: PropTypes.bool,
		mode: PropTypes.oneOf(['all', 'parent', 'leaf', 'singleLeaf']),
	};
	static defaultProps = {
		... DataLoader.defaultProps,
		component: 'TreePicker',
		mode: 'singleLeaf',
		composeValue: true,
		filter: d => d.active,
		renderItem: (label, idx=0, labels=[], markInActive = true) => <React.Fragment key={idx}>
			<small>{label.parent}</small>
			{markInActive && !label.parentActive ?
				<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/> {OptionUtils.getLabel('global.normal', 'disable')}</small> : ''}
			<i className={'fa fa-sm fa-caret-right'} style={{margin:'0 3px'}} />
			<span className={'color-black'}>{label.label}</span>
			{markInActive && !label.labelActive ?
				<small className={'msg sm red'}><i className={'fa fa-sm fa-exclamation-circle'}/> {OptionUtils.getLabel('global.normal', 'disable')}</small> : ''}
			{idx < labels.length - 1 ? ', ' : ''}
		</React.Fragment>
	};

	static label(value, defaultLabel, bid, render, markInActive = true){
		const optionData = eval(this).data(bid, 0);
		if(!optionData) return undefined;

		value = _.isArray(value) ? value : [value];
		const _label = (v) => {
			let label;
			_.find(optionData, parent => {
				const found = _.find(parent.children, {id: v});
				if(found) return label = {parent: parent.name, parentActive: parent.active, label: found.name, labelActive: found.active};
			});
			return label;
		};
		const labels = _.compact(_.map(value, v => _label(v)));
		return labels.length === 0 ? defaultLabel : _.map(labels, (label, idx) =>
			(render || SubDataLoader.defaultProps.renderItem)(label, idx, labels, markInActive));
	}

	constructor(props) {
		super(props);
		if(this.props.mode === 'parent')
			this.state._component = 'Picker';
		if(this.props.initValue){
			const v = this._transfer(this.props.initValue);
			if(v) this.state._initValue = v;
		}
	}

	onUpdate(value, preValue) {
		const {composeValue, mode, onUpdate} = this.props;
		const fn = this._onUpdate || (_.isFunction(onUpdate) ? onUpdate : null);
		if (!fn) return;

		let values;
		if(composeValue && mode !== 'parent') {
			const { data } = this.state;
			values = [];
			if (!_.isArray(value)) value = [value];

			_.each(data, _data => {
				if (_.includes(value, _data.id)) values.push({ parent: _data.id });
				_.each(_data.children, child => {
					if (_.includes(value, child.id)) values.push({ parent: _data.id, value: child.id });
				});
			});

			values = values.length === 0 ? undefined : values;
		}
		else values = this.getValue();

		fn(values, preValue, this);
	}

	getValue(){
		const {composeValue, mode} = this.props;
		if(composeValue && mode !== 'parent'){
			const data = this._picker.state.data;
			const values = [];
			_.forEach(data, d => {
				if(d._selected) values.push({parent: d.id});
				_.forEach(d.children, child => {
					if(child._selected) values.push({parent: d.id, value: child.id});
				});
			});
			return values.length === 0 ? undefined : values;
		}
		else return super.getValue();
	}

	_transfer(value){
		const {composeValue, mode} = this.props;
		if(!_.isArray(value)) value = [value];
		value = _.compact(value);
		if(value.length === 0) return false;
		if(composeValue && mode !== 'parent')
			value = _.map(value, v => _.isPlainObject(v) ?
				((mode === 'all' && !v.hasOwnProperty('value')) ? v.parent : v.value) : v);
		return value;
	}

	setValue(value, cb) {
		const v = this._transfer(value);
		return v === false ? false : super.setValue(v, cb);
	}

	$renderTag(data, idx){
		return data.parent ? <>
			<small className={'color-gray opacity-80'}>{data.parent.name}</small>
			<i className={'fa fa-fw fa-caret-right'} />
			{data.name}
		</> : data.name;
	}
}

class NewSubDataLoader extends SubDataLoader{
	onFetch(data) {
		if (!_.isArray(data)) return [data];
		return data.map(parent => {
			const newParent = {
				...parent,
				id: `${parent.id}`,
			};

			if (_.isArray(parent.children)) {
				newParent.children = parent.children.map(child => ({
					...child,
					id: `${parent.id}_${child.id}`,
				}));
			}
			return newParent;
		});
	}

	onUpdate(value, preValue){
		const { onUpdate } = this.props;
		const fn = this._onUpdate || (_.isFunction(onUpdate) ? onUpdate : null);
		if (!fn) return;

		const values = [];
		if(!_.isArray(value)) value = [value];
		value = _.compact(value);

		_.forEach(value, d => {
			if (_.includes(`${d}`, '_')) {
				const [parent, child] = _.split(d, '_');
				values.push({ parent, value: +child });
			} else values.push({ parent: d });
		})

		fn(values.length === 0 ? undefined : values, preValue, this);
	}

	_transfer(value) {
		const {composeValue, mode} = this.props;
		if(!_.isArray(value)) value = [value];
		value = _.compact(value);
		if(value.length === 0) return false;
		value = _.map(value, v => _.isPlainObject(v) ?
					((mode === 'all' && !v.hasOwnProperty('value')) ? `${v.parent}` : `${v.parent}_${v.value}`)
				: v);
		return value;
	}
}

/**
 * @param d
 * @return {null|string}
 * @private
 */
const ___getDataProp = d => d.hasOwnProperty('id') ? 'id' : d.hasOwnProperty('value') ? 'value' : null;
const ___setValue = (v, data) => {
	if(!data) return;
	if(!_.isArray(v)) v = [v];
	const result = [];
	data.map(d => {
		const prop = ___getDataProp(d);
		if(!prop) return;
		d._selected = _.filter(v, _v => d[prop] == _v).length > 0;
		if (d._selected) result.push(d[prop]);
	});
	return _.intersection(v, result);
};
const ___setBinaryValue = (v, data) => {
	const binString = (v || 0).toString(2).split('').reverse();
	_.map(data, (d, idx) => d._selected = (+binString[idx] || 0) ? true : false);
	return v;
};

function hasOverflow(element) {
	return element.scrollWidth > element.clientWidth;
}

const TipTag = ({ className, children, tipText, theme }) => {
	const el = useRef({});
	const [isHover, setIsHover] = useState(false);
	const [tipWidth, setTipWidth] = useState(500);

	// if (theme === 'select') {
	// 	return <div className={className}>{tipText}{children}</div>
	// }

	return (
		 <div
		 	className={classnames(className, {
				'-tip': true,
			})}
			onMouseEnter={() => {
				if (hasOverflow(el.current)) {
					setTipWidth(el.current.clientWidth + 24)
					setIsHover(true);
				}
			}}
			onMouseLeave={() => {
				setIsHover(false);
			}}
		>
			<div ref={el} style={{
				// maxWidth: 'calc(100% - 16px)',
				overflow: 'hidden',
				whiteSpace: 'nowrap',
				textOverflow: 'ellipsis',
				display: 'inline-block',
			}}>{tipText}</div>
			{children}
			{
				isHover ? (
					<Tip {...{
						stick: el.current,
						stickDirection: 'top',
						stickAlign: 0,
					}}>
						<div
							style={{ wordBreak: 'break-word', maxWidth: tipWidth }}>
							{tipText}
						</div>
					</Tip>
				) : null
			}
		</div>
	)
}

class Picker extends ReactInputWithData{
	static version = '1.1.0';
	static propTypes = {
		... ReactInputWithData.propTypes,
		indicator: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
		dataFilter: PropTypes.func,
		dataExcludes: PropTypes.array,
		removeAll: PropTypes.bool,
		behavior: PropTypes.oneOf(['default', 'jira', 'simple']),
		theme: PropTypes.string,
		finding: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
		finder: PropTypes.func,
		renderItem: PropTypes.func,
		renderTag: PropTypes.func,
		renderTagClass: PropTypes.func,
		valueType: PropTypes.oneOf(['number', 'string', 'unlimited']),
		inactiveIsReadOnly: PropTypes.bool,
		inactiveValidate: PropTypes.bool,
	};
	static defaultProps = {
		... ReactInputWithData.defaultProps,
		indicator: true, //'<%= count %> / <%= max %>', 	// false or String(variable:{count},{max})
		dataFilter: d => d.inActive ? d : !d.hasOwnProperty('active') || d.active,
		dataExcludes: null,
		removeAll: true,
		// width: 'auto',
		// maxWidth: null,
		// minHeight: 30, // 1-line
		// height: 'auto',
		// maxHeight: null,
		validate: {
			required: false,
			// min: 2,
			// max: 3,
		},
		//onUpdate: (value, preValue) => {},
		behavior: 'default', // 'default', 'jira'
		finding: 10,
		finder: (d, kw) => {
			let { name, text, code, label } = d;
			const exp = new RegExp(_.escapeRegExp(kw), 'i'); // TODO kw 的 RegExp 化往上提一層？
			return _.some([name, text, code, label], value => {
				if (!value) return false;
				if (_.isPlainObject(value)) value = LocaleUtils.adapt(value);
				return exp.test(value);
			});
		},
		menuPlaceholder: OptionUtils.getLabel('components.Input', 'search'),
		maxMenuHeight: 350,
		maxMenuWidth: 500,
		valueType: OptionUtils.getLabel('components.Input', 'translate error'),
		inactiveText: OptionUtils.getLabel('components.Input', 'deactivated'),
		inactiveIsReadOnly: true,
		inactiveValidate: false, // 是否在 validate 時檢查已選項目是否包含停用選項
		valueFixed: false, // 是否修正 max 不是 1 但 onUpdate 回傳單一值時被改成非陣列的問題
		clickOrder: false, // 照點擊順序而非資料順序呈現資料
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		max: OptionUtils.getLabel('components.Input', 'youCanSelectUpTo'),
		min: OptionUtils.getLabel('components.Input', 'atLeastMin'),
		inactive: OptionUtils.getLabel('components.Input', 'selectedItemIsInactive'),
	};
	state = {
		... this.state,
		loading: false,
		data: null,
	};
	static contextType = MobileContext;
	_preValue = undefined; 	// 與state._preValue不同，this._preValue元件內部控制，state._preValue專屬getDerivedStateFromProps()控制props

	// 不要閉包，否則會造成 this._onUpdate 一直是舊的值
	// _onUpdate = _.isFunction(this.props.onUpdate) ? this.props.onUpdate : null;
	// _onEditing = _.isFunction(this.props.onEditing) ? this.props.onEditing : null;

	// 按點擊順序保存的資料
	orderData = [];

	constructor(props) {
		super(props);

		this._checkUpdate = this._checkUpdate.bind(this);
		this.renderItem = this.renderItem.bind(this);
		this._getSelectedIds = this._getSelectedIds.bind(this);

		this.$init();
	}

	_onUpdate(...params) {
		if(_.isFunction(this.props.onUpdate)) {
			this.props.onUpdate(...params)
		}
	}

	_onEditing(...params) {
		if(_.isFunction(this.props.onEditing)) {
			this.props.onEditing(...params)
		}
	}

	$init(){
		const {initValue, value, initIndex, data, valueType, binary, focus ,sort} = this.props;
		this.state._preData = data;
		let _data = ReactInputWithData._transformData(data, valueType);
		if(!_.isNil(_data) && !_.isEmpty(_data)){
			const {dataFilter:f, dataExcludes:exc} = this.props;
			this.state.data = _.isFunction(f) ? _.filter(_data, d => f(d) || _.includes(exc, d.id)) : _data;
		}

		// 保留原始順序
		if (initValue) {
			this.orderData = Array.isArray(initValue) ? [...initValue] : [initValue];
		}
		if (value) {
			this.orderData = Array.isArray(value) ? [...value] : [value];
		}

		const d = this.state.data;
		// 如果同時填寫 initValue 跟 initIndex 的話，只看 initValue
		if (!_.isNil(initValue)) {
			this.state._initValue = this.state._value = this._preValue =
				binary ? ___setBinaryValue(initValue, d) : ___setValue(initValue, d);
		} else if (!_.isNil(initIndex) && !_.isEmpty(d) && !_.isNil(d[initIndex])) {
			let entry = d[initIndex];
			if (entry) {
				const prop = ___getDataProp(entry);
				if (prop) {
					const indexedValue = entry[prop];
					this.state._initValue = this.state._value = this._preValue =
						binary ? ___setBinaryValue(indexedValue, d) : ___setValue(indexedValue, d);
				}
			}
		}
		if(!_.isNil(value))
			this.state._value = this._preValue =
				binary ? ___setBinaryValue(value, d) : ___setValue(value, d);
		if (focus === true)
			this.state._focusAfterMount = true;
		//BankCode string排序
		if (sort && _.isFunction(sort)) {
			this.state.data.sort(function (a, b) {
				return +a.id - +b.id;
			});
		}
	}

	static getDerivedStateFromProps(props, state) {
		let s = ReactInputWithData.getDerivedStateFromProps(props, state);
		if(s) {
			delete s.value;
			delete s._value;
			if (state._focusAfterMount && s.focus)
				delete s.focus;
		}

		const {value} = props;
		const {_initValue, _value} = state;
		if(!s || (_.isNil(value) && _.isNil(_initValue))) return s;

		if(!_.isNil(value)){
			const v = _.isArray(value) ? value : [value];
			if(!_.isEqual(v, _value)){
				if(!s) s = {};
				// WARN _value 只應該紀錄 props.value 的變化，而非紀錄實際選擇值
				// 否則當 props.value 出現非 data 資料時，每次 render 將重設 _selected flag
				// Ex: props.value = 1, props.data = { 2: 'itemName' }, 上面的 !_.isEqual 將 恆為 true
				s._value = ___setValue(v, s.data || state.data);
			}
			else ___setValue(v, s.data);
		}
		else if(!_.isNil(_initValue)){
			const v = _.isArray(_initValue) ? _initValue : [_initValue];
			// WARN _value 只應該紀錄 props.value 的變化，而非紀錄實際選擇值，原因同上
			s._value = ___setValue(v, s.data || state.data);
			delete state._initValue;
		}
		return s;
	}

	componentDidMount() {
		super.componentDidMount();
		if (this.state._focusAfterMount)
			this.setState({ focus: true, _focusAfterMount: false });
	}

	componentDidUpdate(prevProps, prevState, snapshot){
		const {behavior, allowUncheck} = this.props;
		const { data, focus } = this.state;
		if(focus && data && behavior === 'default' && this.$isAllSelected() && !allowUncheck) this.blur();
	}

	blur(cb){
		super.blur(() => this._checkUpdate(cb));
	}

	_checkUpdate(cb) {
		if (!this.validate()) return;

		if(_.isFunction(cb)) cb();
		const value = this.props.binary ? _.reduce(this.state.data, (result, item, idx) => {
			if(item._selected) result += Math.pow(2, idx);
			return result;
		}, 0) : this._getSelectedIds();
		if (!_.isEqual(this._preValue, value)) {
			if (this._onUpdate) {
				let newValue = _.cloneDeep(value);
				if (this.props.valueFixed) {
					const rules = this.$getValidateRules();
					if (rules.max === 1)
						newValue = _.isArray(newValue) ? newValue[0] : newValue;
					else
						newValue = _.isArray(newValue) ? newValue : [newValue];
				} else if (_.isArray(newValue) && newValue.length === 1) newValue = newValue[0];
				this._onUpdate(newValue, this._preValue, this);
			}
			this._preValue = value;
		}
	}

	reset(){
		const r = super.reset();
		if(!r || this.props.view) return false;
		const {initValue} = this.props;
		_.map(this.state.data, d => {
			if(_.isNil(initValue)) d._selected = false;
			else{
				let v = d.id === 0 ? 0 : (d.id || d.value);
				v = _.isNaN(+v) ? v : +v;
				d._selected = _.isNumber(v) ? v == initValue : _.includes(initValue, v);
			}
		});
		this.forceUpdate();
		this._preValue = undefined;
		return this;
	}
	validate(){
		if (this.props.view || super.validate()) return true;

		const rules = this.$getValidateRules();
		const {errorMsg, binary, onError} = this.props;
		const ids = this._getSelectedIds();
		if (rules.required && (!binary && _.isEmpty(ids) || binary && ids === 0)) {
			const msg = (errorMsg && errorMsg.required) || Picker.ERROR.required;
			this.setState({error: msg}, () => _.isFunction(onError) ? onError(msg, this) : null);
			return false;
		}
		if (rules.min && (((ids && ids.length) || 0) < +rules.min)) {
			const msg = _.template((errorMsg && errorMsg.min) || Picker.ERROR.min)({min: rules.min});
			this.setState({error: msg}, () => _.isFunction(onError) ? onError(msg, this) : null);
			return false;
		}
		if (rules.max && (((ids && ids.length) || 0) > +rules.max)) {
			const msg = _.template((errorMsg && errorMsg.max) || Picker.ERROR.max)({max: rules.max});
			this.setState({error: msg}, () => _.isFunction(onError) ? onError(msg, this) : null);
			return false;
		}
		if (this.props.inactiveValidate && !binary) {
			if (this.state.data) {
				let hasInactiveSelected = false;
				for (const d of this.state.data) {
					if (d._selected && d.active !== undefined && !d.active) {
						hasInactiveSelected = true;
						break;
					}
				}
				if (hasInactiveSelected) {
					const msg = (errorMsg && errorMsg.inactive) || Picker.ERROR.inactive;
					this.setState({ error: msg }, () => _.isFunction(onError) ? onError(msg, this) : null);
					return false;
				}
			}
		}
		if (_.isFunction(rules.custom)) {
			let msg = rules.custom(ids);
			if (msg !== true) {
				msg = msg || OptionUtils.getLabel('global.normal', 'error');
				this.setState({ error: msg }, () => _.isFunction(onError) ? onError(msg, this) : null);
				return false;
			}
		}
		if (this.state.error) this.setState({error: false});
		const {focus} = this.state;
		if(focus)
			this.setState({focus: false}, () => {
				if(!_.isEqual(this._preValue, ids)){
					let newValue = _.cloneDeep(ids);
					if(_.isArray(newValue) && newValue.length === 1) newValue = newValue[0];
					if(_.isFunction(this._onUpdate)) this._onUpdate(newValue, this._preValue);
					this._preValue = ids;
				}
			});
		return true;
	}

	enable(cb) {
		return this.props.view ? this : super.enable(cb);
	}
	disable(cb) {
		return this.props.view ? this : super.disable(cb);
	}

	editable(cb) {
		return this.props.view ? this : super.editable(cb);
	}
	readOnly(cb) {
		if (this.props.view) return this;
		const {error, data} = this.state;
		if(error) {
			if(data)
				data.map(d => d._selected = false);
		}
		return super.readOnly(cb);
	}

	addOrderData(item) {
		const { allowUncheck } = this.props
		if (!Array.isArray(this.orderData)) this.orderData = [];
		if (!this.orderData.includes(item.id)) {
			this.orderData.push(item.id);
		} else {
			if (allowUncheck) {
				this.orderData = this.orderData.filter(id => id !== item.id);
			}
		}
	}

	_getSelectedIds(){
		const {binary} = this.props;
		const {data} = this.state;
		if(!data) return undefined;
		const _data = this.genClickSortData(data)
		if(binary)
			return _.reduce(_data, (result, item, idx) => {
				const key = ___getDataProp(item);
				if(item._selected) result += (key ? item[key] : Math.pow(2, idx));
				return result;
			}, 0);
		else{
			const ids = _.transform(_data, (result, d, idx) => {
				if(d._selected){
					let _v = d.id === 0 ? 0 : (d.id || d.value);
					_v = _casting(_v, this.props.valueType);
					result.push(_v);
				}
			}, []);
			return ids.length == 0 ? undefined : ids;
		}
	}
	getValue(){
		const {data, focus, enable, error} = this.state;
		if(!data || !enable || error) return undefined;

		let v = null;
		if(focus){
			if(!this.validate()) return;
			this.blur();
		}
		v = this._getSelectedIds();

		const {validate} = this.props;
		return validate && validate.max == 1 && _.isArray(v) ? v[0] : v;
	}
	setValue(value){
		const {data, enable, editable} = this.state;
		// 可以透過 initValue 去設定，不一定要動這一行
		if(!data || !enable || !editable) return;
		const {binary} = this.props;
		if(binary){
			const binString = (value || 0).toString(2).split('').reverse();
			_.map(data, (d, idx) => d._selected = (+binString[idx] || 0) ? true : false);
			this.forceUpdate();
		}
		else{
			if(!_.isArray(value)) value = [value];
			this.orderData = [...value];
			value = value.map(v => _.isNil(v) ? undefined : v);
			data.map(d => d._selected = value.some(i => {
				if (i === undefined) return false
				return i == d.id || i == d.value
			}));
			this.forceUpdate(() => this._preValue = _.clone(value));
		}
	}

	getText(){
		const {data} = this.state;
		if(!data) return undefined;
		const texts = _.transform(data, (result, d, idx) => {
			if(d._selected) result.push(d.name || d.text || d.label);
		}, []);
		return texts.length == 0 ? undefined : texts.length == 1 ? texts[0] : texts;
	}

	// abstract methods ...
	renderTag(data, idx){
		const {renderTag} = this.props;
		if(_.isFunction(renderTag)) return renderTag(data, idx, this);

		const name = data.hasOwnProperty('name') ? data.name : data;
		return (_.isPlainObject(name) ? LocaleUtils.adapt(name) : name);
	}
	renderTagClass(data, idx){
		const isActive = !data.hasOwnProperty('active') || data.active;
		const {renderTagClass} = this.props;
		return _.isFunction(renderTagClass) ? renderTagClass(data, idx) : isActive ? '' : 'inactive';
	}
	renderItem(data, idx){
		const {renderItem} = this.props;
		if(_.isFunction(renderItem)) return renderItem(data, idx);

		const name = data.hasOwnProperty('name') ? data.name : data;
		return (_.isPlainObject(name) ? LocaleUtils.adapt(name) : name);
	}
	renderPrefix(){
		const {renderPrefix} = this.props;
		return _.isFunction(renderPrefix) ? renderPrefix() : null;
	}

	genClickSortData(data) {
		const _data = [...data];
		if (this.props.clickOrder && Array.isArray(this.orderData) && this.orderData.length > 0) {
			const _orderData = this.orderData.map(id => isNaN(Number(id)) ? id : Number(id));
			_data.sort((a, b) => {
				const aIdx = _orderData.indexOf(a.id);
				const bIdx = _orderData.indexOf(b.id);
				return aIdx - bIdx;
			})
		}
		return _data
	}

	// protected methods ...
	$genSelectedData(){
		const {data} = this.state;
		const _data = _.filter(data, d => d._selected)

		return this.genClickSortData(_data);
	}
	$genMenuData() {
		const {behavior} = this.props;
		const v = this.$getValidateRules();
		const {data} = this.state;
		return behavior !== 'default' || (v && v.max == 1) ? data : _.filter(data, d => !d._selected);
	}
	$allowMenu(){return true;}
	$isAllSelected(){
		const {data} = this.state;
		return _.every(data, d => d._selected);
	}
	$onMenuClose(evt){
		const {onMenuClose} = this.props;
		if(_.isFunction(onMenuClose)) onMenuClose(evt, this);
		else this.blur(this.props.onBlur);
	}

	menuComponent = 'PickerMenu';
	render() {
		const {
			className, style,
			placeholder, width, maxWidth, minWidth, removeAll, indicator,
			minHeight, maxHeight, height, view, tip, behavior, theme, maxMenuHeight, maxMenuWidth,
			finding, finder, menuPlaceholder,
			allowUncheck, inactiveText,
			onFocus, emptyStyle=null,
		} = this.props;
		const {data, loading, focus, error, enable, editable, hover} = this.state;
		if (loading) return <Loading />;
		if (_.isEmpty(data)) return <div className={'color-red'} style={{
				... _.isArray(width) && width.length > 1
				? {
					maxWidth: width[1], minWidth: width[0], width: 'auto'
				}
				: { ...emptyStyle, width}
			}}>
			<i className={'fa fa-fw fa-exclamation-circle'} />{OptionUtils.getLabel('global.normal', 'noInfo')}
		</div>;

		const rules = this.$getValidateRules();
		const max = rules && rules.max ? rules.max : undefined;
		const _selectedData = this.$genSelectedData();
		const _menuData = this.$genMenuData();
		const isRemoveAll = (this.context && focus || hover) && enable && editable && !view && removeAll &&
			(this.context || _selectedData && _selectedData.length > 0) && (max !== 1 || allowUncheck);
		const _renderTag = () => {
			if (behavior === 'jira') {
				return <div className="tag" style={{
						maxWidth: '100%',
						overflow: 'hidden',
						whiteSpace: 'nowrap',
						textOverflow: 'ellipsis',
					}}>{_selectedData.map((data, idx) => {
						const isActive = !data.hasOwnProperty('active') || data.active;
						// 自訂的 renderTag 回傳非 string 型態...
						const tag = this.renderTag(data, idx);
						if (React.isValidElement(tag)) return tag.props.children[0];
						return <React.Fragment key={idx}>
							{idx > 0 ? ', ' : ''}
							{isActive ? null : <i className='-err color-red fa fa-sm fa-exclamation-circle' style={{ marginRight: 6 }} />}
							{tag}
						</React.Fragment>;
					})}
				</div>;
			}
			return _selectedData.map((d, idx) => {
				const isActive = !d.hasOwnProperty('active') || d.active;
				return <TipTag
					key={d.id === 0 ? 0 : (d.id || d.value)}
					className={`tag ${this.renderTagClass(d, idx)}`}
					tipText={this.renderTag(d, idx)}
					theme={theme}
				>
					{isActive ? null : <small className={'-inactive'}>{inactiveText}</small>}
					{!view && enable && editable ? (
						<>
							<i className='-remover fal fa-times' />
							<i {...{
								className: '-remover fa fa-times-circle',
								onClick: evt => {
									evt.stopPropagation();
									d._selected = false;
									this.orderData = this.orderData.filter(id => id !== d.id);
									this.forceUpdate(() => {
										!focus ? this._checkUpdate() : _.isFunction(this._onEditing) ? this._onEditing(this._getSelectedIds()) : null
										this._dom.menu?.position();
									})
								}
							}} />
						</>
					) : null}
				</TipTag>;
			});
		};
		const _renderIndicator = () => {
			const s = _selectedData;
			const count = s ? s.length : 0;
			return !view && enable && editable && indicator && !error ?
				<div ref={ele => this._dom.indicator = ele} className={'-indicator'}>
					{indicator === true ? count : _.template(indicator)({ count: count, max: max })}
				</div> : null;
		};

		const Menu = () => {
			const M = eval(this.menuComponent);
			const freeSlot = (max > 0) ? Math.max(0, max - _selectedData.length) : -1;
			const isSelectAllBtn = this.menuComponent !== 'DepPickerMenu' && (max === undefined || max > 1);
			return <M {...{
				ref: ele => this._dom.menu = ele,
				stick: this._dom.root,
				close: evt => this.$onMenuClose(evt),
				clickExcludes: this._dom.root,
				picker: this._dom.root,
				height: [this._dom.root.getSize().y, maxMenuHeight],
				width: [this._dom.root.getSize().x, maxMenuWidth],
				data: _menuData,
				renderItem: this.renderItem,
				lock: max > 1 && _selectedData.length >= max,
				freeSlot,
				isSelectAllBtn,
				onSelect: (item, closeMenu) => {
					this.addOrderData(item);
					const isArray = _.isArray(item);
					if (isArray) _.each(item, d => d._selected = true);
					else {
						if (max === 1) data.forEach(d => d._selected = d !== item ? false : !item._selected ? true : !allowUncheck);
						else item._selected = true;
					}
					this.forceUpdate(() => {
						if (closeMenu ||
							(isArray && item.length === _menuData.length && behavior === 'default') ||
							(!isArray && max === 1 && item._selected)) {
							return this.setState({ focus: false, hover: false }, this._checkUpdate);
						}

						if (this._dom.tags)
							this._dom.tags.scrollTo(0, this._dom.tags.getScrollSize().y);
						if (_.isFunction(this._onEditing) && (!isArray || !_.isEmpty(item)))
							this._onEditing(this._getSelectedIds());
					});
				},
				onDeselect: item => {
					this.orderData = this.orderData.filter(id => id !== item.id);
					item._selected = false;
					this.forceUpdate(_.isFunction(this._onEditing) ? () => this._onEditing(this._getSelectedIds()) : null);
				},
				onOverload: (force) => {
					if (!force && !this._dom.indicator) return;
					//this._dom.indicator.addClass('overload').removeClass.delay(300, this._dom.indicator, 'overload');
					this._dom.root.addClass('overload').removeClass.delay(300, this._dom.root, 'overload');
				},
				behavior, finding, finder,
				placeholder: menuPlaceholder,
				inactiveText: inactiveText,
				inactiveIsReadOnly: this.props.inactiveIsReadOnly,
				max,
				... {
					... this.props.menuProps,
					... this.menuProps,
				},
			}} />;
		};
		const _renderSimpleMode = () => <div className={'form-control flex-row'}>
			<span className={'-label'}>{placeholder}</span>
			{_selectedData ? <span className={'-indicator'}>{_selectedData.length}</span> : 0}
			{isRemoveAll ? <i {...{
				className: '-removeAll btn btn-xs square btn-danger fa fa-trash-alt',
				onClick: evt => {
					if (!enable || !editable) return;
					evt.stopPropagation();
					this.orderData = [];

					_selectedData.map(d => d._selected = false);
					this.forceUpdate(!focus ? this._checkUpdate :
						_.isFunction(this._onEditing) ? () => this._onEditing(this._getSelectedIds()) : null);
				},
			}} /> : null}
		</div>;
		const _renderNormalMode = () => <>
			{_selectedData.length === 0 && placeholder ?
				<span className={'-placeholder color-lightGray'}>{placeholder}</span> : null}
			<div ref={ele => this._dom.tags = ele} className={`-tags ${view ? 'view' : ''}`} style={{
				... behavior != 'jira' && height ? { height } : null,
				... behavior != 'jira' && minHeight ? { minHeight } : null,
				... behavior != 'jira' && maxHeight ? { maxHeight } : null,
			}}>{_selectedData.length !== 0 ? _renderTag() : null}</div>
			{isRemoveAll ? <i {...{
				className: `-removeAll btn btn-${_.includes(className, 'sm') ? 'xs' : 'sm'} square btn-danger fa fa-trash-alt`,
				onClick: evt => {
					if (!enable || !editable) return;
					evt.stopPropagation();
					this.orderData = [];
					_selectedData.map(d => d._selected = false);
					// this.forceUpdate(!focus ? this._checkUpdate :
					// 	_.isFunction(this._onEditing) ? () => this._onEditing(this._getSelectedIds()) : null);
					this.forceUpdate(() => {
						!focus ? this._checkUpdate() : _.isFunction(this._onEditing) ? this._onEditing(this._getSelectedIds()) : null
						this._dom.menu?.position();
					})
				},
			}} /> : null}
			{max === 1 || _selectedData.length === 0 ? null : _renderIndicator()}
			{error ? <i className={'-err color-red fa fa-exclamation-circle'} /> : null}
			{enable && !view && !editable ? <i className={'-lock color-gray fa fa-lock-alt'} /> : null}
			{theme === 'select' ? <span className={'-arrowBtn'}><i className={'fal fa-angle-down'} /></span> : null}
			{
				view ? null :
				error && hover ? <Tip {...{
					stick: this._dom.root,
					stickDirection: 'top',
					stickAlign: 1,
					theme: 'validate',
				}}>{error}</Tip> :
				hover && tip && behavior === 'jira' && _selectedData.length > 0 ? <Tip {...{
					stick: this._dom.root,
					stickDirection: 'top',
					stickAlign: 1,
				}}>{tip}</Tip> : null
			}
		</>;
		return <div {...{
			ref: ele => this._dom.root = ele,
			className: (() => {
				let css = 'H2-Picker';
				css += behavior === 'simple' ? ' simple' : '';
				_.forEach([theme, className], x => css += x ? ` ${x}` : '');
				css += focus ? ' focus' : '';
				css += error ? ' error' : '';
				css += enable ? '' : ' disable';
				css += editable ? '' : ' readOnly';
				return css;
			})(),
			onClick: enable && editable ? evt => {
				this.focus();
				evt.stopPropagation();
				_.isFunction(onFocus) ? onFocus(this) : null;
			} : null,
			style: {
				... style,
				... _.isArray(width) && width.length > 1 ? {
					maxWidth: width[1], minWidth: width[0], width: 'auto'
				} : {width},
				... minWidth ? {minWidth, width: 'auto'} : null	// TODO: remove later
			},
			onMouseEnter: evt => {
				if(!enable || !editable || hover) return;
				this.setState({hover: true}, () => {
					if(this.props.onMouseEnter) this.props.onMouseEnter();
				});
			},
			onMouseLeave: evt => {
				if(!enable || !editable || !hover) return;
				this.setState({hover: false}, () => {
					if (this.props.onMouseLeave) this.props.onMouseLeave();
				});
			},
		}}>
			{this.renderPrefix()}
			{behavior === 'simple' ? _renderSimpleMode() : _renderNormalMode()}
			{enable && editable && focus && _menuData && this.$allowMenu() ? Menu() : null}
		</div>;
	}
}
class PickerMenu extends Box {
	static version = '1.0.0';
	static propTypes = {
		... Box.propTypes,
		isCount: PropTypes.bool,
	};
	static defaultProps = {
		... Box.defaultProps,
		theme: 'pickerMenu',
		stickDirection: 'ver',
		stickAlign: -1,
		//inject: document.body,
		nilText: OptionUtils.getLabel('components.Input', 'noMatchingInformation'),
		isCount: false,
		isEventControl: true,
	};
	static SEGMENT_SIZE = 100;
	state = {
		... this.state,
		kw: null,
		segment: 0,
		criteria: {},
	};
	_positionCount = () => {
		const {ul, count} = this._dom;
		if(count && ul)
			count.position({
				relativeTo: ul,
				position: 'leftBottom',
				edge: 'rightBottom',
				offset: {x: 14}
			});
	};

	componentDidMount() {
		super.componentDidMount();
		this._positionCount();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		this._positionCount();
	}

	renderBoxBody() {
		return <>
			{this.renderTopSticky()}
			{this.renderBody()}
		</>;
	}

	renderExtra(){
		const {isCount} = this.props;
		return isCount && this._count > 9 ? <div {... {
			ref: ele => this._dom.count = ele,
			className: '-count',
		}}>{this._count}</div> : null;
	}

	renderTopSticky(){
		const {renderCriteria, isSelectAllBtn } = this.props;
		const {criteria} = this.state;
		const selectAllBtn = (isSelectAllBtn && <span className="btn btn-sm btn-success" onClick={() => this._selectAll()}>{OptionUtils.getLabel('hp.m4.m410040', 'selectAll')}</span>) || null;
		return this._isFilter() ? null : <div className={'-filters'}>
			{
				_.isFunction(renderCriteria) ?
					renderCriteria(criteria, () => this.forceUpdate(this.position), selectAllBtn) :
					<div className={'flex-row'}>{this._filterInputs()}{selectAllBtn}</div>
			}
		</div>;
	}

	_isFilter(){
		const {finding, data} = this.props;
		return finding === false || data.length < finding;
	}
	_filterInputs(){
		const {placeholder} = this.props;
		const {kw} = this.state;
		return <>
			<i className={'fal fa-fw fa-sm fa-search color-gray'} style={{margin: '0 0 0 3px'}} />
			<Text {...{
				className: 'empty sm -gum',
				placeholder,
				initValue: kw || '',
				onEditing: v => {
					v = v.trim();
					if (v === kw) return;
					this.setState({kw: v}, this.position);
				},
			}} />
		</>;
	}

	_selectAll() {
		const {
			data: allData, finder, lock,
			onSelect, onOverload,
			filterCriteria, inactiveIsReadOnly,
		} = this.props;
		if (lock) return onOverload();

		let { freeSlot } = this.props;
		const { criteria, kw } = this.state;
		const data = !_.isEmpty(criteria) ? filterCriteria(allData, criteria, finder) : kw ? _.filter(allData, d => finder(d, kw)) : allData;

		const selectedData = [];
		let isOverload = false;
		_.each(data, d => {
			const inactive = d.active === 0 || d.active === false;
			if (d._selected) return;
			if (inactiveIsReadOnly && inactive) return;
			if (freeSlot === 0) {
				isOverload = true;
				return false; // 終止 iterate
			}

			selectedData.push(d);
			freeSlot--;
		});
		if (!_.isEmpty(selectedData)) onSelect(selectedData, selectedData.length === data.length);
		if (isOverload) onOverload(true);
	}

	renderBody(){
		const {
			data:d, behavior, finder, lock, renderItem,
			onSelect, onDeselect, onOverload, inactiveText, nilText,
			filterCriteria, inactiveIsReadOnly, finding
		} = this.props;
		const {criteria, kw, segment} = this.state;
		if (!d || d.length === 0) return null;

		const data = !_.isEmpty(criteria) ? filterCriteria(d, criteria, finder) : kw ? _.filter(d, d => finder(d, kw)) : d;

		this._count = data ? data.length : 0;
		const isNeedSegment = data.length > PickerMenu.SEGMENT_SIZE;
		const _data = isNeedSegment ? _.slice(data, 0, (segment + 1) * PickerMenu.SEGMENT_SIZE) : data;

		return <ul {... {
			ref: ele => this._dom.ul = ele,
			... isNeedSegment ? {onScroll: evt => {
				const container = evt.target;
				const bottomRemaining = container.getScrollSize().y - container.getSize().y - container.getScroll().y;
				if(bottomRemaining < 50 && (segment + 1) * PickerMenu.SEGMENT_SIZE < data.length)
					this.setState({segment: segment + 1});
			}} : null
		}}>
			{
				!_data || _data.length === 0 ? <div className={'notice notice-sm ico'} style={{margin: 6}}>
					<i className={'fa fa-info-circle'} /> {nilText}
				</div> : _data.map((d, idx) => {
					const _lock = lock && (behavior !== 'jira' || !d._selected);
					const inactive = d.active === 0 || d.active === false;
					return <li {...{
						key: d.id ?? idx,
						className: `${_lock ? ' lock' : ''}${d._selected ? ' active' : ''}${inactiveIsReadOnly && inactive ? ' inactive' : ''}`,
						... inactiveIsReadOnly && inactive ? null : {
							onClick: () => {
								_lock ? onOverload() : ((behavior === 'jira' || behavior === 'simple') && d._selected ? onDeselect(d) : onSelect(d))
								setTimeout(() => {
									this.position()
								})
							}
						},
					}}>
						{renderItem(d, idx)}
						{inactive ? <small className={'msg sm red'} style={{margin: '0 5px'}}>
							<i className={'fa fa-sm fa-exclamation-circle'} /> {inactiveText}</small> : null}
					</li>;
				})
			}
		</ul>;
	}
}

class Switch extends Picker{
	static version = '0.0.1';
	static propTypes = {
		... Picker.propTypes,
		onText: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.element
		]),
		offText: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
			PropTypes.element
		]),
		showText: PropTypes.bool,
	};
	static defaultProps = {
		... Picker.defaultProps,
		showText: true,
		initValue: 0,
	};
	state = {
		... this.state,
		focus: true,
	};

	constructor(props) {
		super(props);
		const {onText, offText, initValue, value} = this.props;
		this.state.data = [
			{id: 0, name: offText || 'Off', _selected: !(value || initValue) ? true : false},
			{id: 1, name: onText || 'On', _selected: (value || initValue) ? true : false}
		];
	}

	static getDerivedStateFromProps(props, state) {
		let s = Picker.getDerivedStateFromProps(props, state);
		if(s) delete s.data;
		return s;
	}

	reset(){
		const {initValue} = this.props;
		this.state.data[0]._selected = initValue ? false : true;
		this.state.data[1]._selected = initValue ? true : false;
		this.forceUpdate();
		return this;
	}

	getValue(){
		return super.getValue()[0];
	}

	render(){
		const {showText, onUpdate} = this.props;
		const {enable, editable, data} = this.state;

		const _update = (value) => this.forceUpdate(() => {
			if(_.isFunction(onUpdate)) onUpdate(value, null, this);
		});
		const _switch = evt => {
			if(!enable || !editable) return;
			if(data[0]._selected){
				data[0]._selected = false;
				data[1]._selected = true;
				_update(1);
			}
			else{
				data[0]._selected = true;
				data[1]._selected = false;
				_update(0);
			}
		};
		const _turnOff = evt => {
			if(!enable || !editable || data[0]._selected) return;
			data[0]._selected = true;
			data[1]._selected = false;
			_update(0);
		};
		const _turnOn = evt => {
			if(!enable || !editable || data[1]._selected) return;
			data[0]._selected = false;
			data[1]._selected = true;
			_update(1);
		};
		return <span className={`H2-Switch ${data[1]._selected ? ' on' : ''}${enable && editable ? '' : ' disable'}`}>
			{showText ? <span className={'-off'} onClick={_turnOff}>{data[0].name}</span> : null}
			<span className={'-switcher'} onClick={_switch}/>
			{showText ? <span className={'-on'} onClick={_turnOn}>{data[1].name}</span> : null}
		</span>;
	}
}

class Select extends Picker{
	static version = '1.0.0';
	static propTypes = {
		... Picker.propTypes,
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
		allowUncheck: PropTypes.bool,
	};
	static defaultProps = {
		... Picker.defaultProps,
		allowUncheck: false,
		validate: {
			required: false,
			max: 1
		},
		theme: 'select',
		placeholder: OptionUtils.getLabel('global.normal', 'pleaseSelect'),
	};

	$init() {
		const {data, menuProps} = this.props;
		if (!_.isString(data)) {
			super.$init();
			return;
		}

		const {filter, value, initValue, valueType,sort} = this.props;
		if(_.isString(data)) _stringToOptionData(data, filter, this.state, valueType);

		const _setValue = (value, data) => {
			let _value = _.isArray(value) ? value : [value];
			_value = _value.map(v => _.isNaN(+v) ? v : +v);
			if(data) data.map(d => d._selected = _value.some(i => i == d.id));
		};
		if(!_.isNil(initValue)){
			delete this.state._initValue;
			_setValue(initValue, this.state.data);
			this._preValue = this.state._preValue = this.getValue();
		}
		if(!_.isNil(value)){
			_setValue(value, this.state.data);
			this._preValue = this.state._preValue = this.getValue();
		}
		//BankCode string排序
		if(sort && isFunction(sort)){
			this.state.data.sort(function(a, b) {
				return +a.id - +b.id;
			});
		}
	}

	componentDidUpdate(...params) {
		super.componentDidUpdate(...params);
		// 修復某些時機點無法 onUpdate 的問題
		if (this.state._preValue !== undefined) {
			this._preValue = this.state._preValue;
		}
	};

	$getValidateRules(){
		return {
			... this.props.validate,
			max: 1,
		};
	}
	getValue(){
		const v = super.getValue();
		return _.isArray(v) && v.length > 0 ? v[0] : v;
	}

	$genMenuData() {
		const {behavior:b, allowUncheck} = this.props;
		const v = this.$getValidateRules();
		let {data} = this.state;
		return allowUncheck || b === 'jira' || (v && v.max === 1) ? data : _.filter(data, d => !d._selected);
	}
}

class Radio extends Select{
	static version = '0.0.5';
	static propTypes = {
		... Select.propTypes,
		inline: PropTypes.bool,
		allowUncheck: PropTypes.bool,
		uncheckByLabel: PropTypes.func,
		renderLabel: PropTypes.func,
		singleLineMax: PropTypes.number,
	};
	static defaultProps = {
		... Select.defaultProps,
		inline: true,
		allowUncheck: false,
		uncheckByLabel: (d, idx) => true,
		renderLabel: (item, idx) => {return item.name;},
		lock: (item, idx) => false,
		singleLineMax: 0,
	};

	$getValidateRules(){

		return {
			... this.props.validate,
			//required: false,
			max: 1,
		};
	}

	render(){
		const {inline, allowUncheck, onUpdate, renderLabel, uncheckByLabel, style, itemStyle, singleLineMax, lock, className} = this.props;
		const {data, enable, editable, error, hover} = this.state;
		const _click = (item, _allow) => {
			this.state.error = false;
			let _v = null;
			if(item._selected && _allow) item._selected = false;
			else{
				_.map(data, d => d._selected = d === item);
				const prop = ___getDataProp(item);
				_v = prop !== null ? item[prop] : undefined;
			}
			this.forceUpdate(() => _.isFunction(onUpdate) ? onUpdate(_v, null, this) : null);
		};

		return <span {...{
			ref: ele => this._dom.root = ele,
			className: `H2-Radio${className ? ` ${className}` : ''}${error ? ' error' : ''}${inline ? '' : ' block'}${enable && editable ? '' : ' disable'}`,
			... style ? {style} : null,
			onMouseEnter: () => this.setState({ hover: true }),
			onMouseLeave: () => this.setState({ hover: false })
		}}>
			{/* {_.map(data, (d, idx) => <div {...{
				key: !_.isNil(d.id) ? d.id : !_.isNil(d.value) ? d.value : idx,
				className: `radioItem${d._selected ? ' checked' : ''}${enable && editable ? '' : ' disable'}`,
				style: itemStyle
			}}>
				<span {... {
					className: 'radio',
					onClick: enable && editable ? evt => _click(d, allowUncheck) : null,
				}} />
				<span {...{
					className: '-itemBody',
					onClick: enable && editable ? evt => _click(d, allowUncheck && uncheckByLabel(d, idx)) : null,
				}}>{renderLabel(d, idx) || d.name || d.label}</span>
			</div>)} */}
			{_.map(data, (d, idx) => {
				const isLocked = lock(d, idx);
				return <React.Fragment {...{
					key: !_.isNil(d.id) ? d.id : !_.isNil(d.value) ? d.value : idx,
				}}>
					<div {...{
						className: `radioItem${d._selected ? ' checked' : ''}${enable && editable && !isLocked ? '' : ' disable'}`,
						style: itemStyle,
					}}>
					<span {... {
						className: 'radio',
						onClick: enable && editable && !isLocked ? evt => _click(d, allowUncheck) : null,
					}} />
						<span {...{
							className: '-itemBody',
							onClick: enable && editable && !isLocked ? evt => _click(d, allowUncheck && uncheckByLabel(d, idx)) : null,
						}}>{renderLabel(d, idx) || d.label || d.name}</span>
					</div>
					{
						(inline && singleLineMax > 0) && (idx+1) % singleLineMax == 0 ? <div className="flex-break"></div> : null
					}
				</React.Fragment>
			})}
			{hover && error ? <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				theme: 'validate',
			}}>{error}</Tip> : null}
		</span>;
	}
}

class ToggleButton extends Select{
	static version = '0.0.4';
	static propTypes = {
		... Select.propTypes,
		ico: PropTypes.func,
		renderLabel: PropTypes.func,
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		theme: PropTypes.string,
	};
	static defaultProps = {
		... Select.defaultProps,
		renderLabel: (item, idx) => {return item.name;},
		theme: null,
	};

	$getValidateRules(){
		return {
			... this.props.validate,
			//required: false,
			max: 1,
		};
	}

	render(){
		const {className, style, width, onUpdate, renderLabel, ico, theme} = this.props;
		const {data, enable, editable, error} = this.state;
		const _click = (item, evt) => {
			this.state.error = false;
			if(item._selected) return;
			_.map(data, d => d._selected = d === item);
			this.forceUpdate(() => {
				if(_.isFunction(onUpdate)) onUpdate(item.id || item.value || 0, null, this);
			});
		};
		return <div {...{
			ref: ele => this._dom.root = ele,
			className: `btn-group ${theme || 'btn-group-white'}${enable && editable ? '' : ' disable'} ${className || ''}`,
			style,
		}}>
			{
				_.map(data, (d, idx) =>
					<span key={d.id || d.value || idx} {...{
						className: (() => {
							const active = d._selected ? ' active' : '';
							const disable = enable && editable ? '' : ' disable';
							const icon = _.isFunction(ico) ? ico(d) : d._selected ? 'check' : false;
							return `btn${active}${disable}${icon ? ` fa fa-${icon}` : ''}`;
						})(),
						style: { fontFamily: 'inherit' },
						... width ? {style: {width: width}} : null,
						... enable && editable ? {onClick: _click.bind(this, d)} : null,
					}}>{renderLabel(d, idx) || d.name}</span>)
			}
			{error ? <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				theme: 'validate',
			}}>{error}</Tip> : null}
		</div>;
	}
}

class Checkbox extends Picker{
	static version = '0.0.3';
	static propTypes = {
		... Picker.propTypes,
		inline: PropTypes.bool,
		binary: PropTypes.bool,
		renderLabel: PropTypes.func,
		lock: PropTypes.func,
		uncheckByLabel: PropTypes.func,
		singleLineMax: PropTypes.number,
	};
	static defaultProps = {
		... Picker.defaultProps,
		inline: true,
		binary: false,
		renderLabel: (item, idx) => item.name,
		lock: (item, idx) => false,
		uncheckByLabel: (data, idx) => true,
		singleLineMax: 0,
	};

	static getDerivedStateFromProps(props, state) {
		if(!props.binary) return Picker.getDerivedStateFromProps(props, state);

		let s = ReactInputWithData.getDerivedStateFromProps(props, state);
		if(s) delete s.value;
		const {value} = props;
		const {_initValue, _value} = state;
		if(!s || (_.isNil(value) && _.isNil(_initValue))) return s;

		const _setValue = (v, data) => {
			if(!data) return 0;
			let result = 0;
			const binString = (v || 0).toString(2).split('').reverse();
			_.map(data, (d, idx) => {
				d._selected = (+binString[idx] || 0) ? true : false;
				result += d._selected ? Math.pow(2, idx) : 0;
			});
			return result;
		};
		if(!_.isNil(value) && (value != _value)) {
			if (!s) s = {};
			s._value = _setValue(value, s.data);
		}
		if(!_.isNil(_initValue)){
			s._value = _setValue(_initValue, s.data);
			delete state._initValue;
		}
		return s;
	}

	componentDidUpdate(prevProps, prevState, snapshot){
		// DO NOT remove it!
	}

	validate(){
		const {validate: {required} = 0} = this.props;
		return required ? super.validate() : true;
	}
	reset(){
		const {binary, initValue} = this.props;
		if(!binary || _.isNil(initValue)) return super.reset();
		const _setValue = (v, data) => {
			if(!data) return 0;
			let result = 0;
			const binString = (v || 0).toString(2).split('').reverse();
			_.map(data, (d, idx) => {
				d._selected = (+binString[idx] || 0) ? true : false;
				result += d._selected ? Math.pow(2, idx) : 0;
			});
			return result;
		};
		_setValue(initValue, this.state.data);
		this.forceUpdate();
		return this;
	}

	selectAll(){
		_.forEach(this.state.data, d => d._selected = true);
		this.forceUpdate();
	}
	clear(){
		_.forEach(this.state.data, (d, i) => {d._selected = false;});
		this.forceUpdate();
	}

	getValue(){
		const {data, focus, enable, error} = this.state;
		if(!data || !enable || error) return undefined;

		const {binary} = this.props;
		return binary ? _.reduce(data, (result, item, idx) => {
			if(item._selected) result += Math.pow(2, idx);
			return result;
		}, 0) : this._getSelectedIds();
	}
	setValue(value){
		const {data, enable, editable} = this.state;
		// if(!data || !enable || !editable) return;

		const {binary} = this.props;

		if(binary){
			const binString = (value || 0).toString(2).split('').reverse();
			_.map(data, (d, idx) => d._selected = (+binString[idx] || 0) ? true : false);
			this.forceUpdate();
		}
		else super.setValue(value);
	}

	render(){
		const {className, style, binary, inline, onUpdate, renderLabel, lock, uncheckByLabel, singleLineMax} = this.props;
		const {data, enable, editable, error, hover} = this.state;
		const _toggle = item => {
			this.state.error = false;
			item._selected = !item._selected;
			this.forceUpdate(() => {
				const _binaryValue = _.reduce(data, (result, item, idx) => {
					if(item._selected) result += Math.pow(2, idx);
					return result;
				}, 0);
				const _get = _.transform(data, (result, item, idx) => {
					if(!item._selected) return;
					let _v = item.id ?? item.value;
					_v = _.isNaN(+_v) ? _v : +_v;
					result.push(_v);
				}, []);
				if(_.isFunction(onUpdate)) onUpdate(binary ? _binaryValue : _get, null, this);
			});
		};
		const cb = _.map(data, (d, idx) => {
			const isLocked = lock(d, idx, data);
			// return <span {...{
			// 	key: d.id || d.value || idx,
			// 	className: `checkboxItem${d._selected ? ' checked' : ''}${enable && editable && !isLocked ? '' : ' disable'}`,
			// }}>
			// 	<span {...{
			// 		className: 'checkbox',
			// 		onClick: enable && editable && !isLocked ? evt => _toggle(d) : null,
			// 	}} />
			// 	<span {... {
			// 		className: '-itemBody',
			// 		onClick: (!d._selected || (d._selected && uncheckByLabel(d, idx))) && enable && editable && !isLocked ? evt => _toggle(d) : null,
			// 	}}>{renderLabel(d, idx) || d.name || d.label}</span>
			// 	{isLocked ? <i className={'fa fa-sm fa-fw fa-lock-alt'} /> : null}
			// </span>;
			return <React.Fragment {...{
				key: d.id || d.value || idx,
			}}>
				<span {...{
					className: `checkboxItem${d._selected ? ' checked' : ''}${enable && editable && !isLocked ? '' : ' disable'}`,
				}}>
					<span {...{
						className: 'checkbox',
						onClick: enable && editable && !isLocked ? evt => _toggle(d) : null,
					}} />
					<span {... {
						className: '-itemBody',
						onClick: (!d._selected || (d._selected && uncheckByLabel(d, idx))) && enable && editable && !isLocked ? evt => _toggle(d) : null,
					}}>{renderLabel(d, idx) || d.name || d.label}</span>
					{isLocked ? <i className={'fa fa-sm fa-fw fa-lock-alt'} /> : null}
				</span>
				{
					(inline && singleLineMax > 0) && (idx+1) % singleLineMax == 0 ? <div className="flex-break"></div> : null
				}
			</React.Fragment>
		});

		return <span {... {
			ref: ele => this._dom.root = ele,
			className: `H2-Checkbox${error ? ' error' : ''}${inline ? '' : ' block'} ${className || ''}`,
			... style ? {style} : null,
			onMouseEnter: () => this.setState({ hover: true }),
			onMouseLeave: () => this.setState({ hover: false })
		}}>
			{cb}
			{hover && error ? <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				theme: 'validate',
			}}>{error}</Tip> : null}
		</span>;
	}
}

const _stringToOptionData = (key, filter, state, valueType = 'number') => {
	const raw = OPTIONS[key];
	if(!OPTIONS.hasOwnProperty(key) || !raw || raw.length === 0){
		state.nilFromKey = true;
		return;
	}

	const idxs = OPTIONS[key + '._sort'];
	const _data = idxs
		? idxs.map(iv => ({ id: _casting(iv, valueType), name: LocaleUtils.adapt(raw[iv]) }))
		: _.transform(raw, (result, value, key) =>
			result.push({ id: _casting(key, valueType), name: LocaleUtils.adapt(value) }), []);
	if(filter && _.isFunction(filter))
		state.data = _.filter(_data, filter);
	else if(filter && _.isArray(filter))
		state.data = _.filter(_data, d => _.includes(filter, d.id));
	else state.data = _data;
};
class OptionPicker extends Picker {
	static version = '1.0.0';
	static propTypes = {
		... Picker.propTypes,
		data: PropTypes.string,
		filter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		binary: PropTypes.bool,
	};
	static defaultProps = {
		... Picker.defaultProps,
		validate: {
			required: false,
		},
		binary: false,
		finder: (d, kw) => {
			let { name } = d;
			const exp = new RegExp(_.escapeRegExp(kw), 'i');
			return name && exp.test(LocaleUtils.adapt(name));
		},
	};
	state = {
		... this.state,
		nilFromKey: false,
	};

	constructor(props) {
		super(props);

		const {data, filter, initValue, binary, value, valueType} = this.props;
		_stringToOptionData(data, filter, this.state, valueType);

		if(!_.isNil(initValue)){
			delete this.state._initValue;
			this._setValue(initValue, binary);
			this._preValue = this.getValue();
		}
		if(!_.isNil(value)){
			this._setValue(value, binary);
			this._preValue = this.getValue();
		}
	}

	_setValue(value, isBinary){
		if(isBinary){
			let bv = 0;
			this.state.data.map((d, idx) => {
				const v = +d.id;
				if(_.isNaN(v)) return;
				const pow = ((v).toString(2).split('').length - 1);
				if((value >> pow) % 2 === 1){
					d._selected = true;
					bv += v;
				}
				else d._selected = false;
			});
			return bv;
		}
		else{
			const _set = (v, data) => {
				if(!data) return;
				const result = [];
				data.map(d => {
					d._selected = _.some(v, i => i == d.id || i == d.value);
					if(d._selected) result.push(d.id === 0 ? 0 : (d.id || d.value));
				});
				return result;
			};
			return _set(_.isArray(value) ? value : [value], this.state.data);
		}
	}
	setValue(value){
		const {data, enable, editable} = this.state;
		if(!data || !enable || !editable) return;

		const {binary} = this.props;
		if(binary){
			const bv = this._setValue(value, true);
			this.forceUpdate(() => this._preValue = bv);
		}
		else super.setValue(value);
	}

	render() {
		const {data} = this.props;
		const {nilFromKey} = this.state;
		if (nilFromKey)
			return <div className={'color-red text-sm'}>
				<i className={'fa fa-exclamation-circle'}/> Data NOT found (key: <strong>{data}</strong>)
			</div>;
		else return super.render();
	}
}

const _getSelecteds = (src, selecteds) => {
	_.forEach(src, d => {
		if (d._selected) selecteds.push(d);
		if (d.children) _getSelecteds(d.children, selecteds);
	});
	return selecteds;
};
const _getIds = (src, ids) => {
	_.forEach(src, d => {
		if (d._selected) ids.push(d.id === 0 ? 0 : (d.id || d.value));
		if (d.children) _getIds(d.children, ids);
	});
	return ids;
};
const _getTexts = (src, texts) => {
	_.forEach(src, d => {
		if (d._selected) texts.push(d.name || d.text || d.label);
		if (d.children) _getTexts(d.children, texts);
	});
	return texts;
};
const _collapse = src => {
	if(!src.hasOwnProperty('children')) return;
	const _isChildrenSelected = children => !children ? false :
		_.some(children, child => child._selected || _isChildrenSelected(child.children));
	src._collapse = !_isChildrenSelected(src.children);
	src.children.map(child => _collapse(child));
};
const _clear = src => {
	src._selected = false;
	if(src.children) src.children.map(child => _clear(child));
};
/**
 * 跟 Grids.js 裡的 top-level _clear 一樣
 */
const __clear = src => src === 0 ? true : _.isNil(src) || _.isNaN(src) || src === '' || (_.isArray(src) && (src.length === 0 || !src.some(__clear))) ? undefined : src;
const _setTreeValue = (value, data, result = []) => {
	value = _.isArray(value) ? value : [value];
	_.forEach(data, d => {
		const v = d.id === 0 ? 0 : (d.id || d.value);
		d._selected = (_.findIndex(value, ele => (ele == v) ) > -1);	// 1 == '1'
		if(d._selected) result.push(v);
		if (d.children) _setTreeValue(value, d.children, result);
	});
	return result;
};
const _setTreeIndex = (index, data, mode, result = []) => {
	index = _.isArray(index) ? index : [index];
	data = _.isArray(data) ? data : [data];
	const nodes = [];
	const isLeafOnly = mode === 'leaf' || mode === 'singleLeaf';
	// DFS
	const _queue = [...data];
	for (let idx = 0; idx < _queue.length; idx++) {
		const _data = _queue[idx];
		if (_data.children) {
			_queue.splice(idx + 1, 0, ..._data.children);
			if (isLeafOnly) continue;
		}
		nodes.push(_data);
	}
	if (nodes.length === 0) return [];
	_.each(index, idx => {
		const _data = nodes[idx];
		if (_data) {
			_data._selected = true;
			result.push(_data.id === 0 ? 0 : (_data.id || _data.value));
		}
	});
	return result;
};
const _TreePickerUtils = {
	pureData: (src, dataFilter, dataExcludes, pruneChildren=true) => {
		_.forEach(src, s => {
			if(!s.children) return;
			s.children = _TreePickerUtils.pureData(s.children, dataFilter, dataExcludes, pruneChildren);
			_.forEach(s.children, c => c.parent = s);
		});
		src = _.filter(src, d => (!_.isFunction(dataFilter) || dataFilter(d) || _.includes(dataExcludes, d.id))
			&& (pruneChildren ? (!d.hasOwnProperty('children') || (d.children && d.children.length > 0)) : true));	// pruneChildren 為 true 時濾掉沒有 children 的節點
		return src;
	},
};
class TreePicker extends Picker {
	static version = '0.0.3';
	static propTypes = {
		... Picker.propTypes,
		collapse: PropTypes.bool,
		mode: PropTypes.oneOf(['all', 'leaf', 'singleLeaf']),
	};
	static defaultProps = {
		... Picker.defaultProps,
		collapse: true,
		mode: 'all',
	};

	$init(){
		const { data, collapse, mode, validate } = this.props;
		if(!_.isNil(data) && !_.isEmpty(data)){
			this.state._preData = data;
			this.state.data = _TreePickerUtils.pureData(_.cloneDeep(data));
		}

		const d = this.$genMenuData();
		if (!_.isNil(d)) {
			const { initValue, value, initIndex } = this.props;
			if(!_.isNil(initValue)) this.state._initValue = this.state._value = this._preValue = _setTreeValue(initValue, d);
			else if (!_.isNil(initIndex)) this.state._initValue = this.state._value = this._preValue = _setTreeIndex(initIndex, d, mode);
			if(!_.isNil(value)) this.state._value = this._preValue = _setTreeValue(value, d);
		}

		this.menuProps = {
			mode, collapse,
			onToggle: (data, parent) => {
				if (data._selected) data._selected = false;
				else {
					const max = validate && validate.max ? validate.max : undefined;
					const ids = this._getSelectedIds();
					if(max === 1) this.__clear();
					else if(mode === 'singleLeaf'){
						const siblingChecked = _.find(parent.children, {_selected: true});
						if(!siblingChecked && ids && ids.length >= max) return;
						_.map(parent.children, child => child._selected = false);
					}
					else if(ids && ids.length >= max) return;
					data._selected = true;
				}
				if(_.isFunction(this._onEditing)) this._onEditing(this._getSelectedIds());
				this.forceUpdate();
			},
			onToggles: (selectedData) => {
				// 這裡只會有可以選的東西進來
				// mode 為 singleLeaf 時，不能再選的節點已經會被過濾掉
				if (_.isEmpty(selectedData)) return;
				_.each(selectedData, data => data._selected = true);
				_.each(d, _d => _collapse(_d));
				if (_.isFunction(this._onEditing)) this._onEditing(this._getSelectedIds());
				this.forceUpdate();
			},
		};
	}

	static getDerivedStateFromProps(props, state) {
		let s = ReactInputWithData.getDerivedStateFromProps(props, state);
		if(s) {
			delete s.value;
			delete s._value;
		}

		const {value} = props;
		const {_initValue, _value} = state;
		if(!s || (_.isNil(value) && _.isNil(_initValue))) return s;

		if(!_.isNil(value)){
			const v = _.isArray(value) ? value : [value];
			if(!_.isEqual(v, _value)){
				if(!s) s = {};
				s._value = _setTreeValue(v, s.data || state.data);
			}
			else _setTreeValue(v, s.data);
		}
		else if(!_.isNil(_initValue)){
			const v = _.isArray(_initValue) ? _initValue : [_initValue];
			s._value = _setTreeValue(v, s.data || state.data);
			delete state._initValue;
		}
		return s;
	}

	__clear() {
		_.map(this.state.data, _clear);
	}

	reset() {
		if (this.props.view) return;
		const {enable, editable, data} = this.state;
		if (!data || !enable || !editable) return;

		const {initValue} = this.props;
		if(initValue) _setTreeValue(initValue, this.$genMenuData());
		else this.__clear();
		if(this.props.collapse) _.map(data, _collapse);
		this.state.error = false;
		this.state.hover = false;
		this.state.focus = false;
		this.forceUpdate();
	}

	_getSelectedIds() {
		const {data} = this.state;
		if (!data) return [];
		return _getIds(this.$genMenuData(), []);
	}

	getValue() {
		const { data, focus, enable, error } = this.state;
		if (!data || !enable || error) return undefined;
		let v = null;
		if(focus){
			if(!this.validate()) return;
			this.blur();
		}
		v = this._getSelectedIds();

		const {validate} = this.props;
		return validate && validate.max == 1 ? (v.length > 0 ? v[0] : undefined) : (v.length == 0 ? undefined : v);
	}

	setValue(value) {
		const { data, editable } = this.state;
		if (!data || !editable) return;

		if (!_.isArray(value)) value = [value];
		value = value.map(v => _.isNaN(+v) ? v : +v);
		_setTreeValue(value, this.$genMenuData());
		this.forceUpdate(() => this.validate());
	}

	getText(){
		const {data} = this.state;
		if (!data) return [];
		const v = _getTexts(this.$genMenuData(), []);

		const {validate} = this.props;
		return validate && validate.max == 1 ? (v.length > 0 ? v[0] : undefined) : v;
	}

	// abstract methods ...
	renderTagClass(data, idx) { return ''; }
	renderItem(data, idx) {
		return <strong>{data.name} </strong>;
	}

	$genSelectedData() {
		return _getSelecteds(this.$genMenuData(), []);
	}
	$genMenuData() {
		return this.state.data;
	}
	$isAllSelected(){
		const {mode} = this.props;
		const every = src => _.every(src, d => {
			return mode === 'all' ?
				(!d.children ? d._selected : (d._selected && every(d.children))) :
				(d.children ? every(d.children) : d._selected);
		});
		return every(this.state.data);
	}

	menuComponent = 'TreePickerMenu';
}
class TreePickerMenu extends PickerMenu {
	static version = '1.0.0';
	static defaultProps = {
		... PickerMenu.defaultProps,
		theme: 'pickerMenu tree',
	};
	$data = () => this.props.data;

	constructor(props) {
		super(props);
		const {collapse, data} = this.props;
		if(collapse && data) _.forEach(data, d => _collapse(d));
	}

	_isFilter(){
		const {finding} = this.props;
		const _count = (src, count) => {
			src.map(s => {
				count++;
				if(s.children) count = _count(s.children, count);
			});
			return count;
		};
		return (finding === false || _count(this.$data(), 0) < finding);
	}

	_find(src, kw, finds) {
		const { mode, finder } = this.props;
		src.map(s => {
			if((mode === 'all' || ((mode === 'leaf' || mode === 'singleLeaf') && !s.children)) && finder(s, kw)) finds.push(s);
			if(s.children) this._find(s.children, kw, finds);
		});
		return finds;
	}

	_selectAllNode(data, selected = true) {
		const {
			mode, lock,
			onToggles, onOverload,
			inactiveIsReadOnly,
		} = this.props;
		if (lock) return onOverload();

		let { freeSlot } = this.props;

		const { kw } = this.state;
		const selectedData = [];
		let isOverload = false;

		const _doSelect = (d, idx, siblings) => {
			const inactive = d.active === 0 || d.active === false;
			const checkable = mode === 'all' || ((mode === 'leaf' || mode === 'singleLeaf') && !d.hasOwnProperty('children'));
			const isSiblingSelected = mode === 'singleLeaf' && (idx !== 0 || _.some(siblings, d => d._selected));

			if (!d._selected === selected  &&
				checkable && !isSiblingSelected &&
				(!inactive || !inactiveIsReadOnly)) {
				if (freeSlot === 0) {
					isOverload = true;
					return false; // 終止 iterate
				}
				selectedData.push(d);
				freeSlot--;
			}

			if (!kw && d.hasOwnProperty('children')) {
				_.each(d.children, _doSelect);
				if (isOverload) return false; // 終止 iterate
			}
		};
		_.each(data, _doSelect);

		if (!_.isEmpty(selectedData)) onToggles(selectedData, selected);
		if (isOverload) onOverload(true);
	}

	_selectAll() {
		const allData = this.$data();
		const { kw } = this.state;
		const data = kw ? this._find(allData, kw, []) : allData;
		this._selectAllNode(data)
	}

	renderBody() {
		const {mode, behavior, lock, renderItem, onToggle, inactiveText, nilText, inactiveIsReadOnly } = this.props;
		const {kw} = this.state;
		const data = this.$data();
		if(!data || data.length === 0) return null;

		const _renderTreeNode = (parent, d, idx, deep) => {
			const key = d.id === 0 ? 0 : (d.id || d.value);
			const checkable = mode === 'all' || ((mode === 'leaf' || mode === 'singleLeaf') && !d.hasOwnProperty('children'));
			const inactive = d.active === 0 || d.active === false;
			const _toggleCollapse = evt => {
				evt.stopPropagation();
				d._collapse = !d._collapse;
				this.forceUpdate(() => this.position());
			};
			return <React.Fragment key={key}>
				<li {... {
					className: inactive ? 'inactive' : d._selected ? 'active' : lock && !d._selected ? 'lock' : '',
					... inactive && inactiveIsReadOnly ? null : {onClick: checkable ? evt => onToggle(d, parent) : _toggleCollapse},
				}}>
					{d.children && d.children.length > 0 ? <span {... {
						className: `-knot fal fa-${d._collapse ? 'plus' : 'minus'}-square`,
						onClick: _toggleCollapse,
					}} /> : <i className={'-knot'} />}
					{checkable ? <span className={'checkbox' + (d._selected ? ' checked' : '') + (lock && !d._selected ? ' disable' : '')} /> : null}
					{renderItem(d, idx)}
					{inactive ? <small className={'msg sm red'} style={{margin: '0 5px'}}>
						<i className={'fa fa-sm fa-exclamation-circle'} /> {inactiveText}</small> : null}
				</li>
				{d.children && !d._collapse ? <ul>
					{d.children.map((child, i) => _renderTreeNode(d, child, i, deep + 1))}
				</ul> : null}
			</React.Fragment>;
		};
		if(!kw) return <ul>{data.map((d, idx) => _renderTreeNode(null, d, idx, 0))}</ul>;

		const _data = kw ? this._find(data, kw, []) : data;
		if(!_data || _data.length === 0)
			return <div className={'notice notice-sm ico'} style={{margin: 6}}>
				<i className={'fa fa-info-circle'} /> {nilText}
			</div>;
		return <ul>
			{_data.map((d, idx) => {
				const _lock = (behavior != 'jira' && lock) || (lock && behavior === 'jira' && !d._selected);
				const inactive = d.active === 0 || d.active === false;
				return <li key={idx} {...{
					className: `${_lock ? ' lock' : ''}${d._selected ? ' active' : ''}${inactive ? ' inactive' : ''}`,
					onClick: evt => onToggle(d, d.parent),
				}}>
					{renderItem(d, idx)}
					{inactive ? <small className={'msg sm red'} style={{margin: '0 5px'}}>
						<i className={'fa fa-sm fa-exclamation-circle'} /> {inactiveText}</small> : null}
				</li>;
			})}
		</ul>;
	}
}

const _normalizeDep = values => {
	if (!_.isArray(values)) values = [values];
	return values.map(v => _.isNaN(+v) ? v : +v);
};
const _normalize1Dep = (values, data) => {
	if(!values) return false;
	if (!_.isArray(values)) values = [values];

	// 因為 EmpRuleMaker 不存 org, 所以一定得把全部的 deptId 跑過一遍，重新分類 orgType
	const _values = [];
	const _groups = {};
	const within = (nodes, deptId) => {
		if (!_.isArray(nodes)) return false;

		// BFS
		const queue = [...nodes];
		for (let i = 0; i < queue.length; i++) {
			const node = queue[i];
			if (deptId == node.id) return true;
			if (_.isArray(node.children)) queue.push(...node.children);
		}
		return false;
	};
	values.forEach(value => {
		// 如果原本就有 org 資訊，則不需額外處理
		if (!_.isNil(value.org)) _values.push(value);
		else {
			// 否則得把每個 deptId 重新分類
			// (因為 EmpRuleMaker 將要使用 type:-1，會混雜著不同 orgType)
			value.depts.forEach(deptId => {
				_.some(data, ({ data: nodes, id, code: orgType }) => {
					if (within(nodes, deptId)) {
						let _group = _groups[orgType];
						if (!_group) _group = _groups[orgType] = [];
						_group.push(deptId);
						return true;
					}
				});
			});
		}
	});
	_.each(_groups, (deptIds, orgType) => {
		if (_.isEmpty(deptIds)) return;
		_values.push({
			org: orgType,
			depts: deptIds,
		});
	});

	const filter = _.filter(_values, v => {
		const org = +v.org;
		return _.includes([1, 2, 3, 4, 5], org);
	});
	if(filter) filter.map(f => f.depts = _normalizeDep(f.depts));
	return filter;
};
const _setDep = (data, value, result = []) => {
	_.forEach(data, d => {
		const v = d.id === 0 ? 0 : (d.id || d.value);
		d._selected = (_.findIndex(value, ele => (ele == v) ) > -1);	// 1 == '1'
		if(d._selected) result.push(v);
		if (d.children) _setDep(d.children, value, result);
	});
	return result;
};
const _setOrgDep = (values, d) => {
	values = _.isArray(values) ? values : [values];
	if(_.isObject(values[0]) && values[0].org && values[0].depts) {			// {org: 1, depts: [...]}
		let org = 0;
		_.forEach(values, (v, idx) => {
			if (idx === 0) org = +v.org;
			_setDep(d['org' + v.org].data, v.depts);
		});
		return {org, values};
	}
	else{	// [...]
		let result = [];
		if(d.org1) result = _.concat(result, _setDep(d.org1.data, _normalizeDep(values)));
		if(d.org2) result = _.concat(result, _setDep(d.org2.data, _normalizeDep(values)));
		if(d.org3) result = _.concat(result, _setDep(d.org3.data, _normalizeDep(values)));
		if(d.org4) result = _.concat(result, _setDep(d.org4.data, _normalizeDep(values)));
		if(d.org5) result = _.concat(result, _setDep(d.org5.data, _normalizeDep(values)));
		return {values: result};
	}
};
class DepPicker extends PickerWrapper {
	static version = '0.1.1';
	static defaultProps = {
		orgType: 1,
		active: 0,	//0:不包含未生效 1:包含未生效
		// 顯示全部
		dataFilter: d => d,
		// 不顯示停用
		// dataFilter: d => !d.hasOwnProperty('active') || d.active,
	};
	state = {
		loading: true,
		data: null
	};
	menuProps = {
		... this.props.menuProps,
	};

	componentDidMount(){
		super.componentDidMount();
		const {orgType, bid, active, collapse} = this.props;
		const key = i => `DepPicker:${bid ? `${bid}:` : ''}org${i}:${active}:data`;
		const url = i => `/api/company/${bid ? `${bid}/` : ''}org/${i}/${active}`;
		if (orgType < 1)
			_.times(5, i => {
				const idx = i + 1;
				ls.smartGet(key(idx), url(idx), (data, fromCache) => {
					if(collapse) _.map(data.data, _collapse);
					if(!this.state.data) this.state.data = {};
					this.state.data['org' + idx] = data;
					if(data.data && data.data.length > 0){
						if(!this.menuProps.types) this.menuProps.types = {};
						this.menuProps.types[data.id] = LocaleUtils.adapt(data.name);
					}
					if (_.keys(this.state.data).length == 5){
						this.state.loading = false;
						this.forceUpdate();
					}
				});
			});
		else
			ls.smartGet(key(orgType), url(orgType), (data, fromCache) => {
				if(collapse) _.map(data.data, _collapse);
				if(!this.state.data) this.state.data = {};
				if (!this._altData) this.state.data['org' + orgType] = data;
				this.state.loading = false;
				this.menuProps.types = {};
				this.menuProps.types[data.id] = LocaleUtils.adapt(data.name);
				this.forceUpdate();
			});
	}

	render(){
		const {loading, error, data} = this.state;
		const {onUpdate, emptyStyle} = this.props;

		if(loading) return <Loading />;
		else if(error) return <span className={'color-red'}>
			<i className={'fa fa-exclamation-circle'} /> {error}
		</span>;

		const {_tempValue, _tempType} = this;
		if(_tempValue) delete this._tempValue;
		if(_tempType) delete this._tempType;

		return data ? <_DepPicker {... {
			parent: this,
			... this.props,
			ref: ele => this._picker = ele,
			data,
			menuProps: this.menuProps,
			emptyStyle,
			... _tempValue ? {initValue: _tempValue} : null,
			..._tempType ? { initType: _tempType } : null,
			onUpdate: (v, pv) => this._onUpdate ? this._onUpdate(v, pv) : _.isFunction(onUpdate) ? onUpdate(v, pv, this) : null,
		}} /> : null;
	}
}

const TipDepItem =  ({ data }) => {
	const el = useRef({});
	const [isHover, setIsHover] = useState(false);
	const [tipWidth, setTipWidth] = useState(500);

	return (
		 <span
		 	className='-tip'
			onMouseEnter={() => {
				if (hasOverflow(el.current)) {
					setTipWidth(el.current.clientWidth + 24)
					setIsHover(true);
				}
			}}
			onMouseLeave={() => {
				setIsHover(false);
			}}
		>
			<span style={{ display: 'inline-flex' }}>
				<strong
					className='text-ellipsis'
					style={{ maxWidth: 225 }}
					ref={el}
				>
					{LocaleUtils.adapt(data.name)}
				</strong>
			</span>
			<small> {data.code}</small>
			{
				isHover ? (
					<Tip {...{
						stick: el.current,
						stickDirection: 'top',
						stickAlign: 0,
					}}>
						<div
							style={{ wordBreak: 'break-word', maxWidth: tipWidth }}>
							{LocaleUtils.adapt(data.name)}
						</div>
					</Tip>
				) : null
			}
		</span>
	)
}

class _DepPicker extends TreePicker {
	static version = '0.0.2';
	static propTypes = {
		...TreePicker.propTypes,
		orgType: PropTypes.oneOf([-1, 0, 1, 2, 3, 4, 5]).isRequired,
		bid: PropTypes.number,
		active: PropTypes.number,
	};
	static defaultProps = {
		...TreePicker.defaultProps,
		orgType: 1,
		active: 0,	//0:不包含未生效 1:包含未生效
		placeholder: OptionUtils.getLabel('components.Input', 'pleaseSelectTheDepartment'),
		indicator: true,
		minHeight: 54,
		validate: {
			required: false,
		},
		finding: true,
		finder: (d, kw) => {
			let { name, code } = d;
			const exp = new RegExp(_.escapeRegExp(kw), 'i');
			return code && exp.test(code) || name && exp.test(LocaleUtils.adapt(name));
		},
		manageFilter: null, //[...ids] 樹節點以下部門
	};
	state = {
		... this.state,
		menuPlaceholder: OptionUtils.getLabel('components.Input', 'searchDepartment'),
	};

	$init(){
		const {data, orgType, collapse, menuProps, mode, validate, parent, onEditing, initType, manageFilter} = this.props;
		if(data){
			this.state._preData = data;
			this.state.data = _.cloneDeep(data);
			if(_.isArray(manageFilter)) {
				const newData = {};
				Object.keys(data).map(k => {
					let dataNode = [];
					const findTreeNode = deps => {
						deps.map(dep => {
							if (manageFilter.includes(dep.id))
								dataNode.push(dep);
							else if(_.isArray(dep.children))
								findTreeNode(dep.children);
						});
					};
					if(data[k].data) findTreeNode(data[k].data);
					newData[k] = {...data[k], data: dataNode};
					if(dataNode.length<1) delete newData[k].data;
				});
				this.state.data = newData;
			}
			const {dataFilter:f, dataExcludes:d} = this.props;
			_.forEach(this.state.data, (value, key) => {
				if(value && value.data)
					value.data = _TreePickerUtils.pureData(value.data, f, d, false);
			});
		}

		this.menuProps = {
			... ((menuProps) => {
					const newTypes = _.cloneDeep(menuProps);
					if (newTypes.types) {
						Object.keys(this.state.data).map(k => {
							const obj = this.state.data[k];
							if(!obj.hasOwnProperty('data')) delete newTypes.types[obj.code];
						});
					}
					return newTypes;
				})(menuProps),
			type: this.state.type,
			... orgType < 1 ? {
				onSwitchType: (typeId) => {
					this.menuProps.type = +typeId;
					if(orgType === 0) this.__clear();
					this.setState({type: typeId});
				}
			} : null,
			mode, collapse,
			onToggle: (data) => {
				if (data._selected) data._selected = false;
				else {
					const max = validate && validate.max ? validate.max : undefined;
					const ids = this._getSelectedIds();
					if(max == 1) this.__clear();
					else if (max > 1 && ids && ids.length >= max) return;
					data._selected = true;
				}
				const editing = onEditing || parent._onEditing;
				if(_.isFunction(editing)) editing(this.getValue());
				this.forceUpdate();
			},
			onToggles: (selectedData, selected = true) => {
				// 這裡只會有可以選的東西進來
				// mode 為 singleLeaf 時，不能再選的節點已經會被過濾掉
				if (_.isEmpty(selectedData)) return;
				_.each(selectedData, data => {
					data._selected = selected
				});
				if (selected) {
					_.each(this.state.data, ({ data: typedData }) => {
						_.each(typedData, d => _collapse(d));
					});
				}
				const editing = onEditing || parent._onEditing;
				if(_.isFunction(editing)) editing(this.getValue());
				this.forceUpdate();
			},
		};
		const {initValue, value} = this.props;
		let d = this.$genMenuData();
		if(orgType > 0){
			d = d['org' + orgType].data;
			if(!_.isNil(initValue)) this.state._initValue = this.state._value = this._preValue = _setDep(d, _normalizeDep(initValue));
			if(!_.isNil(value)) this.state._value = this._preValue = _setDep(d, _normalizeDep(value));
			this.state.type = this.menuProps.type = _.includes([1, 2, 3, 4, 5], orgType) ? orgType : 1;
		}
		else{
			if(!_.isNil(initValue)){
				const {org, values} = _setOrgDep(initValue, d);
				this.state._initValue = this.state._value = this._preValue = values;
				if(org) this.state.type = this.menuProps.type = org;
				else if (initType && this.menuProps.types[initType]) this.state.type = this.menuProps.type = initType;
			}
			if (!_.isNil(initType) && this.menuProps.types[initType]) {
				this.state.type = this.menuProps.type = initType
			}
			if(!_.isNil(value)){
				const {org, values} = _setOrgDep(value, d);
				this.state._value = this._preValue = values;
				if(org) this.state.type = this.menuProps.type = org;
			}
			if (_.isNil(this.state.type)) this.state.type = this.menuProps.type = 1;
		}
	}

	_checkUpdate(cb) {
		if (!this.validate()) return;

		if(_.isFunction(cb)) cb();
		const value = this.getValue();
		if(!_.isEqual(this._preValue, value)){
			let newValue = _.cloneDeep(value);
			if(this._onUpdate) this._onUpdate(newValue, this._preValue);
			this._preValue = value;
		}
	}

	__clear() {
		_.each(this.state.data, (value, key) => _.map(value.data, _clear));
	}
	reset() {
		if (this.props.view) return;
		const {enable, editable, data, _initValue} = this.state;
		if (!data || !enable || !editable) return;

		if(_initValue) _setDep(this.$genMenuData()['org' + this.props.orgType].data, _initValue);
		else this.__clear();
		if(this.props.collapse)
			_.each(data, (value, key) => _.map(value.data, _collapse));

		this.state.error = false;
		this.state.hover = false;
		this.state.focus = false;
		this.forceUpdate();
	}

	_getSelectedIds() {
		const {orgType} = this.props;
		const {data, type} = this.state;
		const _get = (i, ids = [])  => {
			if(!data || !data['org' + i] || !data['org' + i].data) return ids;
			return _getIds(data['org' + i].data, ids);
		};
		return orgType > -1 ? _get(type) :
			[].concat(_get(1)).concat(_get(2)).concat(_get(3)).concat(_get(4)).concat(_get(5));
	}
	getValue() {
		const {orgType, validate} = this.props;
		const {data, type} = this.state;
		const _get = (t) => {
			if(!data || !data['org' + t]) return undefined;

			const v = _getIds(data['org' + t].data, []);
			return v.length > 0 ? {
				org: +data['org' + t].id,
				depts: validate && validate.max == 1 && v.length > 0 ? v[0] : v,
			} : undefined;
		};
		return orgType > -1 ? _get(type) :
			_.compact([_get(1), _get(2), _get(3), _get(4), _get(5)]);
	}
	setValue(value) {
		const {data, enable, editable} = this.state;
		if (!data || !enable || !editable) return;

		const {orgType} = this.props;
		this.__clear();
		if(orgType > 0)
			_setDep(data['org' + orgType].data, _normalizeDep(value));
		else{
			const {org, values} = _setOrgDep(value, data);
			if(org) this.state.type = this.menuProps.type = org;
		}
		this.forceUpdate();
	}

	getText(){
		const {orgType, validate} = this.props;
		const {data, type} = this.state;
		const _get = (t) => {
			if(!data || !data['org' + t]) return undefined;

			const v = _getTexts(data['org' + t].data, []);
			return v.length > 0 ?
				(validate && validate.max == 1 && v.length > 0 ? v[0] : v) : undefined;
		};
		return orgType > -1 ? _get(type) :
			_.compact([_get(1), _get(2), _get(3), _get(4), _get(5)]);
	}

	renderTag(data, idx) {
		const {orgType} = this.props;
		return orgType > -1 ? data.name : <>
			{data.name} <small className={'-org'}>{LocaleUtils.adapt(this.state.data['org' + data.org].name)}</small>
		</>;
	}
	renderItem(data, idx) {
		// 需要做到動態計算寬度，透過 props 的 parent
		return <TipDepItem data={data} />;
	}

	$genSelectedData() {
		const {orgType} = this.props;
		const {data, type} = this.state;
		const _get = (i, ss = []) => {
			if(!data || !data['org' + i] || !data['org' + i].data) return ss;
			return _.map(_getSelecteds(data['org' + i].data, ss), e => {
				e.org = i;
				return e;
			});
		};
		return orgType > -1 ? _get(type) :
			[].concat(_get(1)).concat(_get(2)).concat(_get(3)).concat(_get(4)).concat(_get(5));
	}
	$genMenuData(){
		return this.state.data;
	}
	$allowMenu(){
		return !_.isEmpty(this.menuProps.types);
	}

	menuComponent = 'DepPickerMenu';

	render() {
		const {orgType, emptyStyle=null} = this.props;
		const {data, type} = this.state;
		const org = data['org' + (orgType < 1 ? 1 : orgType)];
		if (!org || !org.data || org.data.length == 0) {
			return <span className={'block color-red'} style={{ lineHeight: '30px', ...emptyStyle }}>
				<i className={'fa fa-exclamation-circle'} />
				<I18n key1='components.Input' key2='theOrganizationChart' options={{'temp1': org ? LocaleUtils.adapt(org.name) : ''}} />
			</span>;
		}
		else return super.render();
	}
}
class DepPickerMenu extends TreePickerMenu {
	static version = '1.0.0';
	static defaultProps = {
		... TreePickerMenu.defaultProps,
		theme: 'pickerMenu tree dep',
	};
	state = {
		... this.state,
		type: this.props.type,
	};
	$data = () => {
		const {data, type:_type} = this.props;
		const {type} = this.state;
		const d = data['org' + (type || _type || 1)];
		return d ? d.data : [];
	};

	constructor(props) {
		super(props);
		const {collapse} = this.props;
		const data = this.$data();
		if(collapse && data) _.forEach(data, d => _collapse(d));
	}

	_filterInputs(){
		const {type, types, onSwitchType} = this.props;

		return <>
			<span className={'-orgType'}>
				{_.values(types).length > 1 ? <Select {... {
					className: 'sm empty',
					data: types,
					initValue: type,
					menuProps: {
						eventLevel: this.getEventLevel() + 1,
						className: 'level2',
						stickDirection: 'bottom',
						stickOffset: {x: -10, y: 1},
						pointer: 'top',
						pointerClassName: 'sm',
						pointerStyle: {
							left: 10,
						},
					},
					onUpdate: value => this.setState({type: value}, () => onSwitchType?.(value)),
				}} /> : <small className={'msg sm blue'}><i className={'fal fa-sm fa-sitemap'} /> {_.values(types)[0]}</small>}
			</span>
			{super._filterInputs()}
		</>;
	}


	renderBody() {
		const {mode, behavior, lock, renderItem, onToggle, inactiveText, nilText, inactiveIsReadOnly, max } = this.props;
		const {kw} = this.state;
		const data = this.$data();
		if(!data || data.length === 0) return null;

		const _renderTreeNode = (parent, d, idx, deep) => {
			const key = d.id === 0 ? 0 : (d.id || d.value);
			const checkable = mode === 'all' || ((mode === 'leaf' || mode === 'singleLeaf') && !d.hasOwnProperty('children'));
			const inactive = d.active === 0 || d.active === false;
			const _toggleCollapse = evt => {
				evt.stopPropagation();
				d._collapse = !d._collapse;
				this.forceUpdate(() => this.position());
			};
			const hasChildren = d.children && d.children.length > 0

			function trasevalTree(node, floor = 0, nodeCollapse = false) {
				let childrenSelected = 0;
				let childrenCount = 0;
				let notCollapseChildren = 0;
				let lastNodeCollapseChildren = 0;

				if (node._selected) {
					childrenSelected++
				}
				if (floor !== 0 && !nodeCollapse) {
					notCollapseChildren++
				}

				let isCollapse = nodeCollapse || node._collapse
				childrenCount++

				if (node.children) {
					floor++
					node.children.forEach((x, idx) => {
						const [a, b, c] = trasevalTree(x, floor, isCollapse)
						childrenSelected += a
						childrenCount += b

						const isCount = idx === node.children.length - 1
						if (floor == 1 && isCount) {
							lastNodeCollapseChildren = c
						}
						notCollapseChildren += c
					})
				}

				let resultNotCollapseChildren = notCollapseChildren - ((lastNodeCollapseChildren - 1) >= 0 ? (lastNodeCollapseChildren - 1) : 0)

				return [
					childrenSelected, childrenCount, notCollapseChildren, resultNotCollapseChildren
				]
			}
			const [ childrenSelected, childrenCount, _, notCollapseChildren ] = trasevalTree(d)


			return <React.Fragment key={key}>
				<li {... {
					className: (inactive ? 'inactive' : d._selected ? 'active' : lock && !d._selected ? 'lock' : '') + (
						!deep && !hasChildren ? ' -no-border' : ''
					),
					style: {
						// '--border-width': `${35 + (hasChildren ? 0 : 30) + (d.children && checkable ? 0 : 22) }px`
						'--border-width': `${35 + (max !== 1 && hasChildren ? 10 : 0)}`,
						'--max': `${max}`
					}
				}}>
					{hasChildren ? <span {... {
						className: `-knot fal fa-${d._collapse ? 'plus' : 'minus'}-square`,
						onClick: _toggleCollapse,
					}} /> :  <i className={`-knot`} />}
					{d.children && checkable && max !== 1 ? (
						<span className={'checkbox' + (
									childrenSelected === childrenCount ? ' checked' : ''
							  ) + (
									childrenSelected !== childrenCount && childrenSelected > 0 ? ' partial' : ''
							  ) + (
								lock && !d._selected ? ' disable' : ''
							  )}
							  onClick={() => {
								if (childrenSelected < childrenCount) {
									this._selectAllNode([d])
								} else {
									this._selectAllNode([d], false)
								}
						}} />
					) : (
						<span style={{ display: 'inline-block', width: 2 }}></span>
					) }
					<span {... {
						... inactive && inactiveIsReadOnly ? null : {onClick: checkable ? evt => onToggle(d, parent) : _toggleCollapse},
					}}>
						{checkable ? (
							<span className={'checkbox' + (d._selected ? ' checked' : '') + (lock && !d._selected ? ' disable' : '')}  />
						) : null}
						{renderItem(d, idx)}
						{inactive ? <small className={'msg sm red'} style={{margin: '0 5px'}}>
						<i className={'fa fa-sm fa-exclamation-circle'} /> {inactiveText}</small> : null}
					</span>
				</li>
				{d.children && !d._collapse ? <ul style={{
					'--border-height': `${19 + ((notCollapseChildren - 1) * 27)}px`,
					'--children': notCollapseChildren,
				}}>
					{d.children.map((child, i) => _renderTreeNode(d, child, i, deep + 1))}
				</ul> : null}
			</React.Fragment>;
		};

		if(!kw) return (
			<div className='-dep-picker-menu'>
				{
					max !== 1 && (
						<div className='-bars'>
							<div onClick={() => {
								this._selectAllNode(data)
							}}>{OptionUtils.getLabel('global.normal', 'selectAll')}</div>
							<div onClick={() => {
								this._selectAllNode(data, false)
							}}>{OptionUtils.getLabel('hp.m3.m310410_shifting', 'clearThemAll')}</div>
						</div>
					)
				}
				<ul>{data.map((d, idx) => _renderTreeNode(null, d, idx, 0))}</ul>
			</div>
		);

		const _data = kw ? this._find(data, kw, []) : data;
		if(!_data || _data.length === 0)
			return <div className={'notice notice-sm ico'} style={{margin: 6}}>
				<i className={'fa fa-info-circle'} /> {nilText}
			</div>;

		return <ul>
			{_data.map((d, idx) => {
				const _lock = (behavior != 'jira' && lock) || (lock && behavior === 'jira' && !d._selected);
				const inactive = d.active === 0 || d.active === false;
				return <li key={idx} {...{
					className: `${_lock ? ' lock' : ''}${d._selected ? ' active' : ''}${inactive ? ' inactive' : ''}`,
					onClick: evt => onToggle(d),
				}}>
					{renderItem(d, idx)}
					{inactive ? <small className={'msg sm red'} style={{margin: '0 5px'}}>
						<i className={'fa fa-sm fa-exclamation-circle'} /> {inactiveText}</small> : null}
				</li>;
			})}
		</ul>;
	}
}

class PostcodePicker extends TreePicker {
	static version = '0.0.1';
	static defaultProps = {
		... TreePicker.defaultProps,
		mode: 'leaf',
		placeholder: OptionUtils.getLabel('components.Input', 'countiesCitiesAndTownships'),
		indicator: false,
		validate: {
			max: 1,
		},
		finder: (d, kw) => {
			let { name } = d;
			const exp = new RegExp(_.escapeRegExp(kw), 'i');
			return name && exp.test(LocaleUtils.adapt(name));
		},
	};

	$init(){
		const _transform = (src) => {
			return _.transform(src, (result, value, key) => result.push({
				id: _.isNaN(+key) ? key : +key,
				name: LocaleUtils.adapt(value.name),
				... value.hasOwnProperty('children') ? {children: _transform(value.children)} : null
			}), []);
		};
		this.state.data = _transform(POSTAL);

		const {initValue, value} = this.props;
		const d = this.$genMenuData();
		if(!_.isNil(initValue)) this.state._initValue = this.state._value = this._preValue = _setTreeValue(initValue, d);
		if(!_.isNil(value)) this.state._value = this._preValue = _setTreeValue(value, d);

		const {collapse, mode, validate} = this.props;
		this.menuProps = {
			mode, collapse,
			onToggle: (data) => {
				if (data._selected) data._selected = false;
				else {
					const max = validate && validate.max ? validate.max : undefined;
					const ids = this._getSelectedIds();
					if(max == 1) this.__clear();
					else if (max > 1 && ids && ids.length >= max) return;
					data._selected = true;
				}
				this.forceUpdate();
			},
			onToggles: (selectedData) => {
				// 這裡只會有可以選的東西進來
				// mode 為 singleLeaf 時，不能再選的節點已經會被過濾掉
				if (_.isEmpty(selectedData)) return;
				_.each(selectedData, data => data._selected = true);
				_.each(d, _d => _collapse(_d));
				if (_.isFunction(this._onEditing)) this._onEditing(this._getSelectedIds());
				this.forceUpdate();
			},
		};
	}

	renderItem(data, idx) {
		return data.name;
	}
}

class CategoryPicker extends TreePicker {
	static version = '0.0.1';
	static propTypes = {
		... TreePicker.propTypes,
		type: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 77]),
	};
	static defaultProps = {
		... TreePicker.defaultProps,
		mode: 'leaf',
		type: 1,
		finder: (d, kw) => {
			let { text } = d;
			const exp = new RegExp(_.escapeRegExp(kw), 'i');
			return text && exp.test(LocaleUtils.adapt(text));
		},
	};

	$init(n) {
		const {type} = this.props;
		if (!Constants.J104.Categories) return setTimeout(() => this.$init((n || 0) + 1), 50);
		this.state.data = _.cloneDeep(Constants.J104.Categories[type + '000000000']);
		_.map(this.state.data, _collapse);

		super.$init();
		if (!n) return;
		if (this._preVal) super.setValue(this._preVal);
		else this.forceUpdate();
	}

	renderTag(data, idx) {
		return data.text;
	}

	renderItem(data, idx) {
		return data.text;
	}

	setValue(value) {
		this._preVal = value;
		super.setValue(value);
	}
}
class Cate1Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 1
	};
}
class Cate2Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 2
	};
}
class Cate3Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 3
	};
}
class Cate4Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 4
	};
}
class Cate5Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 5
	};
}
class Cate6Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 6
	};
}
class Cate7Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 7
	};
}
class Cate8Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 8
	};
}
class Cate9Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 9
	};
}
class Cate11Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 11
	};
}
class Cate12Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 12
	};
}
class Cate77Picker extends CategoryPicker {
	static defaultProps = {
		... CategoryPicker.defaultProps,
		type: 77
	};
}

class UnfoldedPicker extends ReactInputWithData {
	static version = '1.0.0';
	static propTypes = {
		...ReactInputWithData.propTypes,
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	};
	static defaultProps = {
		...ReactInputWithData.defaultProps,
		isTitle: true,
		isFooter: true,
		filter: true,
		checkable: true,
		toggleOnRow: true,
		basicCriteria: {},
		advCriteria: {},
		totalCounter: data => !!data._selected,
		currCounter: data => !!data._selected,
		emptyWarning: OptionUtils.getLabel('global.normal', 'noInfo'),
	};
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		max: OptionUtils.getLabel('components.Input', 'youCanSelectUpTo'),
		min: OptionUtils.getLabel('components.Input', 'atLeastMin'),
	};

	state = {
		...this.state,
		value: [],
		criteriaType: 'basic',
		_criteria: {},
	};
	_preCriteria = null;
	_preAdvCriteria = null;

	constructor(props) {
		super(props);

		const { data } = props;
		if (!_.isArray(data)) throw 'data must be an array';

		this.renderItem = this.renderItem.bind(this);
		this._checkAll = this._toggleAll.bind(this, true);
		this._uncheckAll = this._toggleAll.bind(this, false);

		this.$init();
	}

	$init() {
		const { data, filter, value, initValue } = this.props;
		const { _criteria } = this.state;

		this.state._preData = data;
		this.state.data = ReactInputWithData._transformData(data) || [];
		this.state.filteredData = UnfoldedPicker._getFilteredData(this.state.data, filter, _criteria);
		this.state.dataProp = _.isEmpty(this.state.data) ? 'id' : ___getDataProp(this.state.data[0]);

		if (!_.isNil(value)) {
			this.state._value = value;
			this.state._preValue = value;
			const v = _.isArray(value) ? value : [value];
			this.state.value = ___setValue(v, this.state.data);
		} else if (!_.isNil(initValue)) {
			const v = _.isArray(initValue) ? initValue : [initValue];
			this.state.value = ___setValue(v, this.state.data);
		}
	}

	static getDerivedStateFromProps(props, state) {
		// NOTE
		// _value 要記著上一次的 props.value (這在 ReactInput.getDerivedStateFromProps 已經處理好了)
		// 不能跟 data 現有的選項值做 intersection
		// 否則每次重 render 都會被選回 props.value 的值
		// 所以這邊的處理方式跟 Picker 不太一樣

		// TODO 這邊是故意繞過 ReactInputWithData 還是寫錯了？
		// ReactInputWithData.getDerivedStateFromProps(props, state);
		let s = ReactInput.getDerivedStateFromProps(props, state);

		const { data } = props;
		const { _initValue, _preData } = state;
		if (!_.isEqual(data, _preData)) {
			const transformedData = ReactInputWithData._transformData(data);

			if (!s) s = {};
			s.data = transformedData || [];
			s._preData = data;
			s.filteredData = UnfoldedPicker._getFilteredData(s.data, props.filter, state._criteria);
		}

		if (!s) return s;

		if (s.data)
			s.dataProp = _.isEmpty(s.data) ? 'id' : ___getDataProp(s.data[0]);
		if (s.value || s.data) {
			// props.value 或 props.data 有異動時，要以現有的 data 重新選取 value 的項目
			const d = s.data || state.data;
			let v = s.value || (_.isObject(state.value) ? _.cloneDeep(state.value) : state.value);
			v = _.isArray(v) ? v : [v];
			s.value = ___setValue(v, d);
		} else if (!_.isNil(_initValue)) {
			// TODO not confirmed
			// TODO not confirmed
			// TODO not confirmed
			// state._initValue 有資料時，要選取 _initValue 的項目 (前提是沒有 value)
			// _initValue 只會在 $init() 被設定一次，且這邊執行後會刪除該 state
			const v = _.isArray(_initValue) ? _initValue : [_initValue];
			s.value = ___setValue(v, s.data || state.data);
			delete state._initValue;
		}
		return s;
	}

	static _getFilteredData(data, filter, _criteria) {
		if (_.isEmpty(data)) return [];
		if (!_.isFunction(filter) || _.isEmpty(_criteria)) return [...data];
		return _.filter(data, _data => filter(_criteria, _data));
	}

	scrollRef = React.createRef();

	_validate() {
		const { errorMsg } = this.props;
		const { required, min, max } = this.$getValidateRules();
		const ids = this.getSelectedIds();
		if (required && _.isEmpty(ids)) {
			return (errorMsg && errorMsg.required) || UnfoldedPicker.ERROR.required;
		}
		if (min && ids.length < min) {
			return _.template((errorMsg && errorMsg.min) || UnfoldedPicker.ERROR.min)({ min });
		}
		if (max && ids.length > max) {
			return _.template((errorMsg && errorMsg.max) || UnfoldedPicker.ERROR.max)({ max });
		}
		return true;
	}

	validate() {
		if (super.validate()) return true;

		const success = this._validate();
		if (success !== true) {
			this.setState({ error: success });
			return false;
		}
		return true;
	}

	/**
	 * 取得所有已勾選的主 key 值，無論是否 filtered
	 * @return {undefined|*[]}
	 */
	getValue() {
		const { enable, error, data } = this.state;
		if (!enable || error || _.isEmpty(data)) return undefined;
		return this.getSelectedIds();
	}

	/**
	 * 取得所有已勾選的主 key 值，無論是否 filtered
	 * @return {*[]}
	 */
	getSelectedIds() {
		const { data, dataProp } = this.state;
		if (_.isEmpty(data)) return [];
		return _.transform(data, (acc, _data) => {
			if (_data._selected) acc.push(_data[dataProp]);
		}, []);
	}

	/**
	 * 取得所有已勾選的 data，無論是否 filtered
	 * @return {*[]}
	 */
	getSelectedData() {
		const ids = this.getSelectedIds();
		const { data, dataProp } = this.state;
		if (_.isEmpty(ids) || _.isEmpty(data)) return [];
		return _.transform(data, (acc, _data, idx) => {
			if (_.includes(ids, _data[dataProp])) acc.push(_.cloneDeep(_data));
		}, []);
	}

	setValue(value, cb) {
		const { data, dataProp } = this.state;
		this.state.value = [];
		if (!_.isArray(value)) value = [value];
		const _value = [];
		_.each(data, _data => {
			_data._selected = value.includes(_data[dataProp]);
			if (_data._selected) _value.push(_data[dataProp]);
		});
		this.setState({
			value: _value,
			error: false,
		}, cb);
		return this;
	}

	getText() {
		const data = this.getSelectedData();
		if (_.isEmpty(data)) return undefined;
		const texts = _.transform(data, (acc, _data) => {
			acc.push(_data.name || _data.text || _.data.label);
		}, []);
		return texts.length === 1 ? texts[0] : texts;
	}

	reset() {
		if (!super.reset()) return false;
		const { initValue = [] } = this.props;
		this.setValue(initValue);
		return this;
	}

	renderItem(data, idx) {
		const { renderItem: customRender } = this.props;
		if (!_.isNil(customRender)) return _.isFunction(customRender) ? customRender(data, idx) : customRender;

		return <span>{data.name}</span>;
	}

	_toggle(data, idx) {
		const { checkable, onCheckOne } = this.props;
		const isCheckable = _.isFunction(checkable) ? checkable(data, idx) : !!checkable;
		if (!isCheckable) return;

		let { value, dataProp } = this.state;

		data._selected = !data._selected;
		if (data._selected) value = [...value, data[dataProp]];
		else value = _.without(value, data[dataProp]);
		if (onCheckOne) onCheckOne(data);
		this.setState({ value, error: false });
	}

	_toggleAll(doSelect) {
		const { filteredData } = this.state;
		if (_.isEmpty(filteredData)) return;

		let { checkable, onCheck } = this.props;
		if (!_.isFunction(checkable)) checkable = checkable ? () => true : () => false;

		let { value, dataProp } = this.state;
		const ids = [];
		if (doSelect) {
			_.each(filteredData, (_data, idx) => {
				if (_data._selected || !checkable(_data, idx)) return;
				_data._selected = true;
				ids.push(_data[dataProp]);
			});
			if (onCheck) onCheck(ids, 1);
			value = [...value, ...ids];
		} else {
			_.each(filteredData, (_data, idx) => {
				if (!_data._selected || !checkable(_data, idx)) return;
				_data._selected = false;
				ids.push(_data[dataProp]);
			});
			if (onCheck) onCheck(ids);
			value = _.without(value, ...ids);
		}

		this.setState({ value, error: false });
	}

	_renderFilter() {
		const { _preCriteria } = this;
		const { basicCriteria, advCriteria, readOnly } = this.props;
		const { criteriaType, openAdvPanel, _criteria, _criteriaDescriptor } = this.state;
		const isBasic = criteriaType === 'basic';
		const isAdv = criteriaType === 'adv';

		return <>
			<div className="btn-group btn-group-white">
				{_.isEmpty(basicCriteria) ? null
					: <TipButton {...{
						disabled: readOnly,
						tip: OptionUtils.getLabel('components.Input', 'easyFiltering'),
						className: `-sb btn fa fa-search${isBasic ? ' active' : ''}`,
						...isBasic ? null : {
							onClick: evt => {
								this.setState({ _criteria: {}, criteriaType: 'basic' }, this._doFilter);
							},
						},
					}} />}
				{_.isEmpty(advCriteria) ? null
					: <TipButton {...{
						disabled: readOnly,
						tip: OptionUtils.getLabel('components.Input', 'advancedFiltering'),
						className: `-sb btn fa fa-sliders-h${isAdv ? ' active' : ''}`,
						onClick: evt => {
							if (isBasic) this.setState({ criteriaType: 'adv' });
							if (!openAdvPanel) {
								this.setState({ openAdvPanel: true });
								if (_.isFunction(this.props.onAdvPanelOpen))
									this.props.onAdvPanelOpen();
							}
						},
					}} />}
			</div>
			<div className="-criteria">
				{!isBasic ? null
					: _.map(basicCriteria, (criterion, key) => {
						const initValue = (_preCriteria || {})[key];
						const { input } = criterion;
						return React.cloneElement(input, {
							key,
							readOnly,
							..._.isNil(initValue) ? null : { initValue },
							onUpdate: value => {
								const _criteria = _.pickBy({
									...this.state._criteria,
									[key]: value,
								}, __clear);
								this._doFilter(_criteria);
							},
						});
					})}
				{!isAdv ? null
					: openAdvPanel ? <small className="color-lightGray">
							{OptionUtils.getLabel('components.Input', 'advancedFilterSettings')}
						</small>
						: <AdvCriteriaDescriptor {...{
							src: advCriteria,
							criteria: _criteria,
							descriptor: _criteriaDescriptor,
							onClick: evt => {
								this.setState({ openAdvPanel: true });
								if (_.isFunction(this.props.onAdvPanelOpen))
									this.props.onAdvPanelOpen();
							},
							onRemove: key => {
								const criteria = { ..._criteria };
								delete criteria[key];
								if (_.size(criteria) > 0) this._doFilter(criteria);
								else this.setState({ criteriaType: 'basic', _criteria: null }, this._doFilter);
							},
						}} />}
			</div>
		</>;
	}

	_renderCtrls() {
		const { unit, totalCounter, currCounter, custHead } = this.props;
		const {
			data: allData, filteredData,
			enable, editable,
		} = this.state;

		const totalSelected = _.reduce(allData, (acc, d) => totalCounter(d) ? acc + 1 : acc, 0);
		const currSelected = _.reduce(filteredData, (acc, d) => currCounter(d) ? acc + 1 : acc, 0);

		return <>
			<div className="-checkbox">
				<span {...{
					className: `checkbox${currSelected === 0 ? '' : currSelected === filteredData.length ? ' checked' : ' partial'}${enable && editable ? '' : ' disable'}`,
					...!enable || !editable ? null : {
						onClick: currSelected === filteredData.length ? this._uncheckAll : this._checkAll,
					},
				}} />
			</div>
			{custHead
				? <div className="-indicator">{custHead}</div>
				:
			<div className="-indicator">
				{OptionUtils.getLabel('components.Input', 'selected')} <span>{totalSelected}</span> {unit}
			</div>
			}
		</>;
	}

	renderExtraCtrls() {
		const { renderExtraCtrls: customRender } = this.props;
		if (!_.isNil(customRender)) return _.isFunction(customRender) ? customRender() : customRender;
		return null;
	}

	_renderAdvCriteriaBox() {
		const { _preCriteria, _preAdvCriteria } = this;
		const { advCriteria } = this.props;
		const { _criteriaDescriptor } = this.state;

		return <AdvCriteriaBox {...{
			theme: 'gridAdv',
			pointer: false,
			stickDirection: 'inside',
			stickOffset: {},
			src: advCriteria,
			criteria: _preAdvCriteria || {},
			descriptor: _criteriaDescriptor,
			onOk: (criteria, descriptor) => {
				this.setState({
					openAdvPanel: false,
					_criteria: criteria,
					_criteriaDescriptor: descriptor,
				}, this._doFilter);
				if (_.isFunction(this.props.onAdvPanelClose))
					this.props.onAdvPanelClose();
			},
			close: () => {
				if (_preAdvCriteria) this.setState({ openAdvPanel: false });
				else this.setState({ openAdvPanel: false, criteriaType: 'basic', _criteria: _preCriteria });
				if (_.isFunction(this.props.onAdvPanelClose))
					this.props.onAdvPanelClose();
			},
		}} />;
	}

	/**
	 * 篩選 data
	 * (呼叫此 method 後，this.state.filteredData 必定會被更新)
	 * @param {object} [_criteria] 篩選條件，沒傳入的話會用 this.state._criteria 做篩選
	 * @private
	 */
	_doFilter(_criteria) {
		const { filter } = this.props;
		const { data, criteriaType } = this.state;

		if (_.isNil(_criteria)) _criteria = this.state._criteria;
		else this.setState({ _criteria });

		this[criteriaType === 'basic' ? '_preCriteria' : '_preAdvCriteria'] = _criteria;
		this[criteriaType !== 'basic' ? '_preCriteria' : '_preAdvCriteria'] = null;

		const filteredData = UnfoldedPicker._getFilteredData(data, filter, _criteria);
		this.setState({ filteredData });
	}

	_renderItem(_data, idx, otherProps) {
		const { checkable, toggleOnRow, custItem, locked } = this.props;
		const { enable, editable, dataProp } = this.state;

		const isCheckable = _.isFunction(checkable) ? checkable(_data, idx) : !!checkable;

		return <div {...{
			key: String(_data && _data[dataProp]) || idx,
			className: '-item', ...custItem,
			...toggleOnRow && enable && editable && isCheckable ? {
				onClick: () => this._toggle(_data, idx),
			} : null,
			// ...otherProps,
		}}>
			<div className="-checkbox">
				{!isCheckable ? locked && locked(_data, enable && editable, idx)
					: <span {...{
						className: `checkbox${_data._selected ? ' checked' : ''}${enable && editable ? '' : ' disable'}`,
						...!toggleOnRow && enable && editable ? {
							onClick: () => this._toggle(_data, idx),
						} : null,
					}} />}
			</div>
			<div className="-body">{this.renderItem(_data, idx)}</div>
		</div>;
	}

	renderTitle() {
		const { title } = this.props;
		const {
			error,
			data: allData,
		} = this.state;

		return <div className="-title">
			{title} (<span>{allData ? allData.length : 0}</span>)
			{error ? <i className={'-err color-red fa fa-sm fa-exclamation-circle'} /> : null}
		</div>;
	}

	renderBody() {
		const { bodyStyle, emptyWarning } = this.props;
		const { filteredData, _criteria } = this.state;
		console.log(this.scrollRef.current)

		return <div {...{
			className: '-body -container',
			ref: this.scrollRef,
			...bodyStyle && { style: bodyStyle },
		}}>
			{_.isEmpty(filteredData) && !_.isEmpty(_criteria)
				? (!emptyWarning ? null
					: <div className={'-noticeWrapper'}>
						<div className={'-msg msg blue'}><i className={'fa fa-info-circle'} /> {emptyWarning}</div>
					</div>)
				: (
					// _.map(filteredData, (_data, idx) => this._renderItem(_data, idx))
					<VirtualListBasic rows={filteredData} container={this.scrollRef} itemHeight={34}>
						{this._renderItem.bind(this)}
					</VirtualListBasic>
				)}
		</div>;
	}

	renderFooter() {
		const { renderFooter: customRender, footerStyle } = this.props;
		return <div {...{
			className: '-footer',
			...footerStyle && { style: footerStyle },
		}}>
			{_.isNil(customRender) ? null : _.isFunction(customRender) ? customRender() : customRender}
		</div>;
	}

	render() {
		// TODO body 或許可以指定 Picker 類型?
		// TODO 如此一來預設的實作可能類似塞一個 PickerMenu 在裡面
		const { theme, width, height, isTitle, isFooter, basicCriteria, advCriteria } = this.props;
		const { error, hover, openAdvPanel } = this.state;

		return <div {...{
			ref: ele => this._dom.root = ele,
			className: `H2-UnfoldedPicker ${theme ? theme : ''}${error ? ' error' : ''}`,
			style: {
				...width && { width },
				...height && { height },
			},
			...!error || openAdvPanel ? null : {
				...hover ? { onMouseLeave: () => this.setState({ hover: false }) } : null,
				...!hover ? { onMouseEnter: () => this.setState({ hover: true }) } : null,
			},
		}}>
			<div className="-header">
				{isTitle && this.renderTitle()}
				{_.isEmpty(basicCriteria) && _.isEmpty(advCriteria) ? null
					: <div className="-filter">{this._renderFilter()}</div>}
				<div className="-ctrls">
					{this._renderCtrls()}
					<div className="-extraCtrls">{this.renderExtraCtrls()}</div>
				</div>
			</div>
			{this.renderBody()}
			{isFooter && this.renderFooter()}
			{!openAdvPanel ? null : this._renderAdvCriteriaBox()}
			{!(error && hover) || openAdvPanel ? null : <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				pointerStyle: { right: 20, left: 'unset' },
				theme: 'validate',
			}}>{error}</Tip>}
		</div>;
	}
}

class TwoSidePicker extends ReactInputWithData {
	static version = '1.0.0';
	static ERROR = {
		required: OptionUtils.getLabel('components.Input', 'requiredField'),
		max: OptionUtils.getLabel('components.Input', 'youCanSelectUpTo'),
		min: OptionUtils.getLabel('components.Input', 'atLeastMin'),
	};

	static propTypes = {
		...ReactInputWithData.propTypes,
		height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	};
	static defaultProps = {
		...ReactInputWithData.defaultProps,
		leftComponent: UnfoldedPicker,
		rightComponent: UnfoldedPicker,
		/**
		 * 用來分出餵給左右邊 Picker 的 data
		 * @param {object[]} srcData
		 * @param {number[]} srcValue
		 * @param {string} [dataProp] srcData 的 PK 名稱，沒有的話會嘗試從 srcData[0] 裡尋找，找不到就跳錯
		 * @returns {[object[], object[], (number[]|undefined)]} [leftSideData, rightSideData, rightSideIds]
		 */
		valueSetter: (srcData, srcValue, dataProp) => {
			const data = [], valueData = [];
			if (_.isEmpty(srcData)) return [data, valueData, undefined];
			if (_.isNil(dataProp)) dataProp = ___getDataProp(srcData[0]);
			const validValue = [];
			_.each(srcData, _data => {
				_data = _.cloneDeep(_data);
				if (_.includes(srcValue, _data[dataProp])) {
					validValue.push(_data[dataProp]);
					valueData.push(_data);
				} else data.push(_data);
			});
			return [data, valueData, validValue];
		},
	};

	constructor(props) {
		super(props);

		this._checkUpdate = this._checkUpdate.bind(this);
		this.moveToRight = this.moveToRight.bind(this, this._checkUpdate);
		this.moveToLeft = this.moveToLeft.bind(this, this._checkUpdate);
		this.leftCtrls = this.leftCtrls.bind(this);
		this.rightCtrls = this.rightCtrls.bind(this);

		this.$init();
	}

	$init() {
		let { data, value, initValue, valueSetter } = this.props;
		data = ReactInputWithData._transformData(data) || [];
		const dataProp = this.state.dataProp = _.isEmpty(data) ? 'id' : ___getDataProp(data[0]);
		let srcValue = value || initValue;
		if (_.isNil(srcValue)) srcValue = [];
		else if (!_.isArray(srcValue)) srcValue = [srcValue];
		const [leftData, rightData, validValue] = valueSetter(data, srcValue, dataProp);
		this.state.data = data;
		this.state._preData = data;
		this.state.leftData = leftData;
		this.state.rightData = rightData;
		this._preValue = validValue;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		if (this.state.__setPreValue) {
			this._preValue = this.state.__setPreValue;
			delete this.state.__setPreValue;
		}
	}

	static getDerivedStateFromProps(props, state) {
		const s = ReactInputWithData.getDerivedStateFromProps(props, state);

		if (s && (s.value || s.data)) {
			if (s.data)
				s.dataProp = _.isEmpty(s.data) ? 'id' : ___getDataProp(s.data[0]);

			const data = s.data || state.data;
			const value = s.value || state.value;
			const [leftData, rightData, validValue] = props.valueSetter(data, value, s.dataProp);
			s.leftData = leftData;
			s.rightData = rightData;
			s.__setPreValue = validValue; // 為了更新 this._preValue
		}

		return s;
	}

	_validate() {
		const { errorMsg } = this.props;
		const { rightData } = this.state;
		const { required, min, max } = this.$getValidateRules();

		if (required && _.isEmpty(rightData)) {
			return (errorMsg && errorMsg.required) || TwoSidePicker.ERROR.required;
		}
		if (min && rightData.length < min) {
			return _.template((errorMsg && errorMsg.min) || TwoSidePicker.ERROR.min)({ min });
		}
		if (max && rightData.length > max) {
			return _.template((errorMsg && errorMsg.max) || TwoSidePicker.ERROR.max)({ max });
		}
		return true;
	}

	validate() {
		if (super.validate()) return true;

		const success = this._validate();
		if (success !== true) {
			this.setState({ error: success });
			return false;
		}
		return true;
	}

	getValue() {
		const { enable, error, rightData, dataProp } = this.state;
		if (!enable || error || _.isEmpty(rightData)) return undefined;
		return _.map(rightData, _data => _data[dataProp]);
	}

	getData() {
		const { enable, error, rightData, dataProp } = this.state;
		if (!enable || error || _.isEmpty(rightData)) return undefined;
		return _.map(rightData, _.cloneDeep);
	}

	setValue(value, cb) {
		const { valueSetter } = this.props;
		const { data, dataProp } = this.state;
		if (!_.isArray(value)) value = [value];
		const [leftData, rightData, validValue] = valueSetter(data, value, dataProp);
		this.setState({
			leftData,
			rightData,
		}, () => {
			this._preValue = validValue;
			if (_.isFunction(cb)) cb();
		});
		return this;
	}

	getText() {
		const { rightData } = this.state;
		if (_.isEmpty(rightData)) return undefined;
		const texts = _.transform(rightData, (acc, _data) => {
			acc.push(_data.name || _data.text || _.data.label);
		}, []);
		return texts.length === 1 ? texts[0] : texts;
	}

	reset() {
		if (!super.reset()) return false;
		const { initValue = [] } = this.props;
		this.setValue(initValue);
		return this;
	}

	_checkUpdate() {
		const { onUpdate } = this.props;
		if (!_.isFunction(onUpdate)) return;

		const { _preValue } = this;
		const { rightData, dataProp } = this.state;
		const value = _.map(rightData, dataProp);

		if (!_.isEqual(value, _preValue)) {
			this._preValue = value;
			onUpdate(value, _preValue);
		}
	}

	/**
	 * @param {function} [cb]
	 */
	moveToRight(cb) {
		const { valueSetter } = this.props;
		const { data, rightData, dataProp } = this.state;
		const leftIds = this._leftPicker.getSelectedIds();
		let rightIds = _.map(rightData, dataProp);
		const moveIds = _.without(leftIds, ...rightIds);
		if (_.isEmpty(moveIds)) return;

		rightIds = [...rightIds, ...moveIds];
		const [remainsData, movedData] = valueSetter(data, rightIds, dataProp);
		this.setState({
			leftData: remainsData,
			rightData: movedData,
			error: false,
		}, () => {
			if (this.validate()) cb();
		});
	}

	/**
	 * @param {function} [cb]
	 */
	moveToLeft(cb) {
		const { valueSetter } = this.props;
		const { data, leftData, dataProp } = this.state;
		let leftIds = _.map(leftData, dataProp);
		const rightIds = this._rightPicker.getSelectedIds();
		const moveIds = _.without(rightIds, ...leftIds);
		if (_.isEmpty(moveIds)) return;

		leftIds = [...leftIds, ...moveIds];
		const [remainsData, movedData] = valueSetter(data, leftIds, dataProp);
		this.setState({
			leftData: movedData,
			rightData: remainsData,
			error: false,
		}, () => {
			if (this.validate()) cb();
		});
	}

	leftCtrls() {
		const { enable, editable, leftData } = this.state;
		const ids = this._leftPicker ? this._leftPicker.getSelectedIds() : [];
		const isEnable = enable && editable && leftData.length !== 0 && ids.length !== 0;
		return <button {...{
			type: 'button',
			className: `btn btn-success${isEnable ? '' : ' disabled'}`,
			...!isEnable ? null : {
				onClick: this.moveToRight,
			},
		}}>{OptionUtils.getLabel('components.Input', 'join')} <i className="fa fa-arrow-right" /></button>;
	}

	rightCtrls() {
		const { enable, editable, rightData } = this.state;
		const ids = this._rightPicker ? this._rightPicker.getSelectedIds() : [];
		const isEnable = enable && editable && rightData.length !== 0 && ids.length !== 0;
		return <button {...{
			type: 'button',
			className: `btn btn-success${isEnable ? '' : ' disabled'}`,
			...!isEnable ? null : {
				onClick: this.moveToLeft,
			},
		}}><i className="fa fa-arrow-left" /> {OptionUtils.getLabel('global.normal', 'remove')}</button>;
	}

	renderLeftPicker() {
		// TODO 左右 Picker Component 的部分，應該只負責選取，不要包含 title 或 ctrls
		// TODO 要不就是 UnfoldedPicker 可以指定 body 的 Picker 類型?
		const { leftComponent: Component, shareProps, leftProps } = this.props;
		const { leftData, enable, editable } = this.state;
		return <Component {...{
			theme: '-twoSide',
			disable: !enable,
			readOnly: !editable,
			onAdvPanelOpen: () => this.setState({ advPanelOpened: true }),
			onAdvPanelClose: () => this.setState({ advPanelOpened: false }),
			...shareProps,
			...leftProps,
			ref: ele => this._leftPicker = ele,
			data: leftData,
			height: '100%',
			renderExtraCtrls: this.leftCtrls,
		}} />;
	}

	renderRightPicker() {
		// TODO 左右 Picker Component 的部分，應該只負責選取，不要包含 title 或 ctrls
		// TODO 要不就是 UnfoldedPicker 可以指定 body 的 Picker 類型?
		const { rightComponent: Component, shareProps, rightProps, validate } = this.props;
		const { rightData, enable, editable } = this.state;
		const max = validate?.max;
		return <Component {...{
			theme: '-twoSide',
			disable: !enable,
			readOnly: !editable,
			onAdvPanelOpen: () => this.setState({ advPanelOpened: true }),
			onAdvPanelClose: () => this.setState({ advPanelOpened: false }),
			...shareProps,
			...rightProps,
			ref: ele => this._rightPicker = ele,
			data: rightData,
			height: '100%',
			renderExtraCtrls: this.rightCtrls,
			...max && { max },
		}} />;
	}

	render() {
		const { theme, height } = this.props;
		const { error, hover, advPanelOpened } = this.state;
		return <div {...{
			ref: ele => this._dom.root = ele,
			className: `H2-TwoSidePicker ${theme ? theme : ''}${error ? ' error' : ''}`,
			style: { height },
			...!error || advPanelOpened ? null : {
				...hover ? { onMouseLeave: () => this.setState({ hover: false }) } : null,
				...!hover ? { onMouseEnter: () => this.setState({ hover: true }) } : null,
			},
		}}>
			{this.renderLeftPicker()}
			{this.renderRightPicker()}
			{error ? <i className={'-err color-red fa fa-sm fa-exclamation-circle'} /> : null}
			{!(error && hover) || advPanelOpened ? null : <Tip {...{
				stick: this._dom.root,
				stickDirection: 'top',
				stickAlign: 1,
				pointerStyle: { right: 20, left: 'unset' },
				theme: 'validate',
			}}>{error}</Tip>}
		</div>;
	}
}

class SortableUnfoldedPicker extends UnfoldedPicker {
	constructor(props) {
		super(props);
		this._moveTop = this._moveTop.bind(this);
		this._moveUp = this._moveUp.bind(this);
		this._moveDown = this._moveDown.bind(this);
		this._moveBottom = this._moveBottom.bind(this);
	}

	getSortedDataIds() {
		// TODO Picker-compatible
		return _.map(this.state.data, this.state.dataProp);
	}

	_moveTop() {
		const { filter } = this.props;
		const { data, dataProp, _criteria } = this.state;
		const ids = this.getSelectedIds();
		const newData = _.transform(data, (acc, _data) => {
			if (_.includes(ids, _data[dataProp])) acc.push(_data);
		}, []);
		newData.push(..._.pull(data, ...newData));
		const filteredData = UnfoldedPicker._getFilteredData(newData, filter, _criteria);
		this.setState({ data: newData, filteredData });
	}

	_moveUp() {
		const { filter } = this.props;
		const { data, dataProp, _criteria } = this.state;
		const ids = this.getSelectedIds();
		const pickedData = _.transform(data, (acc, _data) => {
			if (_.includes(ids, _data[dataProp])) acc.push(_data);
		}, []);
		const newData = _.without(data, ...pickedData);
		const idx = _.indexOf(data, pickedData[0]);
		newData.splice(idx === 0 ? 0 : idx - 1, 0, ...pickedData);
		const filteredData = UnfoldedPicker._getFilteredData(newData, filter, _criteria);
		this.setState({ data: newData, filteredData });
	}

	_moveDown() {
		const { filter } = this.props;
		const { data, dataProp, _criteria } = this.state;
		const ids = this.getSelectedIds();
		const pickedData = _.transform(data, (acc, _data) => {
			if (_.includes(ids, _data[dataProp])) acc.push(_data);
		}, []);
		const newData = _.without(data, ...pickedData);
		const idx = _.indexOf(data, pickedData[pickedData.length - 1]) - (data.length - 1);
		const newIdx = idx >= -1 ? newData.length : (idx + 1);
		newData.splice(newIdx, 0, ...pickedData);
		const filteredData = UnfoldedPicker._getFilteredData(newData, filter, _criteria);
		this.setState({ data: newData, filteredData });
	}

	_moveBottom() {
		const { filter } = this.props;
		const { data, dataProp, _criteria } = this.state;
		const ids = this.getSelectedIds();
		const pickedData = _.transform(data, (acc, _data) => {
			if (_.includes(ids, _data[dataProp])) acc.push(_data);
		}, []);
		const newData = _.without(data, ...pickedData);
		newData.push(...pickedData);
		const filteredData = UnfoldedPicker._getFilteredData(newData, filter, _criteria);
		this.setState({ data: newData, filteredData });
	}

	renderTitle() {
		const { title, max } = this.props;
		const { error, data: allData } = this.state;
		return <div className="-title">
			{title} (<span>{allData ? allData.length : 0}{max && `/${max}`}</span>)
			{error ? <i className={'-err color-red fa fa-sm fa-exclamation-circle'} /> : null}
		</div>;
	}

	_renderMoveBtn(cssSuffix, isMovable, fn) {
		return <div {...{
			key: cssSuffix,
			className: `btn fa fa-arrow-alt-${cssSuffix}${isMovable ? '' : ' disable'}`,
			...isMovable && { onClick: fn },
		}} />;
	}

	renderBody() {
		const { emptyWarning } = this.props;
		const { filteredData, _criteria, value } = this.state;
		const isMovable = value.length !== 0 && value.length !== filteredData.length && _.isEmpty(_criteria);
		return <div {...{
			className: '-body',
			style: { display: 'flex' },
		}}>
			<div style={{ flexGrow: 1, overflow: 'auto' }}>
				{_.isEmpty(filteredData) && !_.isEmpty(_criteria)
					? (!emptyWarning ? null
						: <div className={'-noticeWrapper'}>
							<div className={'-msg msg blue'}><i className={'fa fa-info-circle'} /> {emptyWarning}</div>
						</div>)
					: _.map(filteredData, (_data, idx) => this._renderItem(_data, idx))}
			</div>
			<div style={{ flexShrink: 0, flexBasis: '42px', margin: 'auto' }}>
				<div className={'-ctrl btn-group btn-group-white vertical btn-group-lg'}>
					{this._renderMoveBtn('to-top', isMovable, this._moveTop)}
					{this._renderMoveBtn('up', isMovable, this._moveUp)}
					{this._renderMoveBtn('down', isMovable, this._moveDown)}
					{this._renderMoveBtn('to-bottom', isMovable, this._moveBottom)}
				</div>
			</div>
		</div>;
	}
}

class OrderedTwoSidePicker extends TwoSidePicker {
	static defaultProps = {
		...TwoSidePicker.defaultProps,
		rightComponent: SortableUnfoldedPicker,
		valueSetter: (srcData, srcValue, dataProp) => {
			const data = [], valueData = [];
			if (_.isEmpty(srcData)) return [data, valueData];
			if (_.isNil(dataProp)) dataProp = ___getDataProp(srcData[0]);
			srcData = _.cloneDeep(srcData);
			const map = _.keyBy(srcData, dataProp);
			const validValue = [];
			_.each(srcValue, id => {
				const _data = map[id];
				if (!_data) return;
				validValue.push(_data[dataProp]);
				valueData.push(_data);
			});
			_.pull(srcData, ...valueData);
			return [srcData, valueData, validValue];
		},
	};

	getValue() {
		// TODO Picker-compatible
		const { enable, error, rightData } = this.state;
		if (!enable || error || _.isEmpty(rightData)) return undefined;
		return this._rightPicker.getSortedDataIds();
	}

	sortRightData(newRightData) {
		// TODO Picker-compatible
		const { dataProp } = this.state;
		const rightDataIds = this._rightPicker.getSortedDataIds();
		const movedDataMap = _.keyBy(newRightData, dataProp);
		const sortedRightData = _.transform(rightDataIds, (acc, id) => {
			const data = movedDataMap[id];
			if (!data) return;
			acc.push(data);
		}, []);
		sortedRightData.push(..._.pull(newRightData, ...sortedRightData));
		return sortedRightData;
	}

	/**
	 * @param {function} [cb]
	 */
	moveToRight(cb) {
		const { valueSetter } = this.props;
		const { data, rightData, dataProp } = this.state;
		const leftIds = this._leftPicker.getSelectedIds();
		let rightIds = _.map(rightData, dataProp);
		const moveIds = _.without(leftIds, ...rightIds);
		if (_.isEmpty(moveIds)) return;

		rightIds = [...rightIds, ...moveIds];
		const [remainsData, movedData] = valueSetter(data, rightIds, dataProp);
		this.setState({
			leftData: remainsData,
			rightData: this.sortRightData(movedData),
			error: false,
		}, () => {
			if (this.validate()) cb();
		});
	}

	/**
	 * @param {function} [cb]
	 */
	moveToLeft(cb) {
		const { valueSetter } = this.props;
		const { data, leftData, dataProp } = this.state;
		let leftIds = _.map(leftData, dataProp);
		const rightIds = this._rightPicker.getSelectedIds();
		const moveIds = _.without(rightIds, ...leftIds);
		if (_.isEmpty(moveIds)) return;

		leftIds = [...leftIds, ...moveIds];
		const [remainsData, movedData] = valueSetter(data, leftIds, dataProp);
		this.setState({
			leftData: movedData,
			rightData: this.sortRightData(remainsData),
			error: false,
		}, () => {
			if (this.validate()) cb();
		});
	}
}







class PickerSet extends ReactInputWithData{
	static version = '0.0.5';
	static propTypes = {
		... ReactInputWithData.props,
		min: PropTypes.number,
		max: PropTypes.number,
		singleAdder: PropTypes.bool,
		type: PropTypes.oneOf([
			'Picker', 'Select', 'Radio', 'ToggleButton', 'Checkbox',
			'OptionPicker',
		]),
		inputProps: PropTypes.object,
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		// maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		// minWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		combo: PropTypes.array,
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.string, PropTypes.object]),
		filter: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
		onInsert: PropTypes.func,
		onDelete: PropTypes.func,
		onUpdate: PropTypes.func,		// 注意! 與inputProps.onUpdate的差異!!!
	};
	static defaultProps = {
		... ReactInputWithData.defaultProps,
		min: 1,
		max: 5,
		singleAdder: true,
		type: 'Picker',
//		width: 200,
	};
	state = {
		... this.state,
		ids: [],
		values: {},
		min: 1,
		max: 5,
	};
	_inputs = {};

	constructor(props) {
		super(props);
		if(_.isNumber(this.props.min)) this.state.min = this.props.min;
		if(_.isNumber(this.props.max)) this.state.max = this.props.max;
		if (this.state.min < 0) this.state.min = 0;
		if (this.state.max < 0) this.state.max = 0;
		if (this.state.max > 0 && this.state.min > this.state.max){
			const temp = this.state.min;
			this.state.min = this.state.max;
			this.state.max = temp;
		}

		const {initValue, combo, type} = this.props;
		let initSize = (_.isArray(initValue) && initValue.length) || this.state.min;
		if(initSize < this.state.min) initSize = this.state.min;
		if(this.state.max > 0 && initSize > this.state.max) initSize = this.state.max;

		this.state.ids = _.times(initSize, () => nanoid());
		this._initSize = initSize;

		if(combo){
			const major = _.find(combo, {input: 'Picker'});
			if(!major) throw Error('[PickerSet] "major" item("input" = "Picker") is necessary if use "combo", ');
			this._majorId = major.id;
		}

		if(type === 'OptionPicker'){
			const {data, filter} = props;
			const raw = OPTIONS[data];
			if(!OPTIONS.hasOwnProperty(data) || !raw || raw.length == 0) return;

			let _data = _.transform(raw, (result, value, key) => result.push({
				id: _.isNaN(+key) ? key : +key,
				name: LocaleUtils.adapt(value),
			}), []);
			if(filter && _.isFunction(filter))
				this.state.data = _.filter(_data, filter);
			else if(filter && _.isArray(filter))
				this.state.data = _.filter(_data, d => _.includes(filter, d.id));
			else this.state.data = _data;
		}
	}

	static getDerivedStateFromProps(props, state) {
		let s = ReactInputWithData.getDerivedStateFromProps(props, state);
		if(!s) s = {};

		const {max, min} = props;
		const {_max, _min} = state;
		if(max !== _max) s._max = s.max = max;
		if(min !== _min) s._min = s.min = min;
		return s;
	}

	reset(){
		this._inputs = {};
		this.state.values = {};
		this.state.ids = _.times(this._initSize, () => {
			const uid = nanoid();
			this.state.values[uid] = undefined;
			return uid;
		});
		this.forceUpdate();
		return this;
	}
	validate(){
		const {_inputs} = this;
		const {combo} = this.props;
		let v = true;
		_.forEach(_inputs, input => {
			if(!input) return;
			if(combo)
				_.forEach(input, part => {
					if(!part) return;
					v = part.validate() && v;
				});
			else v = input.validate() && v;
		});
		return v;
	}

	getValue() {
		const {combo} = this.props;
		const {ids, values} = this.state;
		const value = combo ? _.map(ids, id => _.transform(this._inputs[id], (result, value, key) => {
			if(value && value.getValue){
				const v = value.getValue();
				if(!_.isNil(v) && ((_.isObject(v) && !_.isEmpty(v)) || !_.isObject(v))) result[key] = v;
			}
		}, {})) : _.reduce(_.values(values), (result, item, idx) => {
			if(item) result.push(item.length === 1 ? item[0] : item);
			return result;
		}, []);
		return _.isEmpty(value) ? undefined : value;
	}
	setValue(v, cb) {
		const {_max: max} = this;
		const {combo} = this.props;

		if (!_.isArray(v)) v = [v];
		if (max > 0 && v.length > max) v = v.slice(0, max);
		this._inputs = {};
		this.state.values = {};
		this.state.ids = _.times(_.max([this._initSize, v.length]), idx => {
			const uid = nanoid();
			this.state.values[uid] = v[idx] ? (combo ? v[idx][this._majorId] : v[idx]) : undefined;
			return uid;
		});
		this.forceUpdate(() => {
			if(combo){
				_.map(v, valueSet => {
					const id = _.findKey(this.state.values, x => x == valueSet[this._majorId]);
					if(id) _.forEach(valueSet, (_value, _key) =>
						_key == this._majorId ? null : this._inputs[id]?.[_key]?.setValue(_value));
				});
			}
			if(_.isFunction(cb)) cb();
		});
		return this;
	}

	render() {
		const {_inputs: inputs} = this;
		const {
			singleAdder, type, inputProps, combo,
			onInsert, onDelete, onUpdate, className, style, width,
		} = this.props;
		const {data, error, loading, enable, editable, min, max} = this.state;
		let {ids, values} = this.state;
		if(loading) return <Loading />;

		if(max > 0 && ids.length > 0 && max < ids.length){
			_.forEach(ids.slice(max), id => {
				delete values[id];
				delete inputs[id];
			});
			ids = ids.slice(0, max);
		}

		const _addItem = (injectIdx = 0, evt) => {
			if(injectIdx === 0) ids.push(nanoid());
			else ids.splice(injectIdx + 1, 0, nanoid());
			this.state.ids = ids;
			this.forceUpdate(() => {
				if(onInsert) onInsert(ids.length, this);
			});
		};
		const _removeItem = (id) => {
			if(!inputs.hasOwnProperty(id)) return;
			this.state.ids = _.pull(ids, id);
			delete this.state.values[id];
			this.forceUpdate(() => {
				delete inputs[id];
				if (onDelete) onDelete(ids.length, this);
			});
		};
		const exists = _.reduce(_.values(values), (result, item, i) => {
			return _.concat(result, item);
		}, []);
		const isFull = (max > 0 && ids.length >= max) || _.filter(data, d => !_.includes(exists, d.id)).length == 0;
		const Component = eval(type === 'OptionPicker' ? 'Picker' : type);
		const _genMajorInput = (id, data, value, majorId) => <span {... {
			key: majorId,
			className: '-part major',
			style: {
				... width ? {width} : combo ? {width: 'auto'} : null,
			}
		}}>
			<Component {... {
				ref: ele => {
					if(majorId){
						if(!inputs[id]) inputs[id] = {};
						inputs[id][majorId] = ele;
					}
					else inputs[id] = ele;
				},
				... inputProps,
				data,
				value,
				onUpdate: (v, pre) => {
					//if(_.isArray(v) && v.length == 1) v = v[0];
					this.state.values[id] = v;
					this.forceUpdate(() => {
						if(inputProps && inputProps.onUpdate) inputProps.onUpdate(v, pre);
						if(onUpdate) onUpdate(this.getValue());
					});
				},
				... !enable ? {disable: true} : null,
				... !editable ? {readOnly: true} : null,
			}} />
		</span>;
		const _renderCombo = (id, data, value) => {
			return _.map(combo, (part, i) => part.input !== 'Picker' ? <span {... {
				key: part.id || i,
				className: `-part`,
				style: {
					... part.width ? {width: part.width} : null,
					... part.hidden ? {display: 'none'} : null,
				},
			}}>
				{
					React.cloneElement(part.input, part.id ? {
						ref: ele => {
							if(!inputs[id]) inputs[id] = {};
							inputs[id][part.id] = ele;
						},
					} : null)
				}
			</span> : _genMajorInput(id, data, value, (part.id || i)));
		};

		return <div {... {
			className: `H2-PickerSet${error ? ' error' : ''}${className ? ` ${className}` : ''}`,
			... style,
		}}>
			{
				ids.map((id, idx) => {
					const exists = _.reduce(_.values(_.omit(values, id)), (result, item, i) => {
						return _.concat(result, item);
					}, []);
					const d = _.filter(data, d => !_.includes(exists, d.id));
					return d && d.length > 0 ? <div key={id} className={'-item'}>
						{ combo ? _renderCombo(id, d, values[id]) : _genMajorInput(id, d, values[id]) }
						{
							ids.length > min && enable && editable ? <span {... {
								style: {marginLeft: 3 },
								className: '-remover btn btn-danger btn-sm square fal fa-times',
								onClick: _removeItem.bind(this, id),
							}} /> : null
						}
						{
							!isFull && !singleAdder && enable && editable ? <span {... {
								className: 'btn btn-white btn-sm square fal fa-plus',
								onClick: _addItem.bind(this, idx),
							}}/> : null
						}
					</div> : null;
				})
			}
			{
				!isFull && (singleAdder || ids.length === 0) && enable && editable ? <span {... {
					className: 'btn btn-white btn-sm square fal fa-plus',
					onClick: _addItem.bind(this, 0),
				}}/> : null
			}
		</div>;
	}
}

/**
 * render prop 版的 PickerSet
 * <pre>
 * children 的 signature:
 * ({
 *    idx,            // 第幾row
 *    inputs,         // 這一次要來乘載 inputs 的 object。恆空。
 *    values,         // 永遠是 setValue 當時的值，不是最新值 (但因為 Picker 機制的關係，majorPicker 的值會是最新的值)。沒有 setValue 的話就會只有 majorPicker 的值。
 *    getPickerProps, // Picker 的 props 要透過這個 function 產生，會提供可用的 data
 *    ctrlBtns,       // -/+ 按鈕
 *    length,         // 總長度
 *    _this,          // 這個 PickerSet2 的 ref
 *    enable,
 *    editable,
 * }) => {}
 * </pre>
 * @see pb10820
 */
class PickerSet2 extends ReactInputWithData {
	static propTypes = {
		...ReactInputWithData.propTypes,
		majorId: PropTypes.string,
		data: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
		min: PropTypes.number,
		max: PropTypes.number,
		singleAdder: PropTypes.bool,
		customizedAdder: PropTypes.bool,
		customizedValidate: PropTypes.func,
		checkAllSelected: PropTypes.bool,
	};

	static defaultProps = {
		...ReactInputWithData.defaultProps,
		min: 1,
		max: Number.MAX_SAFE_INTEGER,
		singleAdder: true,
		customizedAdder: false,
		customizedEmptyAdder: false,
		adderClassName: 'btn-white fa-plus',
		removerClassName: 'btn-danger fa-times',
		checkAllSelected: true,		// 是否要檢查選項都被選了 (會影響到能不能加減項目)
		emptyPlus: false, //檢查是否為空值且僅顯示＋按鈕
	};
	state = {
		...this.state,
		ids: [],
		values: {},
		inputs: {},
	};

	constructor(props) {
		super(props);
		const { majorId, initValue } = props;
		this._majorId = _.isNil(majorId) ? nanoid() : majorId;

		if (!_.isEmpty(initValue)) {
			this._setValue(initValue);
		}
	}

	static getDerivedStateFromProps(props, state) {
		let s = ReactInputWithData.getDerivedStateFromProps(props, state);
		if (!s) s = {};

		// ReactInputWithData.getDerivedStateFromProps 只處理 array 跟 object 類型的 data
		// string 類型的要另外處理... =____=
		// 所以 class Select 會有切換 data string 無效的問題
		const { data } = props;
		if (_.isString(data)) {
			let { _preData } = state;
			if (!_.isEqual(data, _preData)) {
				const { filter, valueType } = props;
				s._preData = data;
				_stringToOptionData(data, filter, s, valueType);
			}
		}

		return s;
	}

	reset() {
		let [min] = this._getMinMax();
		this.state.inputs = {};
		this.state.values = {};
		this.state.ids = _.times(min, () => {
			const _uuid = nanoid();
			this.state.values[_uuid] = undefined;
			return _uuid;
		});
		this.forceUpdate();
		return this;
	}

	validate() {
		const { customizedValidate } = this.props;
		let v = true;
		// 每一組的每一個 input 都要做 validate, 不能遇到 invalid 的就不檢查剩下的
		_.forEach(this.state.inputs, inputs => {
			if (!inputs) return;
			_.forEach(inputs, input => {
				if (!input) return;
				v = input.validate() && v;
			});
		});
		if (_.isFunction(customizedValidate)) v = customizedValidate(this.state.inputs) && v;

		return v;
	}

	getValue() {
		const { majorId } = this.props;
		const { ids: uuids, inputs } = this.state;
		const value = _.map(uuids, uuid => {
			const result = _.transform(inputs[uuid], (result, input, key) => {
				if (input && input.getValue) {
					const v = input.getValue();
					if (!_.isNil(v) && ((_.isObject(v) && !_.isEmpty(v)) || !_.isObject(v))) result[key] = v;
				}
			}, {});
			return _.isNil(majorId) ? result[this._majorId] : result;
		});
		return _.isEmpty(value) ? undefined : value;
	}

	_setValue(rowValues) {
		const [min, max] = this._getMinMax();

		if (!_.isArray(rowValues)) rowValues = [rowValues];
		if (max > 0 && rowValues.length > max) rowValues = rowValues.slice(0, max);
		this.state.inputs = {};
		this.state.values = {};

		// "要" 換掉已經存在的 uuid!! 避免忽略 HOC 的 constructor
		const size = _.max([min, rowValues.length]);
		const uuids = this.state.ids = _.times(size, () => nanoid());

		uuids.forEach((uuid, idx) => {
			this.state.values[uuid] = rowValues[idx];
		});
	}

	setValue(rowValues, cb) {
		const { emptyPlus } = this.props;
		emptyPlus ? rowValues : this._setValue(rowValues);

		this.forceUpdate(() => {
			const { majorId } = this.props;
			const { ids: uuids, inputs } = this.state;
			_.each(rowValues, (rowValue, idx) => {
				const uuid = uuids[idx];
				const _inputs = inputs[uuid];
				if (_inputs) {
					if (_.isNil(majorId)) {
						_inputs[this._majorId] && _inputs[this._majorId].setValue(rowValue);
					} else {
						_.each(rowValue, (value, key) => {
							const input = _inputs[key];
							if (input) input.setValue(value);
						});
					}
				}
			});
			if (_.isFunction(cb)) cb();
		});
		return this;
	}

	appendItem() {
		const { disable, readOnly } = this.props;
		if (disable || readOnly) return;
		this._addItem(-1);
	}

	_addItem(injectIdx = -1, evt) {
		const { ids: uuids } = this.state;
		if (injectIdx === -1) uuids.push(nanoid());
		else uuids.splice(injectIdx + 1, 0, nanoid());
		this.forceUpdate(() => {
			const { onInsert } = this.props;
			if (onInsert) onInsert(uuids.length, this);
		});
	}

	_removeItem(uuid) {
		if (!this.state.inputs.hasOwnProperty(uuid)) return;
		const { ids: uuids } = this.state;
		_.pull(uuids, uuid);
		delete this.state.values[uuid];
		this.forceUpdate(() => {
			const { onDelete } = this.props;
			delete this.state.inputs[uuid];
			if (onDelete) onDelete(uuids.length, this);
		});
	}

	_getMinMax() {
		let { min, max } = this.props;
		min = _.isNumber(min) && min >= 0 ? +min : 1;
		max = _.isNumber(max) && max >= 1 ? +max : Number.MAX_SAFE_INTEGER;
		if (min > max) min = max;
		return [min, max];
	}

	renderCtrlBtns(uuid, idx, isFull) {
		const {
			singleAdder, customizedAdder,
			removerClassName, removerStyle, adderClassName, adderStyle,
			renderRemover, renderAdder, renderCtrlBtnsWrapper,
		} = this.props;
		const { ids: uuids } = this.state;
		const [min] = this._getMinMax();

		const delBtn = uuids.length <= min ? null
			: _.isFunction(renderRemover) ? renderRemover({
				className: `btn fal ${removerClassName ? removerClassName : ''}`,
				...removerStyle ? { style: removerStyle } : null,
				onClick: this._removeItem.bind(this, uuid),
			}) : <span {...{
				className: `btn fal ${removerClassName ? removerClassName : ''}`,
				...removerStyle ? { style: removerStyle } : null,
				onClick: this._removeItem.bind(this, uuid),
			}} />;
		const addBtn = isFull || (singleAdder && (customizedAdder || (idx + 1) < uuids.length)) ? null
			: _.isFunction(renderAdder) ? renderAdder({
				className: `btn fal ${adderClassName ? adderClassName : ''}`,
				...adderStyle ? { style: adderStyle } : null,
				onClick: this._addItem.bind(this, idx),
			}) : <span {...{
				className: `btn fal ${adderClassName ? adderClassName : ''}`,
				...adderStyle ? { style: adderStyle } : null,
				onClick: this._addItem.bind(this, idx),
			}} />;

		if (_.isFunction(renderCtrlBtnsWrapper)) return renderCtrlBtnsWrapper(addBtn, delBtn);
		return (
			<div className="btn-group btn-group-sm square">
				{delBtn}
				{addBtn}
			</div>
		);
	}

	render() {
		if (this.state.loading) return <Loading />;
		if (_.isEmpty(this.state.data)) return <div className={'color-red'}>
			<i className={'fa fa-fw fa-exclamation-circle'} />無資料
		</div>;

		const {
			children, customizedEmptyAdder,
			adderClassName, adderStyle, checkAllSelected,
		} = this.props;
		const { data, inputs, values, ids: uuids, enable, editable } = this.state;

		const [min, max] = this._getMinMax();
		// 這邊還是動了 uuids 了，感覺不是很好。(下面還可能再動一次)
		// 可是放回 getDerivedStateFromProps 又要把 inputs 跟 values 綁進 state 裡 ...
		if (0 <= max && max < uuids.length) {
			uuids.splice(max, uuids.length - max).forEach(uuid => {
				// TODO 這邊因為少了 forceUpdate，可能會有值殘留的問題
				// TODO 要參考下面一點的 shouldUpdate，或改回 getDerivedStateFromProps...
				delete inputs[uuid];
				delete values[uuid];
			});
		}
		if (0 <= min && uuids.length < min) {
			uuids.push(..._.times(min - uuids.length, () => nanoid()));
		}

		// 如果直接是滿的話就不用畫加/減按鈕了
		const exists = _.reduce(_.values(values), (result, item, i) => {
			// 當 Picker 可多選時，item 會是 array，所以用 concat 接起來
			return _.isNil(item) ? result : _.concat(result, item[this._majorId]);
		}, []);

		const noAvailable = checkAllSelected ? _.filter(data, d => !_.includes(exists, d.id)).length === 0 : false;
		// 只有選項已被用盡時才需要縮減
		if (noAvailable) {
			// 檢查 exists 是不是都還在 data 裡面
			// 都不在的，或是原本就是空的都要移除
			let shouldUpdate = false;
			for (let i = uuids.length - 1; i >= 0; i--) {
				const uuid = uuids[i];
				let ids = values[uuid][this._majorId];
				if (!_.isArray(ids)) ids = [ids];
				const inUsed = _.intersectionWith(data, ids, (d, id) => d.id == id);
				if (_.isEmpty(inUsed)) {
					delete inputs[uuid];
					delete values[uuid];
					uuids.splice(i, 1);
					shouldUpdate = true;
				}
			}
			if (shouldUpdate) this.forceUpdate();
		}
		const isFull = noAvailable || (uuids.length >= max);
		const isEmpty = uuids.length === 0;

		const _renderItems = () => uuids.map((uuid, idx) => {
			// 每畫一個就要重新準備可用的 data
			// 蒐集別人用掉的 data
			const exists = _.reduce(_.values(_.omit(values, uuid)), (result, item, i) => {
				return _.isNil(item) ? result : _.concat(result, item[this._majorId]);
			}, []);
			// 挑出剩下可用的 data
			const available = checkAllSelected ? _.filter(data, d => !_.includes(exists, d.id)) : data;
			if (!available || available.length === 0) return null;

			const ctrlBtns = !(enable && editable) ? null
				: this.renderCtrlBtns(uuid, idx, isFull);

			const _inputs = inputs[uuid] = {};
			const _values = values[uuid] || (values[uuid] = {});

			const getPickerProps = ({ onUpdate, ...otherProps }) => {
				//如果有dataFilter必須也過濾
				const availableFix = otherProps.dataFilter ? available.filter(otherProps.dataFilter) : available;
				return {
					...otherProps,
					// 因為 data 改變導致值被清空 (data 內部的 selected flag)，所以得要重設選擇的值
					..._values[this._majorId] ? { value: _values[this._majorId] } : null,
					ref: ele => _inputs[this._majorId] = ele,
					data: otherProps?.dataFilterClose ? data : availableFix, // 改變 data 會導致值被清空，如果有dataFilterClose參數則維持原來的data
					onUpdate: (value) => {
						// 更新選單時，要記下現在的值，在重畫後才有辦法 set 回去 (因為 data 改變導致值被清空)
						// 這裡刻意要產生新的reference, 所以用展開
						const preValue = this.state.values[uuid] && this.state.values[uuid][this._majorId];
						this.state.values[uuid] = { ...this.state.values[uuid], [this._majorId]: value };
						this.forceUpdate(() => {
							if (_.isFunction(onUpdate))
								onUpdate(value, preValue, this);
						});
					},
				};
			};

			return <React.Fragment key={uuid}>
				{children({
					idx,
					inputs: _inputs, // 這一次要來乘載 inputs 的 object。恆空。
					values: _values, // 永遠是 setValue 當時的值，不是最新值 (但因為 Picker 機制的關係，majorPicker 的值會是最新的值)。沒有 setValue 的話就會只有 majorPicker 的值。
					getPickerProps,
					ctrlBtns,
					length: uuids.length,
					_this: this,
					enable, editable,
				})}
			</React.Fragment>;
		});

		return <>
			{_renderItems()}
			{!customizedEmptyAdder && enable && editable && isEmpty ? <span {...{
				className: `btn btn-sm fal ${adderClassName ? adderClassName : ''}`,
				... adderStyle ? {style: adderStyle} : null,
				onClick: this._addItem.bind(this, -1),
			}} /> : null}
		</>;
	}
}

class PickerSet3 extends PickerSet2 {
	render() {
		if (this.state.loading) return <Loading />;
		if (_.isEmpty(this.state.data)) return <div className={'color-red'}>
			<i className={'fa fa-fw fa-exclamation-circle'} />無資料
		</div>;

		const {
			majorId, children, singleAdder, customizedAdder, customizedEmptyAdder,
			removerClassName, removerStyle, adderClassName, adderStyle, checkAllSelected,
		} = this.props;
		const { data, inputs, values, ids: uuids, enable, editable } = this.state;

		const [min, max] = this._getMinMax();
		// 這邊還是動了 uuids 了，感覺不是很好。(下面還可能再動一次)
		// 可是放回 getDerivedStateFromProps 又要把 inputs 跟 values 綁進 state 裡 ...
		if (0 <= max && max < uuids.length) {
			uuids.splice(max, uuids.length - max).forEach(uuid => {
				// TODO 這邊因為少了 forceUpdate，可能會有值殘留的問題
				// TODO 要參考下面一點的 shouldUpdate，或改回 getDerivedStateFromProps...
				delete inputs[uuid];
				delete values[uuid];
			});
		}
		if (0 <= min && uuids.length < min) {
			uuids.push(..._.times(min - uuids.length, () => uuid()));
		}

		// 如果直接是滿的話就不用畫加/減按鈕了
		const exists = _.reduce(_.values(values), (result, item, i) => {
			// 當 Picker 可多選時，item 會是 array，所以用 concat 接起來
			return _.isNil(item) ? result : _.concat(result, item[this._majorId]);
		}, []);

		const noAvailable = checkAllSelected ? _.filter(data, d => !_.includes(exists, d.id)).length === 0 : false;
		// 只有選項已被用盡時才需要縮減
		if (noAvailable) {
			// 檢查 exists 是不是都還在 data 裡面
			// 都不在的，或是原本就是空的都要移除
			let shouldUpdate = false;
			for (let i = uuids.length - 1; i >= 0; i--) {
				const uuid = uuids[i];
				let ids = values[uuid][this._majorId];
				if (!_.isArray(ids)) ids = [ids];
				const inUsed = _.intersectionWith(data, ids, (d, id) => d.id == id);
				if (_.isEmpty(inUsed)) {
					delete inputs[uuid];
					delete values[uuid];
					uuids.splice(i, 1);
					shouldUpdate = true;
				}
			}
			if (shouldUpdate) this.forceUpdate();
		}
		const isFull = noAvailable || (uuids.length >= max);
		const isEmpty = uuids.length === 0;

		const _renderItems = () => uuids.map((uuid, idx) => {
			// 每畫一個就要重新準備可用的 data
			// 蒐集別人用掉的 data
			const exists = _.reduce(_.values(_.omit(values, uuid)), (result, item, i) => {
				return _.isNil(item) ? result : _.concat(result, item[this._majorId]);
			}, []);
			// 挑出剩下可用的 data
			const available = checkAllSelected ? _.filter(data, d => !_.includes(exists, d.id)) : data;
			if (!available || available.length === 0) return null;

			const ctrlBtns = !(enable && editable) ? null
				: <div className="btn-group btn-group-sm square">
					{uuids.length <= min ? null
						: <RemoveBtn {...{
							removerClassName,
							onClick: this._removeItem.bind(this, uuid),
							style: {
								marginLeft: 8,
								fontSize: 24,
								...removerStyle,
							}
						}} />}
					{isFull || (singleAdder && (customizedAdder || (idx + 1) < uuids.length)) ? null
						: <AddBtn {...{
							adderClassName,
							onClick: this._addItem.bind(this, idx),
							style: {
								marginLeft: 8,
								fontSize: 24,
								...adderStyle,
							}
						}} />
					}</div>;

			const _inputs = inputs[uuid] = {};
			const _values = values[uuid] || (values[uuid] = {});

			const getPickerProps = ({ onUpdate, ...otherProps }) => {
				//如果有dataFilter必須也過濾
				const availableFix = otherProps.dataFilter ? available.filter(otherProps.dataFilter) : available;
				return {
					...otherProps,
					// 因為 data 改變導致值被清空 (data 內部的 selected flag)，所以得要重設選擇的值
					..._values[this._majorId] ? { value: _values[this._majorId] } : null,
					ref: ele => _inputs[this._majorId] = ele,
					data: otherProps?.dataFilterClose ? data : availableFix, // 改變 data 會導致值被清空，如果有dataFilterClose參數則維持原來的data
					onUpdate: (value) => {
						// 更新選單時，要記下現在的值，在重畫後才有辦法 set 回去 (因為 data 改變導致值被清空)
						// 這裡刻意要產生新的reference, 所以用展開
						const preValue = this.state.values[uuid] && this.state.values[uuid][this._majorId];
						this.state.values[uuid] = { ...this.state.values[uuid], [this._majorId]: value };
						this.forceUpdate(() => {
							if (_.isFunction(onUpdate))
								onUpdate(value, preValue, this);
						});
					},
				};
			};

			return <React.Fragment key={uuid}>
				{children({
					idx,
					inputs: _inputs, // 這一次要來乘載 inputs 的 object。恆空。
					values: _values, // 永遠是 setValue 當時的值，不是最新值 (但因為 Picker 機制的關係，majorPicker 的值會是最新的值)。沒有 setValue 的話就會只有 majorPicker 的值。
					getPickerProps,
					ctrlBtns,
					length: uuids.length,
					_this: this,
					enable, editable,
				})}
			</React.Fragment>;
		});

		return <>
			{_renderItems()}
			{!customizedEmptyAdder && enable && editable && isEmpty ? <AddBtn {...{
				adderClassName,
				adderStyle,
				onClick: this._addItem.bind(this, -1),
				style: {
					fontSize: 24,
					height: 24
				}
			}} /> : null}
		</>;
	}
}

const _Icon = ({ style, ...props }) => {
	return <span style={{ paddingTop: 6, display: 'inline-block', cursor: 'pointer', position: 'relative', top: 5 }}>
		<Icon className='H2-IconButton -interact' style={{ ...style }} {...props} />
	</span>
}
// TODO: extends ReactInput
class MultipleInput extends React.PureComponent {
	static version = '0.0.1';
	static propTypes = {
		min: PropTypes.number,
		max: PropTypes.number,
		input: PropTypes.element,
		width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
		combo: PropTypes.array,
		initValue: PropTypes.array,
		readOnly: PropTypes.bool,
		tipMarkup: PropTypes.func,
		placeholderMarkup: PropTypes.func,
		addInMiddle: PropTypes.bool,
		keepMaxSizeWhenSetValue: PropTypes.bool,
	};
	static defaultProps = {
		min: 1,
		max: 5,
		width: 396,
		initValue: [],
		addInMiddle: false,
		keepMaxSizeWhenSetValue: false,
	};
	state = {
		ids: [],
		editable: true,
	};
	inputs = {};

	constructor(props) {
		super(props);
		this._min = this.props.min;
		this._max = this.props.max;
		if (this._min < 0) this._min = 0;
		if (this._max < 0) this._max = -1;
		if (this._max > 0 && this._min > this._max) this._min = this._max;

		let initSize = this.props.initValue.length || this._min;
		if (initSize < this._min) {
			initSize = this._min;
		} else if (this._max !== -1 && initSize > this._max) {
			initSize = this._max;
		}

		this.state.ids = _.times(initSize, () => nanoid());
		this.state.editable = !props.readOnly;
	}

	componentDidMount() {
		if (this.props.initValue.length !== 0) {
			this.setValue(this.props.initValue);
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (this.props.combo)
			_.keys(this.inputs).map(key => _.isEmpty(_.pickBy(this.inputs[key], _.identity)) ? this.inputs[key] = null : null);
		this.inputs = _.pickBy(this.inputs, _.identity);
	}

	reset() {
		_.every(this.inputs, input => input.reset && input.reset());
		return this;
	}

	removeAll(callback) {
		const ids = this.state.ids;
		if (ids && ids.length > this._min) {
			this.setState({ ids: ids.slice(0, this._min) }, () => {
				let idx = 0;
				for(let id of ids) {
					if (idx >= this._min)
						delete this.inputs[id];
					idx++;
				}

				if(callback) callback();
			});
		}
	}

	validate() {
		let v = true;
		_.forEach(this.inputs, input => {
			//這裡的input是第一層Multiple ele
			if (!input) return;
			if (this.props.combo) {
				_.forEach(input, i2 => {
					//需要第二層，才可以拿到multiple 內的 input進行validate處理
					if (!i2) return;
					v = i2.validate() && v;
				});
			} else v = input.validate() && v;
		});
		return v;
	}

	isEnable() { return true; }

	enable() {
		_.forEach(this.inputs, (input, code) => { if (input && input.enable) input.enable(); });
		return this;
	}

	disable() {
		_.forEach(this.inputs, (input, code) => { if (input && input.disable) input.disable(); });
		return this;
	}

	isEditable() { return this.state.editable; }

	editable() {
		_.forEach(this.inputs, (input, code) => { if (input && input.editable) input.editable(); });
		this.setState({ editable: true });
		return this;
	}

	readOnly() {
		_.forEach(this.inputs, (input, code) => { if (input && input.readOnly) input.readOnly(); });
		this.setState({ editable: false });
		return this;
	}

	getValue() {
		const { ids } = this.state;
		let values = _.map(ids, id => {
			const input = this.inputs[id];
			return input.getValue ? input.getValue() : _.transform(input, (result, value, key) => result[key] = value.getValue());
		});
		return values;
	}

	setValue(v, fireEvent = true) {
		if (!_.isArray(v)) v = [v];
		if (this._max > 0 && v.length > this._max) v = v.slice(0, this._max);
		const ids = [...this.state.ids];
		const _setValue = () => _.values(this.inputs).map((input, i) => input.setValue ?
			input.setValue(v[i], fireEvent) :
			_.forEach(v[i], (value, id) => {
				if (input.hasOwnProperty(id)) input[id].setValue(value, fireEvent);
			}),
		);
		if (ids.length < v.length) {
			_.times(v.length - ids.length, i => ids.push(nanoid()));
			this.setState({ ids: [...ids] }, _setValue);
		} else if (!this.props.keepMaxSizeWhenSetValue && ids.length > v.length) {
			this.setState({ ids: ids.slice(0, v.length) }, _setValue);
		}
		else _setValue();
		return this;
	}

	render() {
		const { _max: max, _min: min } = this;
		let inputs = this.inputs;
		const {
			input, width, minWidth, tip, tipMarkup, placeholderMarkup, maxWidth, combo, addInMiddle,
			onInsert, onDelete, onUpdate, className,
		} = this.props;
		const { editable } = this.state;
		const ids = [...this.state.ids];

		const _addItem = (injectIdx = 0) => {
			if (!editable) return;
			if (max < 0 || ids.length < max) {
				if (!addInMiddle)
					ids.push(nanoid());
				else
					ids.splice(injectIdx + 1, 0, nanoid());
				this.setState({ ids: ids },() => {
					if (onInsert) onInsert();
					if (onUpdate) onUpdate();
				});
			}
		};
		const _removeItem = (id) => {
			if (!editable) return;
			if (!inputs.hasOwnProperty(id)) return;
			this.setState({ ids: _.pull(ids, id) }, () => {
				delete inputs[id];
				if (onDelete) onDelete();
				if (onUpdate) onUpdate();
			});
		};
		const _renderSingle = () => {
			const notFull = (max < 0 || ids.length < max);
			const _cloneElement = (id, idx) => React.cloneElement(input, {
				ref: ele => this.inputs[id] = ele,
				... minWidth ? {minWidth} : null,
				... maxWidth ? {maxWidth} : null,
				... tip ? {tip: tipMarkup ? tipMarkup(tip, idx) : tip } : null,
				... input.props.placeholder ? {
					placeholder: placeholderMarkup ? placeholderMarkup(input.props.placeholder, idx) : input.props.placeholder
				} : null,
			});
			return <>
				{
					ids.map((id, idx) => <div
						key={id}
						className={classnames('H2-MultiInputRow', {
							disable: !editable,
						})}
						{...{
							... width ? {className: classnames('H2-MultiInputRow inlineFlex', {
								disable: !editable,
							})} : null,
							... width ? {style: {width}} : null,
						}}
					>
						{/*{*/}
						{/*	!width ? _cloneElement(id, idx) :*/}
						{/*		<span className={'inlineBlock'} style={{width}}>{_cloneElement(id, idx)}</span>*/}
						{/*}*/}
						{_cloneElement(id, idx)}
						{ids.length > min ?
							<div style={{ 'paddingLeft': '5px', 'alignItems': 'center' }}>
								<_Icon icon={CancelIcon} onClick={_removeItem.bind(this, id)} />
							</div> : null
						}
						{notFull && addInMiddle ?
							<div className={'inlineFlex'} style={{ 'paddingLeft': '10px', 'verticalAlign': 'top', 'float': 'right' }}>
								<_Icon icon={AddIcon} onClick={_addItem.bind(this, idx)} />
							</div>
						: null}
					</div>)
				}
				{notFull && (!addInMiddle || ids.length === 0) ?
					<div
						className={classnames('H2-MultiInputRow inlineFlex', {
							disable: !editable,
						})}
						style={{ 'paddingLeft': '10px', 'verticalAlign': 'top', 'float': 'right' }}
					>
						<_Icon icon={AddIcon} onClick={_addItem} />
					</div> : null}
			</>;
		};

		const _renderCombo = () => {
			const notFull = (max < 0 || ids.length < max);
			return <div className={`H2-MultiInput ${className ? className : ''}`}>
				{
					ids.map((id, idx) => <div key={id} className={'-set'}>
						{
							combo.map((item, i) => <span {... {
								key: item.id || i,
								className: '-item',
								style: {
									width: item.width ? item.width : null,
									display: item.hidden ? 'none' : null
								}
							}}>{
								React.cloneElement(item.input, item.id ? {
									ref: ele => {
										if (!this.inputs[id]) this.inputs[id] = {};
										this.inputs[id][item.id] = ele;
									},
								} : null)
							}</span>)
						}
						{ids.length > min ?
							<_Icon icon={CancelIcon} onClick={_removeItem.bind(this, id)} />
						: null}
						{notFull && addInMiddle ?
							<_Icon icon={AddIcon} onClick={_addItem.bind(this, idx)} />
						: null}
					</div>)
				}
				{notFull && (!addInMiddle || ids.length === 0) ?
					<_Icon icon={AddIcon} onClick={_addItem} />
				: null}
			</div>;
		};
		return input ? _renderSingle() : combo ? _renderCombo() : null;
	}
}

/**
 * <p>render prop 版的 MultipleInput</p>
 * <p>children signature:</p>
 * <code>
 * ({idx, inputs, values, ctrlBtns, length, _this}) => element
 * </code>
 * <ul>
 * <li>idx: 第幾項 (0-base)</li>
 * <li>inputs: 這一次要來乘載 inputs 的 object。恆空。</li>
 * <li>values: setValue 當時的值，不是最新值。沒有 setValue 的話就會是空的</li>
 * <li>ctrlBtns: +/- 的 React element</li>
 * <li>length: 總共項目的數量</li>
 * <li>_this: MultipleInput2 本身的 reference</li>
 * <li>回傳值: react element</li>
 * </ul>
 */
class MultipleInput2 extends ReactInput {
	static version = '0.0.1';
	static propTypes = {
		...ReactInput.propTypes,
		min: PropTypes.number,
		max: PropTypes.number,
		singleAdder: PropTypes.bool,
		customizedAdder: PropTypes.bool,
		customizedValidate: PropTypes.func,
	};
	static defaultProps = {
		...ReactInput.defaultProps,
		min: 1,
		max: Number.MAX_SAFE_INTEGER,
		singleAdder: false,
		customizedAdder: false,
		customizedEmptyAdder: false,
		adderClassName: 'btn-white fa-plus',
		removerClassName: 'btn-danger fa-times',
	};

	state = {
		...this.state,
		uuids: [],
	};

	inputs = {};
	values = {};

	constructor(props) {
		super(props);

		const { value, initValue } = props;
		// testing..., nil or empty?
		if (!_.isEmpty(value)) this._setValue(value);
		else if (!_.isEmpty(initValue)) this._setValue(initValue);
	}

	static getDerivedStateFromProps(props, state) {
		const s = ReactInput.getDerivedStateFromProps(props, state);
		// for debug
		return s;
	}

	reset() {
		let [min] = this._getMinMax();
		this.inputs = {};
		this.values = {};
		this.state.uuids = _.times(min, () => {
			const _uuid = nanoid();
			this.values[_uuid] = undefined;
			return _uuid;
		});
		this.forceUpdate();
		return this;
	}

	validate() {
		const { customizedValidate } = this.props;
		let v = true;
		// 每一組的每一個 input 都要做 validate, 不能遇到 invalid 的就不檢查剩下的
		_.forEach(this.inputs, inputs => {
			if (!inputs) return;
			_.forEach(inputs, input => {
				if (!input) return;
				v = input.validate() && v;
			});
		});
		if (_.isFunction(customizedValidate)) v = customizedValidate(this.inputs, this.getValue()) && v;

		return v;
	}

	getValue() {
		const { uuids } = this.state;
		return _.compact(_.map(uuids, uuid => {
			const v = _.transform(this.inputs[uuid], (result, input, key) => {
				if (input && input.getValue) {
					const v = input.getValue();
					if (!_.isNil(v) && ((_.isObject(v) && !_.isEmpty(v)) || !_.isObject(v))) result[key] = v;
				}
				return result;
			}, {});
			if(!_.isEmpty(v)) return v;
		}));
	}

	_setValue(rowValues) {
		const [min, max] = this._getMinMax();

		if (!_.isArray(rowValues)) rowValues = [rowValues];
		if (max > 0 && rowValues.length > max) rowValues = rowValues.slice(0, max);
		this.inputs = {};
		this.values = {};

		// "要" 換掉已經存在的 uuid!! 避免忽略 HOC 的 constructor
		const size = _.max([min, rowValues.length]);
		const uuids = this.state.uuids = _.times(size, () => nanoid());

		uuids.forEach((uuid, idx) => {
			this.values[uuid] = rowValues[idx];
		});
	}

	setValue(rowValues, cb) {
		this._setValue(rowValues);

		this.forceUpdate(() => {
			const { uuids } = this.state;
			_.each(rowValues, (rowValue, idx) => {
				const uuid = uuids[idx];
				const _inputs = this.inputs[uuid];
				if (_inputs) {
					_.each(rowValue, (value, key) => {
						const input = _inputs[key];
						if (input) input.setValue(value);
					});
				}
			});
			if (_.isFunction(cb)) cb();
		});
		return this;
	}

	appendItem() {
		const { disable, readOnly } = this.props;
		if (disable || readOnly) return;
		this._addItem(-1);
	}

	_addItem(injectIdx = -1, evt) {
		const { uuids } = this.state;
		if (injectIdx === -1) uuids.push(nanoid());
		else uuids.splice(injectIdx + 1, 0, nanoid());
		this.forceUpdate(() => {
			const { onInsert } = this.props;
			if (onInsert) onInsert(uuids.length, this);
		});
	}

	_removeItem(uuid, idx) {
		if (!this.inputs.hasOwnProperty(uuid)) return;

		const preValue = this.getValue();
		const {uuids} = this.state;
		_.pull(uuids, uuid);
		delete this.values[uuid];
		this.forceUpdate(() => {
			const {onDelete, onUpdate, onDeleteIdx} = this.props;
			delete this.inputs[uuid];
			const value = this.getValue();
			if(_.isFunction(onUpdate) && !_.isEqual(value, preValue)) onUpdate(value);
			if(_.isFunction(onDelete)) onDelete(uuids.length, this);
			_.isFunction(onDeleteIdx) ? onDeleteIdx(idx) : null;
		});
	}

	_getMinMax() {
		let { min, max } = this.props;
		min = _.isNumber(min) && min >= 0 ? +min : 1;
		max = _.isNumber(max) && max >= 1 ? +max : Number.MAX_SAFE_INTEGER;
		if (min > max) min = max;
		return [min, max];
	}

	renderCtrlBtns(uuid, idx, isFull) {
		const {
			children, singleAdder, customizedAdder, customizedEmptyAdder, onUpdate,
			removerClassName, removerStyle, adderClassName, adderStyle, singleAdderStyle,
		} = this.props;
		const {uuids, enable, editable} = this.state;
		const [min, max] = this._getMinMax();

		return <div className='btn-group btn-group-sm square'>
			{uuids.length <= min ? null
				: <span {...{
					className: `btn fal ${removerClassName ? removerClassName : ''}`,
					...removerStyle ? { style: removerStyle } : null,
					onClick: this._removeItem.bind(this, uuid, idx),
				}} />}
			{isFull || (singleAdder && (customizedAdder || (idx + 1) < uuids.length)) ? null
				: <span {...{
					className: `btn fal ${adderClassName ? adderClassName : ''}`,
					... adderStyle ? { style: adderStyle } : null,
					onClick: this._addItem.bind(this, idx),
				}} />
			}
		</div>
	}

	render() {
		const {
			children, singleAdder, customizedAdder, customizedEmptyAdder, onUpdate,
			removerClassName, removerStyle, adderClassName, adderStyle, singleAdderStyle,
			initValue,
		} = this.props;
		const {uuids, enable, editable} = this.state;

		const [min, max] = this._getMinMax();
		// 這邊還是動了 uuids 了，感覺不是很好。
		// 可是放回 getDerivedStateFromProps 又要把 inputs 跟 values 綁進 state 裡 ...
		if (0 <= max && max < uuids.length) {
			uuids.splice(max, uuids.length - max).forEach(uuid => {
				delete this.inputs[uuid];
				delete this.values[uuid];
			});
		}
		if (0 <= min && uuids.length < min) {
			uuids.push(..._.times(min - uuids.length, () => nanoid()));
		}

		const isFull = uuids.length >= max, isEmpty = uuids.length === 0;
		const _renderItems = () => uuids.map((uuid, idx) => {
			const ctrlBtns = !(enable && editable) ? null
				: this.renderCtrlBtns(uuid, idx, isFull);
			const _inputs = this.inputs[uuid] = {};
			const _values = this.values[uuid] || (this.values[uuid] = {});
			return React.cloneElement(children({
				idx,
				inputs: _inputs, // 這一次要來乘載 inputs 的 object。恆空。
				values: _values, // 永遠是 setValue 當時的值，不是最新值。沒有 setValue 的話就會是空的。
				ctrlBtns,
				length: uuids.length,
				_this: this,
				enable, editable,
				... initValue ? {initValue: initValue[idx]} : null,
			}), {key: uuid});
		});
		return <>
			{_renderItems()}
			{!customizedEmptyAdder && enable && editable && isEmpty ? <span {...{
				className: `btn btn-sm square fal ${adderClassName ? adderClassName : ''}`,
				... singleAdderStyle ? {style: singleAdderStyle} : null,
				onClick: this._addItem.bind(this, -1),
			}} /> : null}
		</>;
	}
}

// 只修改 renderCtrlBtns 樣式
class MultipleInput3 extends MultipleInput2 {
	renderCtrlBtns(uuid, idx, isFull) {
		const {
			children, singleAdder, customizedAdder, customizedEmptyAdder, onUpdate,
			removerClassName, removerStyle, adderClassName, adderStyle, singleAdderStyle,
		} = this.props;
		const {uuids, enable, editable} = this.state;
		const [min, max] = this._getMinMax();

		return (
			<div className="btn-group btn-group-sm square">
					{uuids.length <= min ? null
						: <RemoveBtn {...{
							removerClassName,

							onClick: this._removeItem.bind(this, uuid),
							style: {
								marginLeft: 8,
								fontSize: 24,
								...removerStyle,
							}
						}} />}
					{isFull || (singleAdder && (customizedAdder || (idx + 1) < uuids.length)) ? null
						: <AddBtn {...{
							adderClassName,
							onClick: this._addItem.bind(this, idx),
							style: {
								marginLeft: 8,
								fontSize: 24,
								...adderStyle,
							}
						}} />
					}</div>
		)
	}
}


// TODO:
class Ranger extends MultipleInput {
	static version = '0.0.2';
	static defaultProps = {
		...MultipleInput.defaultProps,
		min: 2,
		max: 2,
		width: 'calc(50% - 0px)',
		placeholderMarkup: (ph, idx) => {
			return `${ph}(${idx == 0 ? '起' : '訖'})`;
		},
		tipMarkup: (tip, idx) => {
			return `${tip} (${idx == 0 ? '起' : '訖'})`;
		},
	};

	constructor(props) {
		if (props.min !== 2 || props.max !== 2) throw new Error('RageInput must has 2 and only 2 input fields!');
		super(props);
	}

	getValue() {
		const v = super.getValue();
		return (v[0] && v[1] && v[1] < v[0]) ? [v[1], v[0]] : (v[0] || v[1]) ? v : undefined;
	}

	render() {
		return <div className="H2-Ranger">{super.render()}</div>;
	}
}

export {
	MobileContext,
	ReactInput, ReactInputWithData,
	Text, TextRange, TWIDText, AlienIDText, Password, TextPassword, RNumber, NumberRange,
	RDate, DateRange, YearMonth,
	Time, TimeRange,
	ComboTime, ComboTimeRange,
	DateTime, DateTimeRange,
	Picker, Switch, Select, Radio, ToggleButton, Checkbox,
	PickerWrapper, DataLoader, SubDataLoader, NewSubDataLoader,
	OptionPicker,
	TreePicker, DepPicker, PostcodePicker, CategoryPicker,
	Cate1Picker, Cate2Picker, Cate3Picker, Cate4Picker, Cate5Picker, Cate6Picker, Cate7Picker,
	Cate8Picker, Cate9Picker, Cate11Picker, Cate12Picker, Cate77Picker,
	UnfoldedPicker, TwoSidePicker, OrderedTwoSidePicker,
	PickerSet, PickerSet2, PickerSet3, I18nText, MultipleInput, Ranger,
	MultipleInput2, MultipleInput3
};
